var _defineProperty = require("/home/ubuntu/workspace/bom-ui-preprod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _pes, _liveVitalStats, _offline;

var mobile = {
  "nav": {
    "today": "Stato",
    "history": "Energia",
    "layout": "Matrice",
    "menu": "Menù"
  },
  "button": {
    "cancel": "Annulla",
    "done": "Fine",
    "login": "Accedi",
    "today": "Oggi",
    "submit": "Inoltra",
    "ok": "Va bene",
    "choose_file": "Scegli il file",
    "refresh": "Aggiorna",
    "send": "Spedire",
    "skip": "Salta",
    "clickHere": "Cliccare qui",
    "confirm": "Conferma",
    "reset": "Ripristina",
    "edit": "Modifica",
    "update": "Aggiorna",
    "next": "Avanti",
    "save": "Salva",
    "no": "No",
    "yes": "Sì",
    "enable": "Abilita",
    "setNow": "Imposta ora",
    "gotIt": "Ho capito",
    "okGotIt": "Ok, capito",
    "continue": "Continua",
    "knowMore": "Per saperne di più",
    "noExportCredit": "Non ottengo credito dall'esportazione",
    "tryLater": "Prova dopo",
    "otherNetworks": "Altre reti"
  },
  "form": {
    "topic": "Tema",
    "contactSupport": {
      "success": {
        "message": "Grazie per averci contattato.",
        "description": "Siamo felici di aiutarti a risolvere il tuo problema. Un esperto di Enphase ti contatterà a breve.",
        "email_notify": "Il rapporto verrà inviato a breve a %{email}."
      },
      "error": {
        "message": "Impossibile inviare il messaggio.",
        "description": "Per favore, riprova.",
        "reset_password": "Password scaduta. Ripristinare la password."
      }
    },
    "default": {
      "success": "Salvato con successo",
      "error": "Riprovare",
      "pleaseEnterAValue": "Per favore inserisci un valore",
      "permissionDenied": "Permesso negato",
      "activeBatteryProfile": "Hai una richiesta profilo batteria attiva. Attendi la conferma o annulla la richiesta per procedere."
    },
    "search": "Cerca"
  },
  "common": {
    "please": "",
    "contactSupport": "Contatta l'assistenza",
    "forHelp": "per ricevere aiuto.",
    "videos": "Video",
    "articles": "Articoli",
    "new": "Nuovo",
    "startDate": "Data di inizio",
    "endDate": "Data di fine",
    "clearedDate": "Data cancellata",
    "startTime": "Ora di inizio",
    "endTime": "Ora di fine",
    "duration": "Durata"
  },
  "errors": {
    "error": "Errore",
    "errors": "Errori",
    "warning": "Warning",
    "retry": "Riprova",
    "email": "Immettere indirizzo e-mail",
    "password": "Immettere password",
    "login": "Indirizzo e-mail e password inseriti non corrispondono ai dati in archivio.",
    "accInactive": "L'account è inattivo. Contatta il tuo installatore e riprova una volta che il tuo sistema è completamente attivo.",
    "expired": "L’accesso è scaduto.",
    "loggedout": "L’utente è stato disconnesso.",
    "report": "Spiacenti, si è verificato un errore.",
    "offline": "Controlla la tua connessione Internet e prova di nuovo.",
    "noInternet": "Assenza di connessione Internet",
    "message": "Messaggio",
    "tryagain": "Riprovare.",
    "resetNow": "Ripristina ora",
    "resetPassword": "La tua password è scaduta. Si prega di ripristinarla per visualizzare il rapporto",
    "validEmail": "Inserisci indirizzo email valido",
    "validPhone": "Si prega di inserire un numero di telefono valido",
    "fileError": "Il logo dell'azienda deve essere compreso tra 0,05kb e 4MB.",
    "400": "Richiesta non valida",
    "401": "Accesso non autorizzato",
    "403": "Accesso negato",
    "404": "Risorsa non trovata",
    "422": "Impossibile processare l'entità",
    "500": "Errore interno del server.",
    "502": "Gateway difettoso.",
    "503": "Servizio non disponibile.",
    "504": "Timeout del gateway.",
    "default": "Errore del server.",
    "400_text": "Richiesta non valida",
    "401_text": "Accesso non autorizzato",
    "403_text": "Accesso negato",
    "404_text": "Risorsa non trovata",
    "422_text": "Impossibile processare l'entità",
    "500_text": "Errore interno del server. Riprovare più tardi.",
    "502_text": "Gateway difettoso. Riprovare più tardi.",
    "503_text": "Servizio non disponibile. Riprovare più tardi.",
    "504_text": "Timeout del gateway. Riprovare più tardi.",
    "default_text": "Errore del server. Riprovare più tardi.",
    "noDeviceFound": "Durata",
    "noBackupHistoryFound": "Nessuna cronologia di backup trovata",
    "noWiFiNetworkFound": "Nessuna rete Wi-Fi trovata",
    "noResultFound": "nessun risultato trovato",
    "allSites": "Tutti I Siti",
    "favorites": "Preferiti",
    "changesNotSaved": "Le modifiche non vengono salvate",
    "wantToExit": "Vuoi uscire senza salvare?",
    "rateNotFound": "Percentuale non trovata"
  },
  "login": {
    "forgot": "Password dimenticata",
    "signup": "Nuovo account",
    "header": "Accedi a Enphase",
    "intro_content": "Per accedere, immettere l'indirizzo e-mail e la password",
    "remember_me": "Memorizza password",
    "forgot_password": "Password dimenticata?",
    "forgot_password_success": "Se sei già registrato con Enphase, controlla le tue e-mail per le istruzioni di ripristino.",
    "caps_lock_warning": "BLOC MAIUSC attivato",
    "welcome_back": "Bentornato, %{user_name}. ",
    "en_us_installer_html": "Benvenuto %{user_name}. Visitare la nostra <a href='http://go.enphase.com/gettingstarted' target='_blank'>Guida introduttiva</a> per scoprire tutto quello che c'è da sapere sulla progettazione, sull'installazione e sulla messa in funzione dei sistemi Enphase. ",
    "en_aunz_installer_html": "Benvenuto %{user_name}. Visitare la nostra <a href='http://go.enphase.com/au/gettingstarted' target='_blank'>Guida introduttiva</a> per scoprire tutto quello che c'è da sapere sulla progettazione, sull'installazione e sulla messa in funzione dei sistemi Enphase. ",
    "provide_email_password": "Immettere nome utente e password.",
    "request_account": "Richiedi un account",
    "subheader": {
      "new_user": "È la prima volta che si accede a Enphase?",
      "enphasePES": "Enphase PES"
    },
    "new_user_content_html": "I prodotti Enphase Energy migliorano notevolmente le prestazioni dei sistemi a energia solare. Utilizzando i microinverter Enphase, i proprietari e i gestori sono in grado aumentare la produttività e l'affidabilità dell'impianto a energia solare.<br/><br/>Per vedere Enphase in azione, <a href='%{systems_list_link}'>è possibile osservare le installazioni dei nostri clienti.</a>",
    "public_system_content_html": "Si desidera osservare Enphase in azione? <a href='%{systems_list_link}'>Visualizza sistemi pubblici</a>",
    "register_new_user_html": "Stai installando il tuo primo sistema Enphase? <a href='%{register_user_link}'>Registrati con Enphase</a>",
    "recommended_browsers": "L'app Enphase è compatibile con i seguenti browser: Chrome 5 o versioni successive, Firefox 3.6 o versioni successive, Internet Explorer 10 o versioni successive, Microsoft Edge per Windows, Safari 4 o versioni successive. L'app Enphase richiede Adobe Flash Player 10.",
    "recommended_browsers_3x": "L'app Enphase è compatibile con i seguenti browser: Chrome 44 o versioni successive, Firefox 41 o versioni successive, Internet Explorer 11, Microsoft Edge per Windows, Safari 8 o versioni successive.",
    "cookies_required": "I cookie devono essere abilitati.",
    "no_community": "Questa community è dedicata a discussioni di carattere tecnico riservate agli installatori Enphase. Tutti gli altri utenti possono partecipare alle discussioni aperte sulla <a href='https://www.facebook.com/EnphaseEnergy'>pagina Facebook</a> di Enphase.",
    "required": "Per accedere alla pagina, è necessario eseguire l'accesso",
    "findInstaller": "Trova un installatore",
    "sizeYourSystem": "Ridimensiona il tuo sistema",
    "getEnphase": "Ottieni Enphase",
    "experienceTheApp": "Prova l'app",
    "viewStorageSystem": "Guarda un video",
    "meetEnphase": "Incontra Enphase",
    "enphaseSolar": "Enphase Solare",
    "enphaseStorage": "Enphase Accumulata"
  },
  "logout": {
    "confirm_logout": "Disconnessione effettuata. Grazie per la visita."
  },
  "password_recovery": {
    "activate_account": {
      "header": "Attiva account",
      "link": "Attiva subito l'account"
    },
    "header": "Reimpostazione password",
    "intro_content": "Per richiedere la reimpostazione della password, inserire il proprio indirizzo e-mail nella casella qui sotto e fare clic su Invia. Si riceverà un'e-mail con le istruzioni per reimpostare la password.",
    "login": "Accedi",
    "try_again": "Riprovare.",
    "sent_message_html": "Se si è già registrati ad Enlighten, verificare la casella e-mail per le istruzioni di reimpostazione. <span style='color:red'>Se non hai ricevuto l'e-mail, controlla la cartella posta indesiderata/spam.</span>",
    "invalid_request": "Richiesta non valida",
    "invalid_link": "Reimpostazione della password non riuscita. Il collegamento di reimpostazione password è valido per 7 giorni. Riprovare.",
    "success": "Reimpostazione password riuscita.",
    "failed_password_reset": "Si è verificato un problema. Riprovare.",
    "password_requirements": "La password deve essere lunga almeno 6 caratteri, contenere almeno 1 carattere numerico o speciale e non può corrispondere all'indirizzo e-mail inserito.",
    "note": "Password ",
    "OK": "Va bene",
    "sent_email": "Abbiamo inviato un'email a",
    "rest_pwd": "Fai clic sul link nell'email per reimpostare la password."
  },
  "users": {
    "new": "Registrazione nuovo utente",
    "company_details": "Dettagli azienda",
    "edit": "Modifica utente",
    "site_accesses": "Accesso sistema",
    "login": "Accedi",
    "logged_in_as": "%{admin}, accesso effettuato come %{user}",
    "logout_as": "Interrompi",
    "reset_password": "Reimposta password",
    "preview_marketing_description": "Solo anteprima. Modifiche non salvate.",
    "preview_custom_welcome_message": "Solo anteprima. Modifiche non salvate.",
    "reset_password_confirm_html": "<b>Reimpostare la password per questo utente?</b><p>In questo modo l'utente verrà impostato come attivo, verrà generata una nuova password e verrà inviata un'e-mail di benvenuto all'utente.</p>",
    "reset_password_success": "Reimpostazione password riuscita. %{email} riceverà un'e-mail di benvenuto contenente informazioni su come eseguire l'accesso.",
    "reset_password_failed": "Reimpostazione della password non riuscita.",
    "enlighten_manager_access": "L'utente dispone di Enlighten Manager con accesso dati a livello di modulo.",
    "myenlighten_access_note": "(solo per utenti NON associati a un'azienda)",
    "module_level_access_note": "(con accesso dati a livello di modulo)",
    "complimentary_note": "NOTA: il passaggio da MyEnlighten a Enlighten Manager comporta la rinuncia a un'attivazione software del valore di %{price}. Questa transazione sarà registrata e contabilizzata.",
    "purchase_note": "Attivazione software acquistata da %{email} per %{price} in data %{date}.",
    "enlighten_version_title": "Versione app Enphase",
    "unlock_account": "Sblocca account",
    "enlighten_version": {
      "enlighten_manager": "Enlighten Manager",
      "my_enlighten": "MyEnlighten"
    },
    "self_installer_true": "Sto installando autonomamente i prodotti Enphase in casa o nella mia azienda",
    "self_installer_false": "Sono un professionista nel settore dell'energia solare e mi sto registrando per conto della mia azienda",
    "self_register_independent": "Altro",
    "opt_in": "Acconsento a ricevere newsletter, promozioni e sondaggi su prodotti e servizi Enphase.",
    "opt_in_info": "È possibile ritirare il consenso in qualsiasi momento. Per maggiori informazioni, consultare l'<a href='%{privacy_url}' target='_blank'>Informativa sulla privacy</a> di Enphase oppure <a href='%{contact_url}' target='_blank'>contattarci</a>.",
    "personal_details": "Dati personali",
    "enable_camera": "Abilita l'accesso alla fotocamera per la tua app dalla scheda Impostazioni",
    "dont_allow": "Non permettere",
    "cameraText": "Questo ti permetterà di selezionare l'immagine che vorresti caricare come logo della tua azienda"
  },
  "forecast": {
    "nodata": "I dati di previsione non sono disponibili!",
    "nodata5": "Per poter prevedere dati di produzione accurati, sono necessari i dati di almeno 5 giorni.",
    "nodata10": "Abbiamo bisogno di almeno 5 giorni di dati di produzione negli ultimi 15 giorni per mostrare la tua previsione.",
    "apifail": "Impossibile visualizzare i dati di previsione!",
    "apifailSub": "Errore durante la visualizzazione dei dati previsti a causa di problemi tecnici.  Si prega di controllare dopo qualche tempo",
    "weatherErr": "Errore nella visualizzazione dei dati di previsione a causa della mancata disponibilità dei dati meteo.",
    "weatherProdErr": "Errore nella visualizzazione dei dati previsti per indisponibilità dei dati di produzione o meteorologici.",
    "genErr": "Errore durante la visualizzazione dei dati previsti a causa di problemi tecnici.",
    "envoyErr1": "I dati di produzione non sono disponibili perché il gateway non invia rapporti al cloud.",
    "envoyErr2": "I dati di produzione non si aggiornano perché il gateway non invia rapporti al cloud.",
    "microErr1": "Dati di produzione non disponibili perché nessuno dei microinverter sta segnalando",
    "microErr2": "I dati di produzione non si aggiornano perché nessuno dei microinverter sta segnalando",
    "accCTA": "Perché la produzione effettiva è diversa da quella prevista?",
    "ctainfo": "La previsione serve solo ad aiutare a pianificare le esigenze energetiche. Tenere presenti che i valori di produzione possono essere diversi dalla previsione.",
    "ctainfoRes": "Possibili motivi della differenza tra la produzione effettiva e quella prevista",
    "ctainfoRes1": "Frequenti cambiamenti meteo nella località",
    "ctainfoRes2": "Alcuni dei microinverter non segnalano",
    "ctainfoRes3": "Il sistema non ha segnalato per più di un giorno",
    "today": "Oggi",
    "forecast": "Previsione",
    "actual": "Valori effettivi",
    "timeFrom": "Visualizzazione 12:00 ",
    "actualProd": "Actual Production",
    "sunrise": "Alba",
    "sunset": "Tramonto",
    "clearDay": "Prevalentemente soleggiato",
    "clearNight": "Mostly clear",
    "rain": "Prevalentemente piovoso",
    "snow": "Prevalentemente nevoso",
    "sleet": "Prevalentemente con foschia",
    "wind": "Prevalentemente ventoso",
    "fog": "Prevalentemente nebbioso",
    "cloudy": "Nuvoloso",
    "partlycloudy": "Parzialmente nuvoloso",
    "unknown": "Unknown",
    "at12": "Alle 12:00",
    "title": "Scopri la tua previsione di producibilità fotovoltaica",
    "infoIconPopup": "La previsione di producibilità fotovoltaica prevede quanta energia verrà prodotta dai pannelli oggi e nei prossimi 5 giorni. La previsione di producibilità fotovoltaica viene calcolata in base alla produzione energetica passata e alle previsioni meteo regionali.",
    "fiveday": "Previsione di 5 giorni",
    "tomo": "Domani"
  },
  "user": {
    "id": "ID utente",
    "api_key": "Chiave API",
    "company": "Azienda",
    "company_id": "ID azienda",
    "consumer": "MyEnlighten",
    "country": "Paese",
    "email": "Indirizzo e-mail",
    "email_confirm": "Conferma e-mail",
    "password": "Password",
    "first_name": "Nome",
    "last_name": "Cognome",
    "sfdc_email": "E-mail",
    "sfdc_subject": "Soggetto",
    "sfdc_message": "Messaggio",
    "sfdc_siteId": "ID sito Enphase",
    "created_at": "Creato alle",
    "name": "Nome",
    "updated_at": "Aggiornato alle",
    "status": "Stato",
    "phone": "Telefono",
    "locale": "Impostazioni internazionali preferite",
    "preferred_metric": "Unità",
    "preferred_alert_level": "Livello di allarme predefinito",
    "preferred_array_builder": "Configurazione campi possibile",
    "preferred_show_dashboard_help": "Preferenze guida dashboard",
    "preferred_new_look": "Anteprima di Enlighten 3.0",
    "preferences": "Preferenze",
    "role": "Ruolo",
    "roles_mask": "Maschera ruoli",
    "sales_demo": "Demo vendite",
    "sees_modules": "Può visualizzare i dati del modulo",
    "notes": "Note",
    "prefers_monthly_email": "Sottoscrivi e-mail mensile",
    "preferred_enphase_email": "Sottoscrivi newsletter Enphase",
    "prefers_privacy_policy_assent": "Informativa sulla privacy accettata",
    "active": "Attivo",
    "inactive": "Inattivo",
    "add_user": "Aggiungi utente",
    "self_installer": "Programma di installazione automatica",
    "site_access_id": "ID sito",
    "user_access_id": "ID utente",
    "with_company": "Includi dettagli azienda nella registrazione",
    "last_login": "Ultimo accesso",
    "acknowledge": "Riconosco di aver letto e accettato Enphase",
    "privacy_url": "Informativa sulla privacy",
    "terms_url": "Condizioni del servizio",
    "acknowledgementHead": "Ho letto",
    "acknowledgementBody": "di Enphase e ho letto e accetto"
  },
  "company": {
    "id": "ID azienda",
    "active_users": "Utenti attivi",
    "address1": "Indirizzo",
    "optional": "Opzionale",
    "address2": "Indirizzo 2",
    "address_id": "Ubicazione",
    "branch_name": "Nome filiale",
    "branch_of": "Filiale di",
    "city": "Città",
    "companies": "Filiali",
    "country": "Paese",
    "duplicate_of": "Sostituito con",
    "latitude": "Latitudine",
    "logo_img": "Logo aziendale",
    "file_type_size": "Deve essere un file JPEG o PNG non superiore a 4 MB.",
    "file_recommendation": "Per ottenere risultati ottimali, consigliamo un immagine quadrata con uno sfondo trasparente di almeno 400 px di larghezza per 400 px di altezza.",
    "logo_img_file_size": "Logo aziendale",
    "logo_img_content_type": "Logo aziendale",
    "longitude": "Longitudine",
    "long_name": "Nome azienda",
    "marketing_description": "Descrizione azienda",
    "custom_welcome_message": "E-mail di benvenuto al cliente",
    "show_logo_in_welcome_email": "Visualizzazione logo aziendale nell'e-mail di benvenuto al cliente",
    "name": "Nome",
    "parent": "Azienda principale",
    "phone": "Telefono",
    "role": "Ruolo",
    "roles": {
      "admin": "Assistenza/Call Center",
      "installer": "Installatore",
      "distributor": "Distributore",
      "third_party_owner": "Proprietario di terze parti"
    },
    "state": "Stato/Provincia",
    "support_email": "E-mail assistenza clienti",
    "support_phone": "Telefono assistenza clienti",
    "timezone": "Fuso orario",
    "url": "URL sito Web",
    "zip": "CAP",
    "is_installer": "Questa azienda installa sistemi Enphase",
    "errors": {
      "name_not_found": "Impossibile trovare il nome dell'azienda"
    },
    "success": {
      "msg": "Il tuo account è stato creato. Controlla la tua email per le istruzioni su come accedere."
    }
  },
  "privacy_policy_broadcast": {
    "modal": {
      "title": "Le modifiche alla nostra Informativa sulla privacy sono diventate effettive il %{policy_date}",
      "link_body": "<a href='%{privacy_url}' target='_blank'>Visualizza Informativa sulla privacy</a>",
      "acknowledgement": "Confermo di aver letto e accettato l'<a href='%{privacy_url}' target='_blank'>Informativa sulla privacy</a> di Enphase.",
      "continue_button": "Continua",
      "privacy_settings_button": "Apri le impostazioni sulla privacy",
      "privacy_policy_agreement_required": "Confermo di aver letto e accettato l'<a target='_blank' href='%{privacy_url}'>Informativa sulla privacy</a>\ne le <a target='_blank' href='%{terms_url}'>Condizioni del servizio</a>.\n"
    }
  },
  "jquery_validate": {
    "messages": {
      "required": "Campo obbligatorio."
    }
  },
  "validate": {
    "privacy_policy_accept": "Se non accetti l'Informativa sulla privacy e i Termini del servizio di Enphase, non puoi registrarti sull'app Enphase."
  },
  "period": {
    "hours": "Giorno",
    "days": "Mese",
    "week": "Settimana",
    "months": "Anno",
    "years": "Dall'installazione",
    "custom": "Personalizzato"
  },
  "history": {
    "totals": "Totali",
    "graph": "Home",
    "production": "Prodotta",
    "consumption": "Consumata",
    "grid": "Rete di distribuzione",
    "export": "Esportata",
    "import": "Importata",
    "netExported": "Netto Esportato",
    "netImported": "Netto Importato",
    "battery": "Batteria",
    "charge": "Carica",
    "discharge": "Scarica",
    "soc": "Batteria",
    "hours": "",
    "months": "",
    "today": "Oggi",
    "battery_status": "Carica",
    "bulbs": "Lampadina 100 w",
    "last_updated": "Aggiornato",
    "power": "Energia",
    "solar_produced": "Prodotto solare",
    "solar_consumed": "Consumo solare",
    "saved": "Salvato",
    "emission_saved": "Emissioni di CO2 risparmiate",
    "refrigerator": "Frigorifero",
    "produced_today": "Prodotto oggi",
    "produced_yesterday": "Prodotto ieri",
    "this_week": "Questa settimana",
    "last_week": "La settimana scorsa",
    "this_month": "Questo mese",
    "last_month": "Lo scorso mese",
    "this_year": "Quest'anno",
    "last_year": "L'anno scorso",
    "selected_day": "Giorno Selezionato",
    "previous_day": "Giorno Precedente",
    "selected_week": "Settimana Selezionata",
    "previous_week": "Settimana Precedente",
    "selected_month": "Mese Selezionato",
    "previous_month": "Mese Precedente",
    "selected_year": "Anno Selezionato",
    "previous_year": "Anno Precedente",
    "produced_this_week": "Prodotto questa settimana",
    "produced_last_week": "Prodotto la settimana scorsa",
    "produced_this_year": "Prodotto quest'anno",
    "produced_last_year": "Prodotto lo scorso anno",
    "produced_this_month": "Prodotto questo mese",
    "produced_last_month": "Prodotto il mese scorso",
    "produced_lifetime": "Prodotto vita",
    "imported-exported": "Importata/Esportata",
    "yesterday": {
      "hours": "Ieri",
      "days": "Ultimo mese",
      "months": "Anno scorso",
      "years": "Prodotta"
    },
    "lastyear": {
      "hours": "Anno scorso",
      "days": "Anno scorso",
      "months": "Anno scorso",
      "years": "Prodotta"
    },
    "generator": "Generatore"
  },
  "custom_report": {
    "dataType": "Choose data type",
    "frequency": {
      "dataFrequency": "Scegliere la frequenza dei dati",
      "daily": "Giornaliero",
      "weekly": "Settimanale",
      "monthly": "Mensile",
      "yearly": "Annuale",
      "generateReport": "Abbiamo bisogno di almeno una settimana di dati per generare il report."
    }
  },
  "calendar": {
    "select": "Selezionare una data",
    "scale": {
      "production": "Produzione",
      "consumption": "Consumo"
    },
    "weekDays": {
      "monday": "Lunedi",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Venerdì",
      "saturday": "Saturday",
      "sunday": "Sunday"
    },
    "months": {
      "january": "Gennaio",
      "february": "Febbraio",
      "march": "Marzo",
      "april": "Aprile",
      "may": "Maggio",
      "june": "Giugno",
      "july": "Luglio",
      "august": "Agosto",
      "september": "Settembre",
      "october": "Ottobre",
      "november": "Novembre",
      "december": "Dicembre",
      "jan": "genn.",
      "feb": "febbr.",
      "mar": "mar.",
      "apr": "apr.",
      "jun": "giugno",
      "jul": "luglio",
      "aug": "ag.",
      "sep": "sett.",
      "oct": "ott.",
      "nov": "nov.",
      "dec": "dic."
    },
    "time": {
      "hour": "ora",
      "hours": "ore",
      "minute": "minuto",
      "minutes": "minuti",
      "second": "secondo",
      "seconds": "secondi",
      "millisecond": "millisecondo",
      "milliseconds": "millisecondi",
      "day": "giorno",
      "h": "h",
      "min": "min"
    }
  },
  "status": {
    "nameChangeNormal": "Normale",
    "nameChangeError": 'Errore',
    "nameChangeWarning": 'Avvertimento',
    "latest_solar_power": "Latest Solar Power",
    "dayTitle": "Stato odierno",
    "dayAltTitle": "Stato più recente",
    "monthTitle": "Stato questo mese",
    "monthAltTitle": "Stato ultimo mese",
    "yearTitle": "Stato quest’anno",
    "yearAltTitle": "Stato ultimo anno",
    "lifetimeTitle": "Stato dall'installazione",
    "lifetime": "Dall'installazione",
    "system_normal": "Sistema normale",
    "system_error": "Errore di sistema",
    "energyConsumed": "Energia Consumata",
    "energyProduced": "Energia Prodotta",
    "powerProduced": "Potenza Prodotta",
    "powerConsumed": "Potenza Consumata",
    "moreDetails": "Maggiori Dettagli",
    "latest_power": "Potenza più recente",
    "latest_power_text": "L’ultima energia solare è la più recente produzione di energia segnalata dal tuo impianto fotovoltaico",
    "peak_power": "Potenza di picco",
    "peak_power_text": "La potenza di picco è la potenza massima erogata dall'impianto fotovoltaico per il periodo di tempo scelto",
    "addEnphaseStorage": "Aggiungi batteria Enphase",
    "getAQuote": "Richiedi un preventivo",
    "production": {
      "title": "Solare",
      "label": "Prodotta",
      "section": "Destinazioni energia"
    },
    "consumption": {
      "title": "Uso",
      "label": "Consumata",
      "section": "Sorgenti di energia"
    },
    "grid": {
      "title": "Energia netta",
      "export": "Esportata",
      "import": "Importata",
      "label": "Energia netta con importata/esportata",
      "section": "Sorgenti di energia",
      "progressbarTitle": "Energia netta dalla rete"
    },
    "breakdown": {
      "consumption": "Home",
      "battery": "Accumulata",
      "production": "Solare",
      "grid": "Rete di distribuzione",
      "export": "Esportata",
      "import": "Importata",
      "soc": "Accumulata",
      "total": "Totale",
      "peak": "Potenza di picco",
      "latest": "Ultima potenza",
      "next": "Prossimo report"
    },
    "battery": {
      "title": "Accumulata",
      "label": {
        "none": "Inattiva",
        "positive": "In carica",
        "negative": "In scarica"
      },
      "section": "Energia disponibile"
    },
    "charge": "Carica",
    "stormAlertOn": "Avviso tempesta: Attivo",
    "batteryProfile": "profilo della batteria",
    "batteryInfo1": "In base al consumo delle ultime 24 ore (%{consumption}) Il tuo sistema Enphase verrà eseguito per circa ",
    "batteryInfo2": " Senza rete o energia solare.",
    "batteryInfoWOSolar": " Senza rete.",
    "batteryErrorInfo": "Dati insufficienti per stimare il tempo di backup della batteria",
    "to": "A",
    "batteryZeroErrorInfo": "Hai zero ore di backup in quanto le batterie sono scariche.",
    "hours": "ora(e)",
    "minutes": "minuto(i)",
    "gridControls": {
      "verifyOtp": "Verifica il codice",
      "verificationCode": "Codice di verifica",
      "offGridContent": "Perderai la connessione alla rete. La potenza disponibile per il consumo sarà limitata.",
      "tryAgainContent": "Impossibile stabilire una connessione con il gateway.",
      "verifyOtpEmail": "Inserisci il codice di 4 cifre che è stato inviato al tuo indirizzo e-mail registrato.",
      "verifyOtpEmailMobile": "Inserisci il codice di 4 cifre che è stato inviato al tuo indirizzo e-mail registrato e al numero di cellulare.",
      "verifyOtpUpdateMobile": "Un codice a 4 cifre sarà inviato al tuo indirizzo e-mail registrato.",
      "onGridContent": "Vuoi ricollegare il tuo sistema alla rete ora?",
      "pleaseTryAgain": "Per favore riprova",
      "enterValidOtp": "Per favore inserisci un codice valido",
      "didntReceiveOtp": "Non hai ricevuto il codice?",
      "goOffGrid": "Vai fuori rete",
      "goOnGrid": "Vai in rete",
      "tryAgain": "riprova",
      "resend": "Invia di nuovo",
      "alert": "L'accesso al controllo della griglia è disabilitato perché è in corso un aggiornamento per il sistema. Questo aggiornamento potrebbe richiedere fino a 24 ore. Attendi il completamento dell'aggiornamento.",
      "sendCode": "Invia il codice",
      "mobileStatus": "per ricevere il codice in formato testo.",
      "myInfoButton": "Aggiorna il numero del cellulare",
      "wpc1l1": "I livelli di consumo attuali sono più elevati della produzione di energia solare disponibile.  Si consiglia di ridurre il tuo consumo per evitare lo spegnimento del sistema durante la transizione.​",
      "wpc1l2": "È possibile visualizzare la propria produzione di energia solare attuale e il consumo essenziale dei carichi in %{liveStatus}.",
      "wpc2l1": "Il consumo medio negli ultimi 15 minuti è stato superiore alla produzione di energia solare media. Assicurarsi che la produzione di energia solare attuale sia sufficiente a supportare le proprie esigenze di consumo, al fine di evitare lo spegnimento del sistema quando è Fuori rete.",
      "wpcOnGrid": "Al momento il tuo sistema è alimentato dal generatore. Se il tuo consumo è molto elevato, il passaggio a Fuori rete potrebbe comportare un'interruzione temporanea dell'alimentazione. Per evitare una tale interruzione, riduci il tuo consumo.",
      "wpcOnGrid2": "Puoi visualizzare il tuo consumo corrente in %{liveStatus}."
    },
    "viewDetails": "Visualizza dettagli",
    "socMessageError1": "La ",
    "socMessageError2": " di accumulazione aggregata esclude le percentuali di accumulazione di ",
    "socMessageError3": " Batteria/e",
    "socMessageThreshold": "La carica della batteria è sconosciuta, nessun dato riportato sulle batterie durante l'ultimo ciclo di trasmissione"
  },
  "menu": {
    "supportHistory": "Cronologia del supporto",
    "supportHistorySearch": "",
    "connectedAppliances": "Dispositivi connessi",
    "connectedAppliancesSubtitle": "Monitorare e controllare i dispositivi smart",
    "homeConnect": "Home Connect",
    "homeConnectSubtitle": "Monitorare e controllare gli elettrodomestici abilitati a Home Connect",
    "appTutorial1": "È possibile consultare tutti i tutorial in qualsiasi momento accedendo alla sezione",
    "appTutorial2": "Conoscere il sistema",
    "appTutorial": "Conoscere il sistema",
    "appTutorial3": "in",
    "appTutorial4": "Sistema",
    "viewallsystutorial": "Visualizza tutti i tutorial per il sistema",
    "voiceAssistant": "Assistente vocale",
    "voiceAssistantSubtitle": "Abilita controllo vocale per Enphase",
    "alexa": "Alexa",
    "googleAssistant": "Google Assistant",
    "solarForecast": "Previsione di producibilità fotovoltaica",
    "dryContactLoads": "Carichi",
    "generator": "Generatore",
    "generatorDevice": "Generatore",
    "loadControl": "Controllo del carico",
    "loadControlSubtitle": "Controlla la potenza sui tuoi carichi",
    "evCharge": "Electric Vehicle Charging",
    "evChargeSubtitle": "Smart suggestions for EV charging",
    "notices": "Notifiche",
    "newNotices": "Notifiche",
    "reports": "Report",
    "exploreEnphase": "Esplora Enphase",
    "exploreEnphaseNewMenu": "Esplora",
    "details": "Dettagli",
    "detailSite": "DETTAGLI SUL SITO",
    "detailsInstaller": "DETTAGLI INSTALLATORE",
    "systemDescription": "Sistema Descrizione",
    "systemStatistics": "Statistiche del sistema",
    "settings": "impostazioni",
    "advanceSettings": "Impostazioni avanzate",
    "advanceBatterySettings": "Impostazioni Avanzate",
    "advancedBatterySettings2": "Impostazioni avanzate",
    "account": "Account",
    "support": "Assistenza",
    "supportFaq": "FAQs",
    "emergencySupport": "chiamaci ora",
    "contactUs": "Contattaci",
    "contactSupport": "Scrivici",
    "devices": "Dispositivi",
    "addStorage": "Aggiungi memoria",
    "devicesOld": "Dispositivi",
    "batteryStorage": "Conservazione della batteria",
    "batteryStorageNewMenu": "Batteria",
    "connectivity": "Connettività",
    "connectGateway": "Connettività",
    "batteryReserve": "Riserva batteria",
    "expertModeEdit": "Modalità esperto",
    "eventsHistory": "Cronologia degli eventi",
    "backupHistory": "Cronologia backup",
    "outageHistory": "Interruzioni di corrente storia",
    "event": "Evento",
    "events": "Eventi",
    "totalEvents": "Eventi totali",
    "totalBackup": "Batteria di backup",
    "backupDuration": "Durata backup",
    "hours": "ore",
    "minutes": "minuti",
    "siteDetails": "Dettagli del sito",
    "configure": "Configura",
    "envoy": "Gateway",
    "liveVitals": "Live Stats",
    "envoyNotReport": "Gateway non segnalato",
    "microInverterNotReporting": "I microinverter non inviano report",
    "enpowerNotReporting": "Il controller di sistema non trasmette",
    "enchargeNotReporting": "La batteria non trasmette",
    "enchargeError": "Errore batteria",
    "enpowerError": "Errore controller di sistema",
    "microinverters": "Microinverter",
    "stringInverters": "String Inverter",
    "storage": "Batteria",
    "reconnectToEnvoy": "Connettività",
    "configureWiFi": "Configura Wi-Fi",
    "envoyInternetConnection": "Per modificare la connettività Internet del gateway",
    "enpower": "Controller di sistema",
    "theme": "Tema",
    "darkmode": "Modalità oscura",
    "devmode": "Developer Mode",
    "appUpdate": "Aggiornamento app",
    "wifi": "Tipo di connessione",
    "feedback": "Feedback",
    "logout": "Esci",
    "help": "Guida",
    "siteid": "ID sito",
    "visitTommorrowForReport": "Controlla domani. Il cloud Enphase non ha raccolto i dati richiesti per creare i rapporti.",
    "email_report": "Rapporto di posta elettronica",
    "will_send": "Sarà inviato a",
    "batterySubtitle": "Ottimizza la tua batteria in base all utilizzo e alle tariffe",
    "batteryEmeaSubtitle": "Ottimizza la tua batteria in base all'utilizzo",
    "connectivitySubtitle": "Modificare la connettività Internet del gateway",
    "eventsHistorySubtitle": "Visualizza il registro degli eventi principali del sistema",
    "backupHistorySubtitle": "Visualizza la cronologia delle interruzioni di corrente",
    "accountSubtitle": "Dati personali, Linguaggio, Impostazioni della privacy",
    "wifiSubtitle": "Larghezza di banda standard, Riporta i dati ogni 15 minuti",
    "liveVitalsSubtitle": "Visualizza i dati del sistema in tempo reale",
    "themeSubtitleOn": "La modalità oscura è attivata",
    "themeSubtitle": "La modalità oscura è disattivata",
    "devmodeSubtitle": "Opzioni della modalità Sviluppatore",
    "appUpdateSubtitle": "Note di rilascio per gli ultimi aggiornamenti e registro delle modifiche",
    "appUpdateSuccessSubtitle": "L'app è aggiornata",
    "requestReplacement": "Richiedi la sostituzione",
    "changeShippingAddress": "Cambia l'indirizzo di spedizione",
    "tariffEditor": "Tariffa elettrica",
    "tariffEditorNewMenu": "Tariffa elettrica",
    "currencyConversion": "Equivalente in valuta",
    "currencyConversionNewMenu": "Moneta",
    "currencySubtitle": "Converte i dati energetici in tassi di cambio equivalenti",
    "showCurrency": "Mostra equivalente in valuta",
    "showCurrencySubtitle": "Attiva per mostrare il widget di conversione",
    "passwordReset": "Ripristino password",
    "tariffAdded": "Visualizza/Modifica la struttura della tariffa elettrica della tua utility",
    "showCurrencySubtitleOff": "Disattiva per nascondere il widget valuta",
    "tariffNotAdded": "La struttura della tariffa elettrica non è stata aggiunta",
    "enlightenManager": "Visualizza in Enlighten Manager",
    "sgipIncentive": "Incentivo Spazio di accumulazione (SGIP)",
    "gridServices": "Grid Services",
    "enphaseHome": "Appena trasferito in una casa che ha Enphase",
    "systemAccess": "Tutto configurato, ma necessità dell'accesso al sistema",
    "woSiteSystemAccess": "Accesso sistema",
    "enphaseProducts": "Scopri di più sui prodotti Enphase",
    "enphaseTeam": "Chiedi aiuto al team di Enphase",
    "gridSwitch": "Controllo della rete",
    "onGrid": "In rete",
    "chatWithUs": "chatta con noi",
    "referFriends": "Segnala agli amici",
    "referralTnC": "Termini e condizioni",
    "hello": "Ciao",
    "homeControls": "Home Controls",
    "systemDetails": "Sistema",
    "pesDetails": "System",
    "community": "Community",
    "settingsMenu": "impostazioni",
    "enphaseStore": "Enphase Store",
    "upgrades": "Upgrades",
    "services": "Servizi",
    "generatorSubtitle2": "Configura il tuo generatore in base a profili intelligenti",
    "devicesSubtitle": "Visualizza tutti i dispositivi e i relativi stati",
    "siteDetailsSubtitle": "Visualizza i dettagli del sito e dell'installatore",
    "reportsSubtitle": "Genera e invia rapporti",
    "appSettings": "Impostazioni dell'app",
    "accountSettings": "Impostazioni account",
    "addStorageSubtitle": "Aggiungi spazio di accumulo per evitare blackout",
    "addSolarPanels": "Aggiungi pannelli solari",
    "addSolarPanelsSubtitle": "Aumenta l'autoconsumo",
    "sgipIncentiveSubtitle": "Richiedi incentivo SGIP",
    "gridServicesSubtitle": "Guadagna benefit aiutando la rete con la tua IQ Battery",
    "incentives": "Incentivi",
    "accountMenu": "Account",
    "myInformation": "Le mie informazioni",
    "myNotificationPreferences": "Le mie notifiche",
    "myPrivacy": "La mia privacy",
    "myAccessControl": "Il mio controllo di accesso",
    "myInformationSubtitle": "Aggiorna i dettagli personali e di sistema",
    "myNotificationPreferencesSubtitle": "Gestisci le mie notifiche",
    "myPrivacySubtitle": "Controlla come Enphase utilizza le informazioni di sistema",
    "myAccessControlSubtitle": "Gestisci l'accesso ai dati di sistema",
    "systemSettings": "Impostazioni di sistema",
    "deviceSettings": "Impostazioni dispositivo",
    "wirelessRangeExtender": "Wireless Range Extender",
    "cacheAction": "Cancella cache locale",
    "cacheResult": "Dati sull'energia del browser cancellati",
    "noActiveNotices": "Non ci sono recensioni attive per te",
    "appInfo": "Informazioni sull'app",
    "whatsNew": "Novità",
    "privacyPolicy": "Informativa sulla privacy",
    "tos": "Condizioni del servizio",
    "rateUs": "Valutaci",
    "gridToggle": {
      "infoPopupTitle": "Sistema di backup basato sulla luce del sole",
      "infoPopupContentP1": "Il sistema in uso è un Sistema di backup basato sulla luce del sole, pertanto non si consiglia di passare alla modalità Fuori rete al di fuori degli orari di luce.",
      "pIt1": "Quando il sistema passa alla modalità Fuori rete, i carichi non essenziali vengono disconnessi dall'alimentazione.",
      "pIt2": "Il passaggio alla modalità Fuori rete è possibile solo durante le ore in cui i carichi essenziali sono pianificati per essere alimentati in %{scheduledMode}.",
      "pIt3": "In caso di scarsa luce solare, il sistema potrebbe spegnersi in modalità Fuori rete.",
      "scheduledMode​": "Modalità pianificata​",
      "infoPopupContentP2": "Quando il sistema passa alla modalità Fuori rete, i carichi vengono disconnessi dall'alimentazione, ad eccezione di quello essenziale. Il passaggio alla modalità Fuori rete non è consentito al di fuori delle ore pianificate. In caso di scarsa luce solare, il sistema potrebbe spegnersi in modalità Fuori rete."
    },
    "ojas": {
      "ojasBoxInfo": "Run the devices on the go with Portable Energy System, your personal portable energy system designed exclusively for home backup and outdoor Off grid use.",
      "ojasTitleQuestion": "Don't have the Portable Energy System yet?",
      "knowurOjas": "Get to know your device",
      "enphasePESSubheading": "Enphase Portable Energy System",
      "enphasePESDesc": "PES is designed exclusively for your home backup and outdoor energy needs ",
      "enphasePESKnowMore": "Know more",
      "enphasePESTitle": "Portable Energy System",
      "enphasePESDescription": "Porta con te l'energia. Sicurezza energetica ed energia durante gli spostamenti.",
      "enphasePESConnectDevice": "Connetti un dispositivo",
      "enphasePESLearnMore": "Maggiori informazioni",
      "enphasePESBuy": "Buy",
      "enphasePESConnect": "Connect",
      "registerYourOjasBox": "Register your device",
      "buyOjas": "Buy Portable Energy System",
      "registerOjasInfo": "Make sure your phone’s Bluetooth is turned on.",
      "registerStep1": "Accedi a/registra un account Enphase",
      "registerStep2": "Pair your device and phone via Bluetooth​",
      "registerStep3": "Give your device a name​",
      "registerStep4": "Connect it to the Wi-Fi network​",
      "register": "Register",
      "start": "Start",
      "later": "Later",
      "fserialNumber": "Enter Serial No.",
      "enterSeriaNumber": "Enter Portable Energy System Serial No.",
      "collectName": "Name Your Device",
      "enterBoxName": "Device Name",
      "connectToWiFi": "Connect your device to Wi%{nbh}Fi",
      "connectToWiFiNotice": "Select your preferred Wi-Fi network and enter password.",
      "takeFewMinutes": "This may take a few minutes",
      "connectingToWifi": "Connecting to Wi-Fi",
      "pleaseContactSupport": "Please contact support for help",
      "unableToCompleteConnect": "Unable to complete the connect",
      "incomplete": "Incomplete",
      "congratulations": "Congratulations!",
      "incorrectPasswordTryAgain": "Incorrect password. Please try again",
      "yourOjasBox": "Your Portable Energy System",
      "isRegistered": "is registered",
      "startMonitoring": "Start Monitoring",
      "turnOnBluetoothOnNotice": "Your mobile bluetooth seems to be switched off. Please turn it on to connect to Portable Energy System.",
      "scanningForOjasDevices": "Scanning for Portable Energy Systems Around",
      "noOjasDevicesFound": "No Portable Energy System found",
      "noOjasAroundNotice": "No Portable Energy Systems could be found. Make sure that your device is switched on and you are near it. If the problem persist",
      "incorrectPassCode": "Incorrect Code",
      "incorrectPassCodeNotice": "Unable to match the code with any of the surrounding Portable Energy Systems.",
      "capturingDeviceDetails": "Capturing Device Details",
      "capturedDeviceDetails": "Device details captured",
      "capturedDeviceDetailsNotice": "Connect Portable Energy System to Wi-Fi",
      "registrationError": "Registration Error",
      "registrationErrorNotice": "Please retry registration. If problem persist, ",
      "deviceAlreadyRegistered": "Device already registered",
      "deviceAlreadyRegisteredNotice": "Questo sistema di accumulo di energia portatile è già registrato con un altro account Enphase.",
      "proceed": "Proceed",
      "rename": "Rename",
      "nameAlreadyExist": "Name already exist",
      "nameAlreadyExistNotice": "This name already exists for an Portable Energy System registered with this account. Please use different name.",
      "bluettoothConnected": "Bluetooth connection eshtablished!",
      "enter4DigitCode": "Enter 4 digit code",
      "bluetoothCodeDetail": "The 4 digit code displayed on your Portable Energy System`s display screen",
      "resendBluetoothCode": "Resend code",
      "connWithOJASBLE": "Connect with Portable Energy System via Bluetooth",
      "noBLEDevicesFound": "No bluetooth devices found",
      "backupTime": "Backup Time",
      "timeToCharge": "Time to Charge",
      "powerSaving": "Power Saving",
      "poweredOn": "Powered On",
      "powerOn": "Power On",
      "powerOff": "Power Off",
      "close": "Chiuso",
      "powerSavingHeader": "Device is Power Saving",
      "powerOnHeader": "Device is Powered On",
      "powerSavingSubHeader": "(AC output disabled)",
      "powerSavingContent": "You can remotely power on and enable AC output or shut down the device and disable all the input and output power supply.",
      "powerOnContent": "You can remotely shut down the device and disable all the input and output power supply.",
      "shuttingDown": "Shutting down in",
      "topenojas": "Select Portable Energy System from the drop-$splitdown list to start monitoring.",
      "foundDevice": "Portable Energy System found",
      "pps": "Portable Energy System",
      "lightSettings": {
        "light": "Light",
        "on": "Always On",
        "off": "Always Off",
        "auto": "Automatic",
        "onMsg": "Stays On",
        "autoMsg": "Turns on when someone is nearby",
        "offMsg": "Stays Off"
      },
      "ojasConnectivity": {
        "1_title": "Il dispositivo non è connesso con l'app Enphase!",
        "1_description": "Please ensure your device is turned on and connected to Wi-Fi. If you are nearby your device, you can pair your phone with the device using Bluetooth.",
        "1_action": "Connect using Bluetooth",
        "3_title": "Bluetooth not supported!",
        "3_description": "Bluetooth not supported in your device, please make sure device has Bluetooth and Location options.",
        "4_title": "Turn On Bluetooth",
        "4_description": "Turn on your phone’s Bluetooth to connect with your Portable Energy System.",
        "5_title": "Scanning for Bluetooth devices...",
        "7_title": "Bluetooth devices",
        "8_title_success": "No bluetooth devices found.",
        "8_title_error": "Problem persisted while scanning.",
        "8_title_noUnits": "No Units nearby",
        "8_description": "No PES devices could be found. Make sure that your device is switched on and you are near it. If the problem persist.",
        "9_title": "Eshtablish Bluetooth connection...",
        "10_title": "Enter proof of possession PIN for",
        "10_subTitle": "Proof of Possession PIN",
        "11_title": "Bluetooth connection established!",
        "11_description_1": "Bluetooth connection with your Portable Energy System:",
        "11_description_2": " is successfully eshtablished.",
        "12_title": "Bluetooth Not-Connected.",
        "12_description_1": "Bluetooth connection with your Portable Energy System:",
        "12_description_2": " is failed, Please try again.",
        "13_title": "Searching for Wi-Fi networks...",
        "14_title": "Connect PES to Wi-Fi",
        "14_description": "Select your preferred Wi-Fi network and enter password.",
        "15_title": "Wi-Fi Networks",
        "15_title_success": "No Wi-Fi network found.",
        "15_title_error": "Problem persisted while scanning.",
        "15_description": "No Wi-Fi network found. Reboot your Wi-Fi router and try again.",
        "18_title_1": "Sending Wi-Fi credentials",
        "18_title_2": "Applying Wi-Fi connection",
        "18_description": "provisioned successfully,",
        "19_title": "Incomplete!",
        "19_description": "Unable to complete the connection with Portable Energy System:"
      },
      "deviceId": "Device ID",
      "ojasSettings": {
        "profile": "Profili",
        "acPorts": "Porte CA",
        "dcPorts": "Porte CC",
        "on": "Attivata",
        "off": "Disattivata",
        "brightnesSettings": {
          "brightness": "Luminosità",
          "customBrightness": "Personalizza luminosità",
          "auto": "Regola automaticamente la luminosità"
        },
        "lightSettings": {
          "light": "Spia",
          "on": "Sempre attiva",
          "off": "Sempre spenta",
          "auto": "Automatico",
          "onMsg": "Resta accesa",
          "autoMsg": "Attiva se qualcuno si trova nelle vicinanze",
          "offMsg": "Resta disattivata"
        },
        "powerSettings": {
          "mode": "Power Mode",
          "powerON": "Alimentazione attivata",
          "powerOff": "Alimentazione disattivata",
          "powerSave": "Risparmio energia"
        },
        "ojasModes": {
          "on": "Tutte le porte CA e CC di uscita sono attive. Tenere il dispositivo in questa modalità se altri strumenti o apparecchiature sono collegati alla porta CA.",
          "save": "Solo le porte CC sono attive e pronte per alimentare dispositivi elettronici. Questa modalità consente di risparmiare energia perché le porte CA sono disattivate.",
          "off": "Tutte le fonti di alimentazione in entrata e in uscita verranno disattivate."
        },
        "displaySetting": "Display Settings",
        "deviceSetting": "Device Settings",
        "appSetting": "App Settings"
      }
    },
    "iq8dEditSavings": "Risparmi",
    "appTutorialPage": {
      'all-topics-empty': 'Nessun argomento disponibile',
      'videos-empty': 'Nessun video disponibile',
      'articles-empty': 'Nessun articolo disponibile',
      'noResults': "Nessun risultato per \"%{searchValue}\""
    }
  },
  "environmentCard": {
    "title": "Ambiente",
    "label": "Impatto ambientale",
    "rightText": "Fonte: epa.gov",
    "equivalent": "Equivalente",
    "planted": "PIANTATI",
    "carbon_offset": "COMPENSAZIONE DELLE EMISSIONI DI CO2",
    "charged": "CARICO",
    "trees": {
      "zero": "alberi",
      "one": "albero",
      "other": "alberi"
    },
    "phone": {
      "one": "Telefono",
      "other": "telefoni"
    },
    "tonne": {
      "one": "tonnellata",
      "other": "tonnellate"
    },
    "lb": {
      "one": "libbra",
      "other": "libbre"
    },
    "ton": {
      "one": "tonnellata",
      "other": "tonnellate"
    }
  },
  "connectionType": {
    "wifi": "Wi-Fi",
    "cellular": "Modem cellulare",
    "ethernet": "Ethernet",
    "reportsAt15Mins": "Riporta i dati ogni 15 minuti",
    "reportsAt6Hrs": "Riporta i dati ogni 6 ore",
    "idle": "Inattivo",
    "notAvailable": "Non disponibile",
    "configureWiFiSettings": "Configura impostazioni wireless",
    "configureWiFiSettings2": "Configura",
    "switchToWiFi": "Passa al Wi-Fi",
    "connectToWiFi": "Connettiti al Wi-Fi"
  },
  "details": {
    "connection_type": "Tipo di connessione",
    "description": "Descrizione sistema",
    "installer": "Installato da",
    "maintainer": "Addetto alla manutenzione del sistema",
    "micros": {
      "one": "Microinverter",
      "other": "Microinverter"
    },
    "acbs": {
      "one": "Batteria",
      "other": "Batterie"
    },
    "arrays": {
      "one": "Matrice",
      "other": "Matrici"
    }
  },
  "notices": {
    "enlighten": "Enlighten"
  },
  "layout": {
    "more_yesterday": "% in più rispetto a ieri",
    "less_yesterday": "% in meno rispetto a ieri",
    "same_yesterday": "Quasi uguale rispetto a ieri",
    "more_last_year": "% in più rispetto allo scorso anno",
    "less_last_year": "% in meno rispetto allo scorso anno",
    "same_last_year": "Quasi uguale rispetto allo scorso anno",
    "more_yesterday_prev": "% in più rispetto a questa volta il giorno precedente",
    "less_yesterday_prev": "% in meno rispetto a questo orario del giorno precedente",
    "same_yesterday_prev": "Più o meno come questa volta il giorno prima",
    "more_last_year_prev": "% in più rispetto a questa volta l'anno precedente",
    "less_last_year_prev": "% in meno rispetto a questa volta l'anno precedente",
    "same_last_year_prev": "Più o meno come lo scorso anno",
    "system": "Sistema",
    "emptyArray": "Nessun layout del campo disponibile",
    "storageArray": "Array di accumulo",
    "solarArray": "Array solare",
    "contactInstForpersonalizedLayout": "Contatta l'installatore per ottenere una visualizzazione personalizzata del tuo array di accumulo.",
    "cntcInstPopP1": "L'array di accumulo mostra l'immagine delle unità di accumulo installate presso la tua abitazione insieme ai relativi livelli di carica.",
    "cntcInstPopP2": "Rivolgiti all'installatore per configurare l'array di accumulo nell'applicazione Installer Toolkit o nell'applicazione Enlighten Manager e ottenere una vista più personalizzata."
  },
  "support": {
    "enphase": "Supporto Enphase",
    "enphaseLink": "Supporto Enphase",
    "maintainer": "Supporto e manutenzione del sistema",
    "maintainerLink": "Contattare il responsabile della manutenzione",
    "contactEnphase": "Contatta Enphase",
    "enphaseSupport": "Supporto Enphase",
    "ensembleSupport": "Chiamata Ensemble Support",
    "writeToUs": "Scrivici",
    "visitSupport": "Visita il supporto",
    "talkToUs": "Parla con noi",
    "talkToUsAnytime": "Parla con noi in qualsiasi momento",
    "customerSupport24by7": "Assistenza clienti 24/7",
    "contactUs": "Contattaci",
    "needMoreHelpTitle": "Serve ancora aiuto",
    "productionIssue": "Problema di produzione",
    "needHelpTitle": "Hai bisogno di aiuto con",
    "askEnphaseCommunity": "Chiedi a Enphase Community",
    "browseTopics": "Sfoglia tutti gli argomenti della guida",
    "chatWithUs": "chatta con noi",
    "productionDifference": "Differenza nella produzione per pannello",
    "envoyNotReporting": "Il sistema o il gateway non trasmettono",
    "microinvertersNotReporting": "I Microinverter non risultano attivi",
    "helpTopics": "Argomenti della guida",
    "brwsAllFaqs": "Sfoglia tutte le Domande frequenti",
    "askEnphaseCommunitySubtitle": "Contatta gli altri clienti Enphase intorno a te",
    "systemOwnerGuide": "Fare riferimento alla guida del proprietario del sistema",
    "faq": {
      "usingManualOverride": "Uso della sovrascrittura manuale",
      "understandingEnpower": "Comprensione di IQ System Controller",
      "understandingEncharge": "Comprensione di IQ Battery",
      "understandIQCombiner": "Comprensione di IQ Combiner, gateway, Kit di comunicazione e modem cellulare",
      "stormGaurdFeatureDetails": "Dettagli della funzione Protezione temporali",
      "settingElectricityRateStructure": "Impostazione della struttura della tariffa elettrica",
      "recoverShutdownLL": "Ripristino dallo spegnimento dovuto a grandi carichi",
      "recoverShutdownCF": "Ripristino dallo spegnimento dovuto a un errore di comunicazione",
      "recoverShutdownBD": "Ripristino dallo spegnimento dovuto all'esaurimento della batteria",
      "PowerHomeInBCK": "Alimentazione dei carichi domestici in backup",
      "partialHomeBCK": "Configurazione backup parziale della casa",
      "monitorUrSys": "Monitoraggio del sistema",
      "mngLgApplianceBck": "Gestione di grandi apparecchi in backup",
      "incentivesAvlbTou": "Incentivi disponibili per te",
      "grdTrnxToOffGrd": "Passaggio da In Rete a Fuori rete",
      "allHomeBck": "Configurazione backup completo della casa",
      "envLEDstatus": "Stato LED gateway",
      "dsgnUrSys": "Progettazione del sistema",
      "cntctCustSupp": "Come contattare l'assistenza clienti",
      "batSmrtPrfSel": "Seleziona il profilo della batteria intelligente",
      "accsEnchrgDcswtch": "Accesso all'interruttore CC della batteria",
      "mcrInvNtReprt": "Il microinverter non sta segnalando",
      "sysEnvNtReprt": "Gateway non segnalato",
      "hwUrSysWrk": "Come funziona il tuo sistema",
      "enchrLedStatus": "Stato LED della batteria",
      "noPwNebDo": "La mia casa non ha elettricità ma i miei vicini ce l'hanno",
      "consBatDurGridOut": "Risparmia la durata della batteria durante un'interruzione di corrente",
      "emgSupCallSteps": "Scegli 2 per il servizio clienti e 1 per il proprietario del sistema. Selezionare 2 dal sottomenu Sistemi di archiviazione.",
      "preLoginCallSteps": "Selezionare 2 per l'assistenza clienti o 4 per le vendite.",
      "sysProdIssue": "Problema di produzione del sistema",
      "diffInPerPanProd": "Differenza di produzione per pannello",
      "installCellModem": "Guida all'installazione del modem cellulare",
      "whatIsEI": "Punteggio dell'indipendenza energetica",
      "howEnHomeEngSysWork": "Come funziona il sistema energetico domestico Enphase?",
      "understandEnv": "Comprensione gateway",
      "findEnv": "Trova il gateway",
      "envReplaced": "Il gateway è stato sostituito",
      "rebootEnv": "Ripristino o riavvio del gateway",
      "hwChangeEmail": "Come cambio la mia email?",
      "hwResetPasswd": "Come posso reimpostare la mia password?",
      "accessEnvLocalIntf": "Accesso all'interfaccia locale del gateway",
      "envLocIntfLogCred": "Credenziali di accesso all'interfaccia locale del gateway",
      "hwDisbaleNotification": "Come si attivano e disattivano i rapporti mensili e altre notifiche e-mail?",
      "MontEngProd": "Tieni traccia della mia produzione di energia",
      "whyNotSeeConsumption": "Perché non riesco a vedere il mio consumo?",
      "hwMonConsumpt": "Come posso controllare i consumi della mia casa?",
      "calEngUsageWoConsumptionMonitoring": "Calcola il mio consumo di energia senza monitorare il consumo",
      "undersNetEng": "Capire l'energia netta",
      "understTrueUpStmt": "Capire un'affermazione vera",
      "diffPaidENLMvsPerpanelDataaoffering": "Differenza tra Enlighten Manager a pagamento e offerta di dati energetici gratuiti per pannello",
      "blkInPerpanMon": "Pannello nero nella vista del pannello",
      "gryorBlnkInPerpanMon": "Pannello grigio (vuoto) nella vista pannelli",
      "hwToMovePnl": "Come spostare un pannello?",
      "hwfindInst": "Come trovare un nuovo programma di installazione?",
      "whtdoIfonePanelNotreproduc": "Cosa devo fare se uno dei pannelli ha poca o nessuna produzione?",
      "haveaSelfPoweredHome": "Cosa significa avere una casa auto-alimentata?",
      "yourSystemPaysForItself": "Quanto tempo passerà prima che il sistema si ripaghi da solo?",
      "enphaseSystemsAreSafe": "Perché i sistemi Enphase sono sicuri?"
    },
    "supportHistory": "Cronologia del supporto"
  },
  "evse": {
    "tariffErr": "Please input your %{tariff} details to be able to view the suggested schedule to charge your Electric Vehicle",
    "errfail": "Unable to display suggested schedule. Please try reloading the page after some time.",
    "errcons": "Unable to suggest charging schedule because of insufficient consumption data",
    "errprod": "Unable to suggest charging schedule because of insufficient production data",
    "errprodcons": "Unable to suggest charging schedule because of insufficient consumption and production data",
    "addev": "Aggiungi un veicolo elettrico",
    "addevSub": "Comunicare se si sta usando il sistema Enphase per ricaricare un EV, così potremmo offrire informazioni e suggerimenti sul periodo ottimale per ricaricare il veicolo in modo efficiente.",
    "haveEv": "Ho un EV.",
    "qbrand": "Qual è la marca dell'EV?",
    "qbrandErr": "*The above field is mandatory",
    "qmodel": "Qual è il modello dell'EV?",
    "diffcharger": "Carico il mio EV a casa usando un caricatore aziendale diverso",
    "qcharger": "Qual è la marca del caricatore?",
    "qcapacity": "Qual è la capacità della batteria del tuo EV (in kWh)?",
    "qtime": "Quando viene caricato il veicolo?",
    "notcompulsory": "*questa domanda non è obbligatoria. Se non si conosce la risposta, è possibile saltarla.",
    "morning": "Al mattino",
    "afternoon": "Nel pomeriggio",
    "evening": "Di sera",
    "night": "Di notte",
    "other": "Altro (specificare)",
    "qmiles": "Quanti km si percorrono, in genere, in un giorno?",
    "brand": "Dettagli marca",
    "tech": "Dettagli tecnici",
    "operational": "Dettagli operativi",
    "ev": "Veicolo elettrico:",
    "suggsch": "Pianificazione suggerita",
    "suggschInfo": "The schedule to charge your electric vehicle is suggested based on your battery profile, production forecast and electricity rate.",
    "charge": "To charge your electric vehicle",
    "weekday": "For Mon, Tue, Wed, Thur & Fri",
    "weekend": "For Sun & Sat",
    "everyday": "Everyday",
    "removeEV": "Rimuovi veicolo elettrico",
    "userfail": "Unable to display Electric Vehicle details!",
    "userfailDesc": "We are unable to display your Electric Vehicle details because of some technical issues. Please try again after sometime."
  },
  "storage": {
    "stormGuardEnablePopUpHeader": "Abilita Storm Guard",
    "stormGuardEnablePopUpFooter": "Vuoi abilitare Storm Guard?",
    "stormGuardDisablePopUpHeader": "Disattiva Storm Guard",
    "stormGuardDisablePopUpFooter": "Vuoi ancora disattivare Storm Guard?",
    "backupTime": "Tempo di backup",
    "encharge_battery": "Seleziona un profilo intelligente per controllare la tua batteria",
    "encharge_battery_emea": "Profilo intelligente per controllare la batteria",
    "savings": "Modalità risparmio",
    "expert": "Modalità esperto",
    "self-consumption": "Autoconsumo",
    "battery_bkup": "Backup completo",
    "savings_text": "Utilizzare se i costi energetici variano durante il giorno. La batteria viene caricata durante le ore non di punta e utilizzata durante le ore di punta e dopo il tramonto.",
    "savings_mode_notSet": "Massimizza i tuoi risparmi in base alle tariffe dell'energia elettrica",
    "savings_mode_dc_tou": "Il solare e la batteria vengono utilizzati durante le ore di punta per ridurre al minimo l'importazione di energia elettrica dalla rete.",
    "savings_mode_dc_all_day": "Durante le ore di punta l'energia solare prodotta viene esportata verso la rete La batteria alimenta la tua casa fino a quando non raggiunge la carica di riserva.",
    "viewElectricityRate": "Visualizza le tariffe dell'energia elettrica",
    "optForDC": "Ottimizzato per il risparmio sui costi legati alla domanda",
    "optForIncExport": "Ottimizzato per aumentare l'esportazione",
    "consumption_text": "Usa l'energia solare immagazzinata per alimentare la tua casa dopo il tramonto. La batteria viene utilizzata quando l'energia solare non è disponibile.",
    "consumption_text_pv_yield": "Caricare la batteria durante le ore di picco di produzione per ottimizzare la produzione fotovoltaica. La batteria viene utilizzata quando il solare non è disponibile.",
    "bkup_text": "Il 100% della batteria è riservato per il backup.",
    "reserve": "Riserva",
    "optimization": "Ottimizzazione basata su",
    "utility_rates": "Tariffe di utilità",
    "increase_consumtion": "Aumenta L'autoconsumo a",
    "max_consumption": "Massimizza L'indipendenza Energetica",
    "optimize_pv_production": "Ottimizza la produzione fotovoltaica",
    "activate": "Attiva",
    "active": "Attivo",
    "save": "Salva",
    "edit": "MODIFICA",
    "error": "Impossibile salvare le impostazioni di archiviazione.",
    "requestTakingLonger": "La richiesta sta impiegando più tempo del previsto. Verifica nuovamente più tardi",
    "batterySettingsTakingLonger": "L'aggiornamento delle impostazioni della batteria richiede più tempo del previsto. Verifica nuovamente più tardi",
    "completed": "Impostazioni della batteria aggiornate correttamente.",
    "completedAdvance": "Impostazioni avanzate della batteria aggiornate correttamente.",
    "requestPending": "Richiesta in sospeso. In attesa di conferma dal gateway. Verificare di nuovo più tardi.",
    "editRequest": "Hai una richiesta attiva. Attendi la conferma o annulla la richiesta per procedere con la selezione.",
    "editRequestVls": "Hai una richiesta attiva in Impostazioni avanzate della batteria. Attendi la conferma o annulla la richiesta per procedere con la selezione.",
    "cancelRequest": "La tua richiesta è stata annullata.",
    "updatedSuccesfully": "Aggiornato con successo",
    "pendingRequestText": "Richiesta in corso",
    "cancelRequestText": "Cancella richiesta",
    "pendingText": "In corso",
    "processingText": "Elaborazione in corso",
    "battery_reserve": "dell'energia immagazzinata sarà dedicata alla riserva",
    "cancelFailed": "Impossibile annullare l'attività.",
    "noPendingTask": "Il sistema non ha attività in sospeso da annullare.",
    "noEncharges": "Il sistema non ha le batterie",
    "severeWeatherText": "Guardia della tempesta",
    "disabled": "Disabilitato",
    "enabled": "Abilitato",
    "weatherWatchDescription": "Sovrascrive il profilo della tua batteria con la modalità Backup completo se un viene emesso un avviso di gravi condizioni atmosferiche per la tua località.",
    "disabledModeInfo": "Se abilitato, Enphase comunica con {%s} per rilevare avvisi di condizioni meteorologiche avverse e imposta il profilo della batteria sulla modalità di backup completo per fornire backup durante l'evento. Una volta passato l'evento, il profilo della batteria tornerà alla sua impostazione precedente.",
    "enabledModeInfo": "Enphase comunicherà con {%s} per rilevare avvisi di condizioni meteorologiche avverse e imposterà il profilo della batteria in modalità di backup completo. Dopo l'evento il profilo della batteria tornerà alla sua impostazione precedente.",
    "activeModeInfo": "Enphase ha rilevato un avviso di eventi meteorologici da {%s} e il profilo della batteria è stato impostato sulla modalità di backup completo. Dopo l'ora di fine dell'evento, il profilo della batteria tornerà alla sua impostazione precedente.",
    "stormGuardModeInfo": "Se %{status}, la funzione Protezione temporali monitora gli avvisi di gravi condizioni atmosferiche emessi da %{nws}. Sovrascrive il profilo della tua batteria con la modalità ‘Backup completo’ se viene emesso un avviso per la tua località. Consente di riservare l'intera capacità della batteria per l'uso durante una potenziale interruzione della rete.%{nl}Se viene emesso un avviso per la tua località, viene visualizzato ‘Storm Alert: On’ nella sezione ‘profilo della batteria’ delle pagine Stato e Stato dal vivo.%{nl}Al termine dell'avviso, il profilo della batteria tornerà alle impostazioni precedenti.",
    "editActiveWeatherAlert": "Storm Guard è attivo. Attendere la fine dell'evento (consigliato) o disabilitare il monitoraggio delle condizioni meteorologiche avverse per procedere con la selezione.",
    "enabledToActiveAlert": "Enphase ha rilevato un avviso di eventi meteorologici avversi dal servizio meteorologico nazionale e il profilo della batteria è stato impostato sulla modalità di backup completo. Dopo l'ora di fine dell'evento, il profilo della batteria tornerà alla sua impostazione precedente.",
    "activeToEnabledAlert": "L’evento meteorologico avverso è passato e il profilo della batteria è stato riportato alle impostazioni precedenti.",
    "okayText": "Ok, capito!",
    "disclaimerText": "La funzione Protezione temporali utilizza informazioni provenienti dallo U.S. National Oceanic and Atmospheric Administration o dal servizio meteorologico nazionale, come (a mero titolo esemplificativo) avvisi di condizioni meteorologiche avverse, le cui informazioni sono di dominio pubblico e non sono protette dal diritto d'autore. Enphase non dichiara di possedere o controllare tali informazioni. L’utente accetta espressamente che l'uso di questa funzione è a suo rischio e pericolo. E si assume l'intero rischio legato all'abilitazione di questa funzione e a qualsiasi utilizzo successivo. Enphase fornisce tali informazioni tramite la funzione Protezione temporali 'così come sono' e non riconosce alcuna garanzia, espressa o implicita, inclusa (a mero scopo esemplificativo) qualsiasi garanzia implicita di commerciabilità o idoneità per uno scopo particolare. In nessun caso Enphase sarà responsabile nei confronti dell’utente o di terzi per eventuali danni diretti indiretti, incidentali, consequenziali, speciali o esemplari o profilo perso derivante da qualsiasi uso o uso improprio di questi dati.",
    "disclaimer": "Limitazione di responsabilità",
    "agreeText": "Accetto e continua",
    "disagreeText": "Non sono d’accordo",
    "nationalWeather": "Servizio meteorologico nazionale (NWS)",
    "dataNotAvailable": "NA",
    "errorTitle": "Errore",
    "errorCode": "Codice errore",
    "thresholdError": "Reporting Error",
    "PopupError": "Batteria S.NO",
    "thresholdPopupError": "Nessun report durante l'ultimo ciclo di report? Pertanto, la % di accumulo aggregata esclude la % di accumulo per questa batteria. La batteria dovrebbe iniziare a generare report con il ciclo di report successivo. Si prega di contattare l'assistenza se il problema persiste.",
    "errorPopup1": "sta avendo un problema (Des. errore:",
    "errorPopup2": ", Codice errore:",
    "errorPopup3": "). Questo evento di errore rende inaffidabile la percentuale di accumulo segnalata da questa batteria. Pertanto, la percentuale di accumulo aggregata sopra menzionata esclude la percentuale di accumulo di questa batteria. Si prega di contattare l'assistenza se il problema persiste.",
    "contactSupport": "Contatta l’assistenza",
    "errorSubmitButton": "Ok, ho capito",
    "microinvertorError": "Il microinverter della batteria non è attivo",
    "microinvertorsError": "I microinverter della batteria non sono attivi",
    "touAlert": "La modalità di risparmio funziona solo se la tariffa di importazione dell'elettricità varia con il tempo di utilizzo. Aggiorna la tariffa di importazione dell'elettricità per abilitare questa modalità.",
    "touAlert2": "Impostare la tariffa di importazione dell'elettricità su ToU (Tempo di utilizzo) e il piano della tariffa di importazione su NEM (Consumo energetico netto) per abilitare la modalità di risparmio energetico.%{nl}La modalità Risparmio energetico funziona solo si ha un Consumo energetico netto (NEM) e la tariffa dell'elettricità varia con il Tempo di utilizzo (ToU).",
    "touAlert3": "Impostare la tariffa di importazione dell'elettricità su ToU (Tempo di utilizzo) per abilitare la modalità di risparmio energetico",
    "touAlert4": "Impostare il piano di importazione dell'elettricità per abilitare la modalità di risparmio energetico",
    "updateElectricityRate": "Aggiorna tariffa elettrica",
    "batteryChangeAlert": "Il profilo della batteria è stato modificato in modalità consumo automatico poiché la modalità Risparmio funziona solo se la tariffa di importazione dell'elettricità varia con il tempo di utilizzo.",
    "batteryChangeAlert2": "Il profilo della batteria è stato modificato sulla modalità di autoconsumo perché la modalità Risparmio energetico funziona solo si ha un Consumo energetico netto (NEM) e la tariffa dell'elettricità varia con il Tempo di utilizzo (ToU).",
    "viewDetails": "Visualizza dettagli",
    "ok": "Ok",
    "systemRequest": "Le richieste generate dal sistema non possono essere annullate.",
    "featureDetailsButton": "Storm Guard Feature Details",
    "stormGuardEnablePopUp": "L'attivazione di Storm Guard consente di riservare l'intera capacità della batteria per l'uso durante una potenziale interruzione della rete, sovrascrivendo il profilo della batteria su 'Backup completo' in caso di allerta meteo.",
    "stormGuardDisablePopUp": "La disattivazione di Storm Guard non è consigliata. In caso di avvisi di maltempo, aiuta a rimanere protetti da gravi interruzioni della rete dovute al suddetto.",
    "batterySmartProfile": {
      "title": "Seleziona il profilo della batteria intelligente",
      "description": "Apprendi come scegliere il giusto profilo per il tuo sistema di batteria",
      "viewDetails": "Visualizza dettagli"
    },
    "reserveDisclaimer": "La riserva della batteria non può essere impostata al di sotto del  %{minSoc}%. Nella batteria viene accumulato un minimo del  %{minSoc}% di energia per alimentare i carichi domestici critici durante un'interruzione della rete.",
    "eIpopDesc": "%{enabled}: La batteria si scarica per risparmiare denaro nelle ore di punta quando i prezzi dell'elettricità sono alti. Una volta fatto ciò, verrà data priorità all'indipendenza energetica. Ciò aumenta la tua autonomia energetica fino a raggiungere la carica di carica della batteria. La tua batteria verrà caricata con energia solare al mattino per prepararti al prossimo periodo di punta.%{nl}%{disabled}: La batteria si scarica solo durante le ore di punta quando le tariffe elettriche sono elevate. Durante gli altri periodi, la batteria sarà inattiva o si caricherà dall'energia solare al mattino per prepararsi per il periodo di picco successivo.",
    "errActiveCostSave": "Per utilizzare questa funzione attiva la Modalità Risparmio",
    "eiDescreption": "Indipendenza energetica dopo le ore di punta",
    "advSetting": {
      "cfg": {
        "title": "Caricare la batteria dalla rete",
        "descrDisable": "La tua batteria si ricarica da Solar.",
        "descrEnabled": "La batteria è caricata con energia solare. Può essere ricaricata anche tramite rete quando la batteria è in modalità full backup o quando la carica della batteria scende al di sotto della capacità di riserva in modalità risparmio o autoconsumo.",
        "descrEnabledFR": "La batteria si ricaricherà dalla rete agli intervalli pianificati. Durante questo periodo non si scaricherà.",
        "popUpDescrFR": "%{enabled}: La batteria si ricaricherà dalla rete agli intervalli pianificati. Durante questo periodo non si scaricherà. %{nl}%{disabled}: La batteria si ricarica con l'energia solare.",
        "popUpDescr": "%{enabled}: La batteria è caricata con energia solare. Può essere ricaricata anche tramite rete quando la batteria è in modalità full backup o quando la carica della batteria scende al di sotto della capacità di riserva in modalità risparmio o autoconsumo.%{nl}%{disabled}: La tua batteria si ricarica da Solar.",
        "disclaimer": "L'utilizzo di una fonte di energia non rinnovabile per caricare il sistema di accumulo Enphase può influire sulla tua idoneità all'uso dell'ITC. Per ulteriori informazioni, contattare il proprio consulente fiscale.",
        "dlgTitle": "Caricare dalla rete?",
        "dlgInfo": "Una volta abilitata questa opzione, la batteria si ricaricherà dalla rete agli intervalli pianificati. Durante questo periodo non si scaricherà. Prima di abilitare questa opzione, consultare le normative dell'azienda di servizio.",
        "selfDeclrFR": "Comprendo che la ricarica dalla rete potrebbe violare le normative dell'azienda di servizio.",
        "selectSchedule": "Selezionare la pianificazione per caricare la batteria dalla rete.",
        "titleFR": "Pianifica ricarica dalla rete",
        "saveSch": "Salva pianificazione",
        "chargeSch": "Pianificazione della ricarica",
        "selfDeclr": "Comprendo che la mia idoneità per il credito d'imposta sugli investimenti potrebbe essere compromessa.",
        "disclaimer_itk": "L'utilizzo di una fonte di energia non rinnovabile per modificare il sistema Enphase Storage può influire sull'idoneità a richiedere ITC. Consultare il proprietario per la loro approvazione.",
        "selfDeclr_itk": "Il proprietario riconosce che la capacità di richiedere il credito d'imposta sugli investimenti potrebbe essere compromessa.",
        "activeStormAlert": "L'avviso temporale è attivo per il tuo sistema. Attendi la fine dell'avviso per aggiornare questa impostazione."
      }
    },
    "exM": {
      "title": "Modalità esperto",
      "subTitle1": "Programma i profili della batteria",
      "subTitle2": "Profili batteria programmati",
      "schedule": "Programma",
      "tariffNotSetDlgtitle": "Tariffa energia elettrica non impostata",
      "tariffNotSetDlgContent": "Imposta la tariffa elettronica per abilitare la Modalità risparmio.%{nl}Enphase necessita dei dettagli della tua tariffa per poter determinare la migliore pianificazione per la tua batteria.",
      "setRate": "Imposta la tariffa",
      "tariffUpdateDlgtitle": "Aggiorna la tariffa dell'energia elettrica",
      "tariffUpdateDlgContent": "La modalità di risparmio funziona solo se disponi di un contatore di energia netta (NEM) e la tua tariffa dell'energia elettrica varia in base al tempo di utilizzo (ToU).",
      "updateRate": "Aggiorna la tariffa",
      "setNemDlgTitle": "Tariffa di esportazione dell'energia elettrica non impostata",
      "setNemDlgContent": "Si prega di impostare la tariffa di importazione dell'energia elettrica come NEM per abilitare questa modalità.",
      "setNemCta": "Imposta come NEM",
      "preview": "Anteprima",
      "addBatProfile": "Aggiungi il profilo batteria",
      "pViewPop": {
        "l1": "Il grafico rappresenta i profili della batteria programmati per il periodo di 24 ore.",
        "l2": "La riserva della batteria è applicabile solo per la modalità di autoconsumo e risparmio. Nel backup completo, la riserva della batteria sarà del 100%.",
        "l3": "Massimizza la tua indipendenza energetica ",
        "l4": "Massimizza i tuoi risparmi in base alle tariffe dell'energia elettrica",
        "l5": "Conserva il 100% dell'energia della batteria per il backup",
        "batteryProfiles": "Profili batteria"
      },
      "batReserveDisclaimer": "La riserva della batteria è applicabile solo per la modalità di autoconsumo e risparmio. Nel backup completo, la riserva della batteria sarà del 100%."
    },
    "prfAssist": {
      "t0": "Già nel profilo consigliato",
      "t1": "Noi raccomandiamo",
      "t2": "Modalità risparmio con bassa carica residua della batteria e indipendenza energetica abilitata.",
      "t3": "Modalità risparmio con una bassa carica residua della batteria e indipendenza energetica disabilitata.",
      "t4": "Modalità di autoconsumo con bassa carica residua della batteria.",
      "t5": "Modalità di autoconsumo con una moderata carica residua della batteria.",
      "t6": "Modalità di backup completo.",
      "t7": "Modalità risparmio con una alta carica residua della batteria e indipendenza energetica disabilitata.",
      "t8": "Modalità di autoconsumo con alta carica residua della batteria.",
      "batResText": "Riserva della batteria tra",
      "learnHowEmea": "Ulteriori informazioni sul profilo della batteria",
      "learnHow": "Scopri come funzionano i profili batteria",
      "editPref": "Modifica preferenze",
      "c1": "Risparmiare denaro",
      "c1Sub": "Massimizzare il risparmio sulle bollette mensili",
      "c2": "Indipendenza energetica",
      "c2Sub": "Autoalimentare le utenze domestiche e passare all'ecologico",
      "c3": "Backup",
      "c3Sub": "Backup durante le interruzioni",
      "p1": "Prima priorità",
      "p2": "Seconda priorità",
      "optional": "Opzionale",
      "ques": "Cosa ti aspetti dal sistema Enphase?",
      "priority": "Trascina e rilascia gli obiettivi in ordine dal più importante al meno importante.",
      "ftrpTutorialText": "Seleziona e trascina le schede verso l'alto o verso il basso per disporle secondo la priorità. La prima scheda dall'alto rappresenta la priorità più alta.",
      "updateBatteryProfile": "Aggiorna il profilo della batteria",
      "activatedSavingsMode": "La batteria è attualmente in modalità risparmio con una riserva del %{soc}% e l'indipendenza energetica dopo le ore di punta è %{eiStatus}.",
      "activatedSelfConsumptionMode": "La batteria è attualmente in Autoconsumo con una riserva del %{soc}%.",
      "activatedFullBackupMode": "Il profilo attuale della batteria è Backup completo.",
      "activatedSavingsModeWithoutSoc": "Al momento, tua batteria si trova in Modalità risparmio energetico e l'Indipendenza energetica dopo le ore di picco è di %{eiStatus}.",
      "activatedSelfConsumptionModeWithoutSoc": "Al momento, la batteria si trova nello stato Autoconsumo.",
      "activateProfile": "Attivare il profilo consigliato?"
    }
  },
  "envoy": {
    "all": "Tutti i Gateway",
    "pvAll": "Tutto",
    "dropDwnHelper": "Mostra dati da",
    "envSN": "Num ser Gateway:",
    "reconnect": "Riconnetti il Gateway.",
    "extraContent": "Nel frattempo, se nei nelle vicinanze del tuo sistema, puoi connetterti localmente con il Gateway per visualizzare lo stato corrente.",
    "btnText": "Scopri come connetterti alla rete Wi-Fi del Gateway",
    "getHelp": "Ricollegare il gateway al Wi-Fi di casa",
    "envoyConfirmation": "Collegarsi al gateway tramite modalità AP per procedere.",
    "title": "Abbiamo riscontrato che stai utilizzando Envoy-S o IQ Gateway e il Wi-Fi.",
    "steps": "Segui i passaggi per connettere il gateway alla rete Wi-Fi",
    "steps_ap": "Seguire i passaggi per connettersi alla rete del Gateway",
    "ap_button": "Premere il pulsante della modalità AP",
    "ap_modeDescription": "Premere e rilasciare brevemente (non tenere premuto) il pulsante del menu Gateway sotto l'icona del telefono. Ciò abiliterà la modalità AP sul gateway che crea una rete wireless a cui ci si potrà unire con lo smartphone.",
    "disable_data": "Disattiva Dati mobili",
    "disable_dataDescription": "Disattiva i dati mobili (dati cellulare) dalle impostazioni del tuo dispositivo mobile. Vai su Impostazioni > Dati mobili e disattiva questa impostazione.",
    "envoy_network": "Unisciti alla rete gateway",
    "envoy_description": "Entra nella rete del gateway usando le impostazioni Wi-Fi dello smartphone. Envoy_029655 è il nome della mini-rete a cui ti unirai, dove \"029655\" sono le ultime sei cifre del numero di serie del tuo gateway.",
    "home_wifi": "Collega il gateway al Wi-Fi di casa",
    "wifi_description": "Tocca il pulsante Configura Wi-Fi domestico, seleziona la tua rete e inserisci la password Wi-Fi.",
    "configure_wifi": "Configura il Wi-Fi domestico",
    "cancel": "Annulla",
    "stickyNotification": "Non toccare il pulsante Indietro o scorrere per terminare l'app (puoi ridurla a icona) mentre stai tentando di ricollegare il gateway.",
    "enter_password": "Inserisci la password per",
    "password": "Password",
    "incorrect_password": "Password errata",
    "wifi_failureMsg": "Il gateway non è riuscito a connettersi alla rete Wi-Fi",
    "wifi_successMsg": "Il gateway è connesso correttamente al Wi-Fi",
    "envoyConnectToCellular": "Ora puoi disconnettere il dispositivo mobile dalla rete gateway e connetterlo al Wi-Fi / abilitare i tuoi dati mobili.",
    "envoyToastMessage": "Il gateway è connesso correttamente. Tuttavia, l'aggiornamento dello stato del gateway potrebbe richiedere fino a 30 minuti.",
    "wifi_congratsMsg": "Congratulazioni! Sei tornato online. Ora puoi riconnettere il tuo cellulare alla rete wifi domestica.",
    "tryagain": "Riprova",
    "okay": "OK, capito",
    "failedToFetchWiFiNetworks": "Problema nel recupero delle reti Wi-Fi. Riprova tra un po'.",
    "noWifiNetworkFound": "Nessuna rete Wi-Fi trovata. Riavvia il router Wi-Fi e riprova.",
    "option2": "Se i passaggi indicato sopra non danno risultati, scopri come farlo manualmente",
    "learnhow": "Leer hoe",
    "ensureOn": "Assicurarsi che il gateway sia acceso",
    "connectToPower": "Assicurarsi che il tuo gateway sia collegato a una fonte di alimentazione."
  },
  "whatsnews": {
    "monitorTitle": "Monitor",
    "monitorContent": "Offre una panoramica sintetica sullo stato del sistema, riportando le metriche più importanti in un'unica schermata",
    "trackTitle": "Monitoraggio",
    "trackContent": "Consente di monitorare ed esaminare l'andamento della produzione e del consumo di energia in visualizzazioni giornaliere, mensili, annue o a partire dall'installazione",
    "reportTitle": "Report",
    "reportContent": "Consente di eseguire report sulla produzione e sul consumo di energia dall'app con una frequenza giornaliera, settimanale, mensile o personalizzata (scelta dall'utente)"
  },
  "theme": {
    "instructions": "Schema colori corrente",
    "night": "Notte",
    "day": "Giorno"
  },
  "devices": {
    "model": "Model",
    "dryContactLoads": "Carichi",
    "generator": "Generatore",
    "noDeviceFound": "Durata",
    "searchMicroinverters": "Cerca microinverter SN",
    "serialNumber": "SN",
    "configure": "Configura",
    "connect": "Connetti",
    "envoy": "Gateway",
    "microinverters": "Microinverter",
    "microinverter": "Microinverter",
    "stringInverters": "String Inverter",
    "storage": "Batteria",
    "enpower": "Controller di sistema",
    "skuNumber": "SKU",
    "firmwareVersion": "Firmware",
    "cycleCount": "Conteggio Cicli",
    "cycleCountInfo": "Il conteggio dei cicli per una batteria è il numero totale di cicli completi di carica e scarica. Viene calcolato come energia accumulata totale divisa per la capacità utilizzabile della batteria. Il numero mostrato qui rappresenta il ciclo completato.",
    "status": "Stato",
    "array": "schieramento",
    "help": "Aiuto",
    "not_reporting": "Non segnalare",
    "not_reporting_lowercase": "non segnalare",
    "normal": "Normale",
    "home": "Casa",
    "no_microinverters": "Nessun microinverter trovato",
    "no_storage": "Nessuna memoria trovata",
    "no_envoy": "Nessun gateway trovato",
    "no_enpower": "Nessun controller di sistema trovato",
    "wirelessRangeExtender": "Wireless Range Extender",
    "no_wirelessRangeExtender": "Nessun Wireless Range Extender trovato",
    "lastReported": "Segnalato l'ultima volta",
    "manufacturer": "Nome del produttore",
    "startType": "Tipo di avvio",
    "fuelType": "Tipo di carburante",
    "modelNumber": "Numero del modello",
    "onOffCycles": "Cicli accensione/spegnimento totali",
    "maintainenceInfo": "Informazioni sulla manutenzione",
    "maintainenceSub": "Aggiornare questi dettagli per ricevere notifiche sulla manutenzione del generatore e sulla necessità di rifornimento.",
    "lastMaintainenceDate": "Data ultima manutenzione",
    "lastRefuellingDate": "Data ultimo rifornimento",
    "lastRefuellingTime": "Ora ultimo rifornimento",
    "lastMaintainenceTime": "Ora ultima manutenzione",
    "litresOfFuel": "Liters of fuel filled",
    "additionalInfo": "Per maggiori informazioni",
    "statistics": "Statistiche dall'ultima manutenzione:",
    "timeElapsed": "Tempo trascorso:",
    "cycles": "Cicli accensione/spegnimento:",
    "runningHours": "Tempo di esecuzione:",
    "Days": "giorni",
    "update": "Aggiorna",
    "clickHere": "fare clic qui",
    "savedSuccessfully": "Impostazioni salvate correttamente.",
    "loads": {
      "status": "Stato",
      "smartControl": "Controllo smart",
      "auxillaryContact": "Contatto ausiliario"
    },
    "devicegenerator": {
      "on": "On",
      "off": "Off"
    },
    "connected": {
      "true": "Connesso con il cloud Enphase",
      "false": "Disconnesso dal cloud Enphase"
    },
    "envoyConnected": {
      "wait": "Ricerca del gateway...",
      "true": "Gateway rilevato con successo.",
      "false": "Gateway non rilevato."
    },
    "stepOne": "Connettersi direttamente al gateway. Per fare ciò, premere prima il pulsante di connessione sul gateway.",
    "stepTwo": "Quindi andare alle impostazioni Wi-Fi e connettersi alla rete del gateway:",
    "stepThree": "Una volta stabilita la connessione, tornare a questa schermata. La connessione a Internet sarà interrotta temporaneamente.",
    "connectLocally": "Connetti in locale",
    "connectEnvoy": "Connettersi al gateway usando",
    "connectEnvoyUser": "Nome utente",
    "connectEnvoyPassword": "Password",
    "notAllowAPMode": "Il gateway non supporta la connettività locale.",
    "localEnvoyConnected": {
      "true": "Gateway rilevato con successo",
      "false": "Nessun gateway trovato sulla rete locale",
      "wait": "Attendi..."
    },
    "envoyPwd": {
      "urenvPwd": "La password di accesso",
      "retrivePwd": "Per recuperare la password del gateway:",
      "infoTitle": "Password del gateway",
      "infoDescription": "Avrai bisogno di questa password per riconnettere il  gateway al Wi-Fi. Ciò si verifica in genere quando la password Wi-Fi o il provider di servizi è cambiata.",
      "infoLearnMore": "Clicca qui per saperne di più"
    },
    "ensemble3_0Provisioning": {
      "bleOff": "Attiva il Bluetooth del tuo telefono per connetterti con il tuo IQ Gateway",
      "tryApMode": "Prova la modalità AP",
      "gatewayNotFound": "IQ Gateway non individuabile. Assicurarsi che IQ Gateway sia nelle vicinanze e acceso.",
      "bleNotSupported": "Bluetooth non supportato",
      "bleNotSupportedDesc": "Il Bluetooth non è supportato nel dispositivo in uso. Accertarsi che il dispositivo disponga delle opzioni Bluetooth e Posizione.",
      "bleConnected": "Bluetooth connesso",
      "scanningGateway": "Ricerca di IQ Gateway",
      "fewMints": "Questa operazione potrebbe richiedere alcuni minuti",
      "noWifi": "Nessun dispositivo Wi-Fi trovato",
      "password": "Password",
      "gatewayConnected": "IQ Gateway è connesso correttamente al Wi-Fi.",
      "okGotIt": "Ok, ho capito",
      "noGateway": "IQ Gateway non trovato",
      "gatewayNearByWarning": "Assicurarsi che IQ Gateway sia nelle vicinanze e acceso.",
      "noNetwork": "Nessuna rete",
      "wifiRouterWarning": "Tenere accesso il router Wi-Fi e tenere l'IQ Gateway nella portata del Wi-Fi.",
      "connectionError": "Errore di connessione",
      "turnOn": "Attiva",
      "failedWifiConnect_1": "Impossibile connettersi alla rete Wi-Fi. Per favore ",
      "failedWifiConnect_2": "Contatta l’assistenza",
      "failedWifiConnect_3": " per ricevere aiuto.",
      "failedIQConnect_1": "Impossibile connettersi all'IQ Gateway. Per favore ",
      "failedIQConnect_2": "Contatta l’assistenza",
      "failedIQConnect_3": " per ricevere aiuto.",
      "bleDevices": "Dispositivi Bluetooth",
      "wifiNetworks": "Reti Wi-Fi",
      "connectBle": "Connetti al Bluetooth",
      "gatewayToWifi": "Connessione di IQ™ Gateway al Wi-Fi in corso...",
      "bleStatus": "Controllo dello stato Bluetooth in corso...",
      "searchingWifi": "Ricerca di reti Wi-Fi in corso...",
      "connectingBle": "Connessione al Bluetooth",
      "turnOnBle": "Attiva Bluetooth",
      "tryAgain": "Riprova",
      "wifiSsIdConfigFailedDesc": "Si è verificato un errore sconosciuto durante la connessione alla rete Wi-Fi. Riprovare più tardi o collegarsi a un'altra rete.",
      "wifiCommunicationError": "Errore di comunicazione Wi-Fi",
      "wifiCommunicationErrorDesc": "Impossibile stabilire una connessione con il modulo BLE del gateway IQ. Provare più tardi.",
      "networkNotFound": "Rete non trovata",
      "networkNotFoundDesc": "La rete a cui si sta cercando di connettersi non è stata trovata. Assicurarsi che il router Wi-Fi sia acceso o provare un'altra rete."
    }
  },
  "notification": {
    "offline": "Offline",
    "apmode": "Modalità AP"
  },
  "siteempty": {
    "nosystemassociated": "Attualmente l'account in uso non è associato ad alcun sistema.",
    "systemowner": "L'utente è proprietario dell'impianto Enphase?",
    "contactyourinstaller": "Contattare l'installatore per verificare l'account associato al sistema.",
    "interestedonsystem": "L'utente è interessato a un sistema Enphase?",
    "initiatetransferofwarranty": "Avviare il trasferimento della garanzia nel caso sia stata acquistata una proprietà con un sistema Enphase.",
    "applytransferownership": "È possibile richiedere un trasferimento di proprietà qui.",
    "ownershiptransfer": "Trasferimento proprietà",
    "visita": "Visita una",
    "publicsystempage": "pagina pubblica del sistema",
    "monitoringexperience": "per visualizzare l'esperienza di monitoraggio Enphase."
  },
  "recaptcha": {
    "verification_failed": "Verifica reCAPTCHA non riuscita. Riprovare.",
    "recaptcha_unreachable": "Impossibile verificare la risposta al reCAPTCHA. Riprovare."
  },
  "mobile_app_rating": {
    "enjoying_app": "Ti piace l'app Enphase?",
    "rate_on_play_store": "Valuta la tua esperienza",
    "rate_on_play_store2": "Sul Play Store",
    "rate_us": "Valutaci ora",
    "may_be_next": "Forse la prossima volta"
  },
  "consumptionMtr": {
    "btnText": "Aggiungi misuratore di consumo",
    "infoText": "Il contatore dei consumi ti aiuta a tenere traccia del tuo consumo energetico complessivo"
  },
  "replacement": {
    "microinverter_not_reporting": "microinverter non ivia report.",
    "batteryWarning": 'Può accadere se la comunicazione wireless tra il gateway e la batteria è debole. Può trattarsi di un problema tecnico temporaneo e il sistema dovrebbe riprendersi presto. Se il problema persiste, chiedi assistenza al manutentore.',
    "controllerWarning": 'Può accadere se la comunicazione wireless tra il gateway e il System Controller è debole. Può trattarsi di un problema tecnico temporaneo e il sistema dovrebbe riprendersi presto. Se il problema persiste, chiedi assistenza al manutentore.',
    "batteryError": 'La batteria non sta inviando dati.',
    "controllerError": 'Il System Controller non sta segnalando.',
    "contactMaintainer": 'Contattare il proprio addetto alla manutenzione per assistenza.',
    "systemWarning": 'avviso di sistema',
    "array_details": "Dettagli dell'array",
    "replacement_warranty1": "I",
    "replacement_warranty": "Microinverters are under warranty and eligible for replacement.",
    "shipping_address": "Indirizzo di spedizione",
    "site_address": "Indirizzo del sito",
    "change": "CAMBIA",
    "select_microinverters": "SELEZIONA MICROINVERTER",
    "serial_number": "Cerca il numero seriale",
    "status": "Stato",
    "normal": "Normale",
    "not_reporting": "Mancata segnalazione",
    "submit_request": "Invia la richiesta",
    "dear": "Gentile",
    "replacement_message1": "potrebbe essere necessario contattare l’installatore",
    "replacement_message2": "per eseguire la sostituzione una volta spedito il dispositivo di ricambio. L’installatore potrebbe applicare dei costi per la sostituzione.",
    "request_submitted": "La tua richiesta di reso è stata inviata correttamente.",
    "response_message": "Utilizza l'ID della richiesta per tenere traccia dello stato della sostituzione quando contatti l'assistenza.",
    "request_id": "ID richiesta",
    "ok": "OK, capito",
    "replacement_delivery": "La parte di ricambio verrà consegnata al tuo sito",
    "replacement_delivery_installer": "La parte di ricambio verrà consegnata al tuo installatore locale",
    "installer_address": "INDIRIZZO DELL’INSTALLATORE",
    "understand": "Ho capito",
    "continue_button": "Continua",
    "error_message": "Non riuscito generare l'ID richiesta.",
    "failed_to_fetch": "Impossibile recuperare i microinverter. Riprova",
    "change_address": "Cambia l'indirizzo di spedizione"
  },
  "tariff": {
    "tariff": "Tariffa",
    "tariffNotAdded": "La tariffa non è stata aggiunta",
    "tariffNotSet": "Tariffa non impostata",
    "tariffType": "Tipo di tariffa",
    "buying": "Acquisto",
    "selling": "Vendita",
    "flat": "Importo forfettario",
    "tou": "Tempo di utilizzo",
    "tiered": "A scaglioni",
    "copyFromBuyingTariff": "Copia dalla tariffa d'acquisto",
    "copyFromSellingTariff": "Copia dalla tariffa di vendita",
    "dayBasedTariff": "La tua tariffa varia durante il giorno?",
    "unitsBasedTariff": "La tua tariffa varia in base alle unità consumate?",
    "seasonalTariff": "La tua tariffa varia stagionalmente?",
    "weekendTariff": "La tua tariffa varia nei fine settimana?",
    "baseRateTariff": "Qual è la tariffa base?",
    "flatLabel": "Il costo dell'energia è fisso per tutto il giorno.",
    "touLabel": "Il costo dell'energia varia durante le fasce orarie di punta.",
    "tieredLabel": "Il costo dell'energia varia con l'aumentare del consumo unitario.",
    "rate": "Tariffa",
    "addSeason": "Aggiungi stagione",
    "season": "Stagione",
    "next": "Avanti",
    "noSeasonWeekend": "La tariffa non varia stagionalmente né nei fine settimana.",
    "weekendOnly": "La tariffa varia solo nei fine settimana.",
    "seasonAndWeekend": "La tariffa varia stagionalmente e nei fine settimana.",
    "seasonOnly": "La tariffa varia solo stagionalmente.",
    "infoText": "Informazioni",
    "baseRate": "Tariffa base",
    "remove": "Rimuovi",
    "from": "Da",
    "to": "A",
    "addPeak": "Aggiungi picco",
    "tariffDetails": "Dettagli della tariffa",
    "off-peak": "Fascia oraria non di punta",
    "above": "Sopra",
    "below": "Sotto",
    "between": "Fra",
    "and": "e",
    "weekdays": "giorni della settimana",
    "weekend": "weekend",
    "winter": "Inverno",
    "summer": "Estate",
    "fall": "Autunno",
    "spring": "Primavera",
    "confirmAndSave": "Conferma e Salva",
    "buyingTariff": "Tariffa d'acquisto",
    "sellingTariff": "Tariffa di vendita",
    "edit": "Modifica",
    "offPeak": "Fascia oraria non di punta",
    "peak": "Fascia oraria di punta",
    "period": "Fascia oraria di punta",
    "addTier": "Aggiungi scaglione",
    "tier": "Scaglione",
    "yesLabel": "sì",
    "noLabel": "no",
    "manualConfiguration": "Configurazioni manuali",
    "added": "aggiunto",
    "modified": "modificato",
    "successfully": "con successo",
    "alreadySelected": "è già selezionato",
    "alreadyAdded": "è già stato aggiunto",
    "buyingTariffAdded": "Tariffa d'acquisto aggiunta correttamente",
    "sellingTariffAdded": "Tariffa di vendita aggiunta correttamente",
    "buyingTariffModified": "Tariffa d'acquisto modificata correttamente",
    "sellingTariffModified": "Tariffa di vendita modificata correttamente",
    "buyingTariffReset": "Tariffa d’acquisto ripristinata correttamente",
    "sellingTariffReset": "Tariffa di vendita ripristinata correttamente",
    "reset": "Ripristino",
    "resetConfirmationText": "Sei sicuro di voler ripristinare i dettagli della tariffa?",
    "resetErrorText": "Impossibile ripristinare i dettagli della tariffa",
    "updateErrorText": "Impossibile aggiornare i dettagli della tariffa",
    "tariffErrorText": "Inserimento non valido. Questo valore esiste già nello scaglione ",
    "tierInvalidEntry": "Inserimento non valido. Il valore deve essere maggiore di \"Scaglione 1\"",
    "timeInvalidEntry": "Inserimento non valido. Il valore deve essere maggiore di \"Da\"",
    "invalidValue": "Il valore deve essere maggiore di 0"
  },
  "currency": {
    "currencyEquivalent": "Vedi l'equivalente in valuta dei valori energetici",
    "currencyConversion": "Imposta il fattore di conversione della valuta",
    "currencyInfo": "Il valore monetario riportato è una stima media in quanto non considera le tasse, le commissioni, gli scaglioni, la domanda o il prezzo di utilizzo temporale.",
    "currencyFactor": "Fattore di conversione di valuta",
    "currencyFactorSubtitle": "I dati energetici vengono convertiti nel loro valore equivalente in valuta moltiplicandoli per il fattore di conversione valutaria.",
    "currencyNote": "Nota: Il valore monetario riportato è una stima media in quanto non considera le tasse, le commissioni, gli scaglioni, la domanda o il prezzo di utilizzo temporale.",
    "conversionFactor": "Fattore di conversione",
    "currencyEquivalentHeader": "Equivalente in valuta",
    "energyImported": "Energia importata",
    "energyExported": "Energia esportata",
    "netEnergyImported": "Energia netta importata",
    "netEnergyExported": "Energia netta esportata",
    "currencyConversionHeader": "Conversione di valuta",
    "confirmationMessage": "Desideri continuare senza salvare le modifiche?",
    "confirmationYes": "sì",
    "confirmationNo": "No",
    "invalidInput": "Inserimento non valido"
  },
  "demo": {
    "appDemo": "Demo dell’app",
    "message": "Questa è un'applicazione demo",
    "enphaseInstaller": "Enphase Installer",
    "mainHeader": "Sistema di energia intelligente tutto in uno",
    "subHeader": "Ottieni energia solare e stoccaggio",
    "getStarted": "Per iniziare",
    "appDemoDesc": "Tocca per vedere come funziona un sistema",
    "loginDesc": "Per gli utenti registrati",
    "selectLanguage": "Seleziona la lingua"
  },
  "connectionBandwidth": {
    "low": "Bassa larghezza di banda. Riporta i dati ogni 6 ore",
    "high": "Standard-Bandwidth. Riporta i dati ogni 15 minuti"
  },
  "release_notes": {
    "appUpdateHeading": "Nuovo aggiornamento per l'app Enphase",
    "appUpdateSuccessHeading": "L'app Enphase è stata aggiornata.",
    "later": "Più tardi",
    "updateNow": "Aggiorna ora",
    "update": "Aggiorna",
    "whatsNew": "Ecco le novità",
    "askWhatsNew": "Cosa c'è di nuovo?",
    "new": "Nuovo",
    "version": "Versione",
    "readMore": "Leggi di più"
  },
  "storageCapacity": {
    "availableEnergy": "Energia disponibile",
    "totalStorage": "Accumulo totale",
    "encharge": "IQ Battery",
    "acBattery": "Batteria CA",
    "of": "di",
    "availablePower": "Potenza disponibile",
    "activeMicroinverters": "Microinverter attivi",
    "activeEncharge": "Batteria/e attiva/e",
    "microinverters": "Microinverter"
  },
  "siteImage": {
    'siteImagePopUpHeading': "Carica un'immagine del sito a tua scelta",
    "selectImage": "Seleziona Immagine",
    "imageSizeError": "*La dimensione dell'immagine deve essere inferiore a 5 MB",
    "hide": "Nascondere",
    "apply": "Applica",
    "hideSiteImage": "Nascondi immagine del sito",
    "hideSiteImageDesc1": "L'immagine del sito non verrà visualizzata nella pagina di stato. Puoi modificare la preferenza andando su Menu -> Sistema -> Dettagli sito.",
    "hideSiteImageDesc2": "Vuoi procedere?",
    "uploadSuccessToast": "L'immagine del tuo sito è stata aggiornata correttamente",
    "maxImageLimit": "Puoi caricare fino a quattro immagini per il tuo sito. Elimina un'immagine per aggiungerne una nuova.",
    "okGotIt": "Ok, ho capito!",
    "imageSIzeErrorSiteDetails": "La dimensione dell'immagine deve essere inferiore a 5 MB. Carica un'immagine diversa.",
    "apiError": "Impossibile completare la richiesta. Per favore riprova più tardi",
    "displayOnStatusPage": "Visualizzazione nella pagina di stato",
    "displayOnStatusPageWarning": "Sei sicuro di voler aggiornare l'immagine nella pagina Stato?",
    "displayOnStatusPageNote": "Nota: l'immagine verrà regolata automaticamente per la visualizzazione. Puoi sempre regolarlo nuovamente nella pagina Stato",
    "deleteSiteImage": "Elimina immagine",
    "deleteSiteImageWarning": "Sei sicuro di voler eliminare l'immagine?",
    "imageDeleteSuccess": "L'immagine è stata eliminata correttamente",
    "imageUploadSuccess": "L'immagine è stata caricata correttamente",
    "imageUploadSuccessStatusPage": "Immagine aggiornata con successo nella pagina di stato",
    "displayedOnStatusPage": "Visualizzato nella pagina di stato",
    "uploadImage": "Carica immagine",
    "imagePreferenceSaved": "La preferenza per l'immagine del tuo sito è stata salvata",
    "siteImage": "Immagine del sito",
    "statusPageMaxImagePopUpDesc1": "Puoi caricare fino a quattro immagini per il tuo sito. Elimina un'immagine da ",
    "statusPageMaxImagePopUpDesc2": " per aggiungerne una nuova qui",
    "addSiteImage": "AGGIUNGI IMMAGINE DEL SITO",
    "wrongFileType": "Carica solo un'immagine JPEG o PNG"
  },
  "nps": {
    "question": "Com’è la tua esperienza con noi?",
    "description": "Sulla base della tua recente esperienza con Enphase, con quale probabilità consiglieresti Enphase a un amico o un collega?",
    "dontAskAgain": "Non chiedermelo più",
    "notNow": "Non ora",
    "notLikely": "Probabilmente no",
    "mostLikely": "Molto probabilmente",
    "confirmationHeader": "Grazie per la tua risposta! Aiutaci a capire meglio la tua risposta.",
    "surveyButton": "Partecipa a un sondaggio di 2 minuti",
    "notInterested": "Non sono interessato",
    "survey": "Sondaggio",
    "internetError": "Controlla la tua connessione Internet e prova di nuovo.",
    "rateEnphaseTitle": "Valuta Enphase",
    "rateEnphaseDescription": "Con quale probabilità consiglieresti Enphase a un amico o un collega?",
    "rateInstallerTitle": "Valuta il tuo installatore",
    "rateInstallerDescription1": "Con quale probabilità consiglieresti",
    "rateInstallerDescription2": "al tuo amico o collega?",
    "feedbackSuccess": "Grazie per il tuo prezioso feedback.",
    "ratingSuccess": "Grazie per il tuo feedback.",
    "feedbackEnphaseTitle": "Il tuo punteggio Enphase",
    "feedbackInstallerTitle": "La tua valutazione dell'installatore",
    "detractors": "Cosa potremmo fare di meglio?",
    "passive": "Cosa potremmo fare per migliorare la tua esperienza?",
    "promoters": "Aiutaci spiegando il tuo punteggio?",
    "legalDisclaimer": "Il tuo nome e il tuo feedback/commenti saranno condivisi con gli installatori."
  },
  "liveStatus": {
    "title": "Stato in tempo reale",
    "subTitle": "Visualizza la potenza in tempo reale",
    "offlineMsg": "Use LIVE STATUS when Offline",
    "streamingLocally": "Streaming locale dal gateway",
    "closingMinutes": "Chiusura in",
    "cfgMsg": "Le batterie possono essere caricate dalla rete perché hai abilitato l'impostazione %{cfglink}.",
    "learn": "Imparare",
    "pvOnlyCta": "%{learn} Come puoi ottimizzare e monitorare il tuo consumo di energia utilizzando la misurazione del consumo",
    "cfgFiller": "Caricare la batteria dalla rete",
    "cfgVls": "Le batterie potrebbero ricaricarsi tramite la rete in quanto la loro carica è inferiore al livello di spegnimento.",
    "solar": {
      "title": "Solare",
      "producing": "Produzione",
      "energyProducing": "Produzione di energia"
    },
    "home": {
      "title": "Home",
      "consuming": "Consumo",
      "energyConsuming": "Consumo di energia"
    },
    "grid": {
      "title": "Rete",
      "gridConnectivity": "Connettività alla rete",
      "waiting": "In attesa di informazioni",
      "unknown": "Stato della rete sconosciuto",
      "notAvailable": "Rete non disponibile",
      "systemConnected": "Il sistema è in rete",
      "notSystemConnected": "Il sistema è fuori rete",
      "outage": "Grid Outage",
      "updating": "Aggiornamento dello stato della rete",
      "exporting": "Esportazione",
      "importing": "Importazione",
      "notConnected": "Non Connesso",
      "offGrid": "Non in rete",
      "onGrid": "In rete",
      "goOnGrid": "Vai in rete",
      "goOffGridDisabled": "Fuori rete non consentito",
      "goOffGrid": "Vai fuori rete",
      "gridUpdatingMessage": "La conferma dello stato della rete richiede più tempo del previsto. Controlla più tardi.",
      "gridConnectedMessage": "il sistema è ora connesso alla rete",
      "gridDisconnectedMessage": "il sistema è ora disconnesso dalla rete",
      "disconnectingGrid": "Disconnessione dalla rete...",
      "connectingGrid": "Connessione alla rete...",
      "unableToConnect": "Impossibile connettersi con il gateway",
      "initialisingOnGrid": "Inizializzazione del controllo rete...",
      "gridOutage": "Sistema fuori rete a causa di un'interruzione della rete",
      "gridOutageToastAuto": "Non è possibile passare in rete a causa di un'interruzione della rete. Quando sarà stata ripristinata l'alimentazione, il sistema si riconnetterà alla rete",
      "gridOutageToastUser": "Non è possibile passare in rete a causa di un'interruzione della rete. Sarà possibile controllare la connessione della rete quando la rete sarà disponibile"
    },
    "generator": {
      "title": "Generatore",
      "onGenerator": "Generatore attivato",
      "offGenerator": "Generatore disattivato",
      "unknown": "Stato del generatore sconosciuto",
      "notConnected": "Non Connesso",
      "genDisconnecting": "Disconnecting...",
      "waiting": "Aggiornamento in corso",
      "updating": "Ordina ora"
    },
    "fuelCell": {
      "title": "Cella a combustibile",
      "on": "Cella a combustibile attiva",
      "off": "Cella a combustibile disattivata",
      "warmingUp": "Riscaldamento cella a combustibile",
      "coolDown": "Raffreddamento cella a combustibile",
      "unknown": "Stato cella a combustibile sconosciuto",
      "notConnected": "Non connessa",
      "genDisconnecting": "Disconnessione...",
      "waiting": "In attesa",
      "updating": "Aggiornamento in corso"
    },
    "systemNotReporting": {
      "title": "Il System Controller non sta segnalando",
      "subTitle": "Non siamo in grado di mostrare i dati dal vivo perché il tuo System Controller non sta segnalando al Gateway. Può trattarsi di un problema tecnico temporaneo e il sistema dovrebbe riprendersi presto."
    },
    "envoy": {
      "connecting": "Connessione al gateway...",
      "connectingToOjas": "Connecting to Portable Energy System...",
      "notAbleToConnect": "Impossibile connettersi",
      "notAbleToConnectMultiEnv": "Impossibile connettersi al gateway SN:",
      "negativeConsumptionTitle": "Errore di comunicazione",
      "negativeConsumptionDesc": "Non è possibile completare lo stato in tempo reale per la perdita di comunicazione tra i dispositivi. Può trattarsi di un problema tecnico temporaneo e il sistema dovrebbe riprendersi presto"
    },
    "onDifferentNetwork": "Il gateway e questo dispositivo sono su una rete diversa",
    "connectOnSameNetworkorAPMode": "Connetti il Gateway e il dispositivo alla stessa rete oppure abilita la modalità AP sul Gateway per connettere questo dispositivo alla rete Wi-Fi %{ssid}",
    "connectOnSameNetwork": "Collega questo dispositivo alla rete Wi-Fi %{ssid} quindi riprova a visualizzare lo stato live in modalità fuori linea.",
    "apModeTutorial": "Tutorial sulla modalità AP",
    "apMT1": "Premere e rilasciare (senza tenere premuto) il ",
    "apMT2": "pulsante della modalità AP",
    "apMT3": " finché il LED della modalità AP (",
    "apMT4": ") diventa verde fisso. Il gateway rimarrà in modalità AP per otto ore."
  },
  "desktop": {
    "status": {
      "power": "Energia",
      "energy": "Energia",
      "solarEquivalent": "Equivalente solare",
      "dataUnavailable": "I dati non sono disponibili"
    },
    "array": {
      "title": "schieramento",
      "totalProduced": "Produzione totale",
      "totalConsumed": "Consumo totale",
      "lifetimeProduced": "Produzione totale durante la vita utile",
      "lifetimeConsumed": "Consumo nella vita",
      "status": "Stato",
      "azimuth": "Azimuth",
      "tilt": "Incli",
      "microinverter": "Microinverter"
    },
    "energy": {
      "totalEnergy": "Energia totale",
      "graphControls": "Controlli del grafico"
    },
    "header": {
      "switchToClassic": "Passa alla visualizzazione classica"
    },
    "footer": {
      "change": "Modifica",
      "changeSite": "cambia sito",
      "copyRightsText": "©2008-%{currYear} Enphase Energy Inc. Tutti i diritti riservati.",
      "privacyText": "Privacy",
      "termsText": "Condizioni",
      "weatherCompany": "The Weather Company",
      "weatherDataText": "Dati meteorologici forniti da"
    }
  },
  "customPeriod": {
    "dialogLabel": "Visualizza in base a",
    "billingCycle": "Ciclo di fatturazione",
    "billingLabel": "Abbina il grafico energetico al tuo ciclo di fatturazione",
    "billingLabelStatusPage": "Periodo di tempo da qualsiasi data di inizio selezionata e per la durata selezionata",
    "startDate": "Data di inizio fatturazione",
    "frequency": "Frequenza di fatturazione",
    "months": "Mesi",
    "days": "Giorni",
    "every": "Ogni",
    "customDate": "Intervallo di date personalizzato",
    "customDateLabel": "Seleziona un intervallo di date personalizzato per visualizzarlo sul grafico dell'energia",
    "customRange": "Seleziona un intervallo di date compreso tra 1 e 100 giorni"
  },
  "systemEstimator": {
    "heading": "Strumento di stima del sistema",
    "exitConfirmation": "Sei sicuro di voler chiudere il flusso Aggiungi memoria?",
    "resumeButton": "Riprendere",
    "systemAccess": "Ottieni accesso al sistema",
    "statusAddStorage": "to avoid blackouts",
    "addStorageLeadInfo": "visualizza lo stato",
    "postLoginWoSiteTitle": "Scopri l'unico sistema solare e di accumulo all-in-one",
    "videoCTABtn": "Guarda un video",
    "addStorageTitle": "Ottieni un nuovo sistema Enphase",
    "orderNowBtn": "Ordina adesso"
  },
  "sgipIncentive": {
    "gotItButton": "Ho capito",
    "exitButton": "Esci",
    "dontExitButton": "Non uscire",
    "sgipPaymentNotDone": "La tua applicazione SGIP è incompleta. Desideri abbandonare senza completare la richiesta?",
    "sgipPaymentDone": "Puoi tornare in qualsiasi momento per verificare lo stato della tua richiesta SGIP",
    "sgipApplyAlert": "Gli incentivi SGIP sono applicabili solo ai sistemi installati in California. Se si ha già un'attivazione del sistema in corso in California, chiedere all'installatore di avviare il processo di creazione del sito nella sua applicazione Enphase.",
    "sgipGetStorage": "Ottieni un nuovo sistema di accumulo Enphase"
  },
  "gridBatteryChange": {
    "gridTag": "G",
    "batteryTag": "B",
    "gridChangeDesc": "Lo stato della griglia è cambiato in",
    "gridOn": "On Grid",
    "gridOff": "Non in rete",
    "batteryChangeDesc": "Profilo batteria modificato in",
    "costSavings": "Risparmi",
    "selfConsumption": "Autoconsumo",
    "savingsMode": "Modalità risparmio",
    "backupOnly": "Solo backup",
    "stormGuardDesc": "Protezione temporale è",
    "alertIssued": " avviso emesso",
    "alertHasEnded": " avviso terminato"
  },
  "liveVitalStats": (_liveVitalStats = {
    "normal": "Normale",
    "unknown": "Sconosciuto",
    "undefined": "Non definito",
    "loads": "Controllo del carico",
    "loadsInfoPart1": "I carichi sono mappati come ",
    "loadsInfoPart2": "Contatti ausiliari controller di sistema",
    "loadsInfoPart3": " da chi si occupa dell’installazione. Per configurarli, vai nelle ",
    "loadsInfoPart4": "Impostazioni di sistema.",
    "powered": "Alimentato",
    "invalidState": "Stato non valido",
    "viewMore": "Vedi di più",
    "viewLess": "Vedi di meno",
    "ECA_BAT_IDLE": "Inattivo",
    "ECA_BAT_CHARGING": "Caricamento",
    "ECA_BAT_DISCHARGING": "Scaricamento",
    "MAX_ECA_BAT_STATE": "Sconosciuto",
    "systemIsOnGrid": "Il sistema è in rete",
    "systemIsOffGrid": "Il sistema è fuori rete",
    "infoIsOnGrid": "Il sistema sta operando in modalità di connessione alla rete.",
    "infoIsOffGrid": "Il sistema sta operando in modalità microrete.",
    "wiredCANConn": "Connessione CAN cablata",
    "infoWiredCAN": "IQ System Controller comunica con il gateway IQ tramite connessione cablata. L'icona indica se è connesso e sta comunicando o meno con il gateway.",
    "infoIsOffGridAvailable": "Il sistema sta operando in modalità microrete. Tuttavia la rete è disponibile e puoi scegliere di passare alla modalità In rete in qualsiasi momento.",
    "voltageL1": {
      "val": "Tensione L1",
      "info": "La tensione tra la Linea 1 (L1) e Neutra."
    },
    "voltageL2": {
      "val": "Tensione L2",
      "info": "La tensione tra la Linea 2 (L2) e Neutra."
    },
    "voltageL3": {
      "val": "Tensione L3",
      "info": "La tensione tra la Linea 3 (L3) e Neutra."
    },
    "voltage": {
      "val": "Tensione",
      "info": "La tensione tra la Linea 1 (L1) e Neutra."
    },
    "frequency": {
      "val": "Frequenza",
      "info": "La frequenza della corrente alternata (CA) nominale."
    },
    "gridParameters": "Parametri della rete dell'utenza domestica",
    "auxiliaryContactsParameters": "Controllo del carico",
    "infoauxiliaryContactsParam": 'Il controller di sistema ha quattro contatti ausiliari per il controllo del carico. Il nome del carico indica che il contatto corrispondente è mappato a quel carico. Per i contatti non mappati ad alcun carico, viene visualizzato "Non in uso".',
    "infoGridParam": "La tensione e la frequenza della rete vengono misurati sul lato dell'utenza domestica del dispositivo di interconnessione alla microrete (MID). Se la rete non è disponibile, la tensione e la frequenza della rete è pari a 0.",
    "microgridParameters": "Parametri della microrete",
    "infoMicrogridParam": "La tensione e la frequenza della microrete vengono misurati sul lato di caricamento del dispositivo di interconnessione alla microrete (MID). Se il MID è aperto, vuole dire che il sistema è in modalità Fuori rete / Microrete.",
    "generatorParameters": "Parametri del generatore",
    "infoGeneratorParam": "La tensione e la frequenza del generatore vengono misurati sul lato di caricamento del dispositivo di interconnessione al generatore (GID). Se il GID è chiuso, vuole dire che il sistema è in modalità Fuori rete / Microrete.",
    "infoEnpower": "IQ System Controller",
    "zigbeeSignal": "dBm",
    "commSignal": "Segnale di comunicazione",
    "infoZigbeeSignal": "Rappresenta la forza della comunicazione wireless a 2,4 GHz con il gateway. Più barre o un valore dBm più alto rappresenta una maggiore potenza del segnale.",
    "commStatus": "Stato della comunicazione",
    "infoCommSignal": "SEGNALE DI COMUNICAZIONE",
    "usbConnection": "USB Connection",
    "infoUsbSignal": "IQ System Controller comunica con IQ Gateway tramite connessione USB. L'icona indica se è connesso e sta comunicando o meno con il Gateway tramite USB.",
    "commStatusDesc": "IQ Battery comunica con IQ System Controller tramite una connessione cablata. L'icona indica se IQ Battery è connesso e sta comunicando con IQ System Controller o meno.",
    "ENCMN_STATE_UNKNOWN": {
      "val": "Sconosciuto"
    },
    "ENCMN_STATE_MISSING": {
      "val": "Errore comunicazione 2.4 GHz"
    },
    "ENCMN_STATE_DISCOVERED": {
      "val": "2.4 GHz pairing"
    },
    "ENCMN_STATE_CONNECTED": {
      "val": "Associazione 2.4 GHz completata"
    },
    "ENCMN_STATE_INV_DONE": {
      "val": "Recupero informazioni dispositivo completato"
    },
    "ENPWR_STATE_GRIDMODE_WAIT": {
      "val": "In attesa che le batterie riconoscano lo stato della rete"
    },
    "ENPWR_STATE_GRIDMODE_CONFIRM": {
      "val": "Comando del controller di sistema per chiudere il relè EC1"
    },
    "ENPWR_STATE_RELAY_CTRL_WAIT": {
      "val": "Sconosciuto"
    },
    "ENPWR_STATE_GRID_PROFILE_UPD": {
      "val": "Avvio aggiornamento profilo rete"
    },
    "ENPWR_STATE_GRID_PROFILE_SET": {
      "val": "Aggiornamento profilo rete in corso"
    },
    "ENPWR_STATE_GRID_PROFILE_END": {
      "val": "Aggiornamento profilo rete terminato"
    },
    "ENPWR_STATE_RELAY_QUERY": {
      "val": "Recupero degli stati del relè del controller di sistema dopo l'inizializzazione"
    },
    "ENPWR_STATE_OPER_SELECTOR": {
      "val": "Interpretazione degli stati dei relè del controller di sistema"
    },
    "ENPWR_STATE_OPER_NO_GRID": {
      "val": "Il controller di sistema è fuori rete"
    },
    "ENPWR_STATE_OPER_OPEN_AC_PRESENT": {
      "val": "Il controller di sistema è fuori rete. La rete è disponibile"
    },
    "ENPWR_STATE_OPER_SYNC_READY": {
      "val": "La microrete è sincronizzata con la rete. Pronto per passare alla modalità In rete"
    },
    "ENPWR_STATE_OPER_CLOSED": {
      "val": "Il controller di sistema è in rete"
    },
    "ENPWR_STATE_GOING_ON_GRID": {
      "val": "Comandare al controller di sistema di andare in rete"
    },
    "ENPWR_STATE_PREPARE_FOR_OFF_GRID": {
      "val": "Preparazione all'esecuzione del comando dell'utente di entrare in modalità Fuori rete"
    },
    "ENPWR_STATE_GOING_OFF_GRID": {
      "val": "Comandare al controller di sistema di andare fuori rete"
    },
    "ENPWR_STATE_OPER_CLOSED_INIT": {
      "val": "System Controller è in rete. Rilevamento delle batterie."
    },
    "ENCMN_STATE_MAX": {
      "val": "Sconosciuto"
    },
    "ENCMN_STATE_CONNECTED_NO_PCU": {
      "val": "No micros detected"
    },
    "ENCHG_STATE_READY": {
      "val": "La batteria è operativa"
    },
    "ENCHG_STATE_GRIDMODE_UPD": {
      "val": "Invio della modalità Rete su batteria"
    },
    "ENCHG_STATE_BACKUP_SOC_UPD": {
      "val": "Aggiornamento del limite dello stato di carica (SoC, State of Charge) di riserva sulla batteria"
    },
    "ENCHG_STATE_GRID_PROFILE_UPD": {
      "val": "Avvio aggiornamento profilo rete"
    },
    "ENCHG_STATE_GRID_PROFILE_SET": {
      "val": "Aggiornamento profilo rete in corso"
    },
    "ENCHG_STATE_GRID_PROFILE_END": {
      "val": "Aggiornamento profilo rete terminato"
    },
    "ENCHG_STATE_INVENTORY": {
      "val": "Recupero di informazioni hardware e software dalla batteria"
    },
    "ST_NOP": {
      "val": "Sconosciuto"
    },
    "ENPWR_STATE_OPER_GEN_CLOSING_INIT": {
      "val": "Il controller di sistema è fuori rete. Collegamento al generatore."
    },
    "ENPWR_STATE_OPER_GEN_CLOSE": {
      "val": "Il controller di sistema è fuori rete. Generatore collegato."
    },
    "ENPWR_STATE_OPER_GEN_OPENING_INIT": {
      "val": "Il controller di sistema è fuori rete. Scollegamento del generatore."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_EC1": {
      "val": "EC1 chiuso. Test relè completato."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_EC1": {
      "val": "EC1 Aperto. Test relè in corso."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_GEN": {
      "val": "Relè GEN chiuso. Test relè completato."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_GEN": {
      "val": "Relè GEN aperto. Test relè in corso."
    },
    "default": {
      "val": "Sconosciuto"
    },
    "controlState": "Stato del controllo",
    "CHECK_BUSES": {
      "val": "Verifica dei bus e dei relè",
      "info": "Il controller di sistema è stato ripristinato. Convalida dei parametri di sistema prima di passare a uno stato di rete diverso."
    },
    "CYCLE_RELAYS": {
      "val": "Ciclo dei relè",
      "info": "Il sistema sta ciclando i relè del controller di sistema per convalidare se le condizioni di errore del relè sono state cancellate."
    },
    "GRID_CONNECT": {
      "val": "Connessione alla rete",
      "info": "Il sistema si sta connettendo alla rete dopo il ripristino del controller di sistema."
    },
    "EC1_EC2_CONNECT": {
      "val": "Batterie collegate. Collegamento NFT",
      "info": "Il tuo sistema sta passando alla microrete. Le batterie sono collegate. Il Il trasformatore di formazione neutra (NFT, Neutral Forming Transformer) è in fase di collegamento."
    },
    "GRID_OP_WAIT_FOR_ENVOY": {
      "val": "In rete. Collegamento delle batterie",
      "info": "Il sistema è in rete. Le batterie sono in fase di collegamento."
    },
    "GRID_OP_FULL": {
      "val": "In rete",
      "info": "Il tuo sistema sta operando in modalità di connessione alla rete."
    },
    "MICROGRID_OK_NO_GENERATOR": {
      "val": "Fuori rete",
      "info": "Il tuo sistema sta operando in modalità microrete."
    },
    "SYNC_TO_GRID": {
      "val": "Sincronizzazione con la rete",
      "info": "Il tuo sistema sta passando dalla microrete alla modalità In rete."
    },
    "MICROGRID_REGULATORY_SHUTDOWN": {
      "val": "Errore microrete",
      "info": "La microrete è collassata a causa di un sovraccarico o di un errore del sistema. Il sistema verrà ripristinato presto."
    },
    "MANUFACTURING_MODE": {
      "val": "Modalità di produzione",
      "info": "Ti preghiamo di contattare l'assistenza clienti."
    },
    "RESET": {
      "val": "Ripristino del controller di sistema",
      "info": "Il controller di sistema è stato ripristinato. Il sistema si ripristinerà presto."
    },
    "GRID_OP_OPEN_NFT": {
      "val": "In rete. Apertura dell'NFT",
      "info": "Il tuo sistema è in rete. Il Trasformatore di formazione del neutro (NFT) è in fase di disconnessione."
    },
    "MANUAL_OVERRIDE": {
      "val": "Sostituzione manuale attivata",
      "info": "Hai chiuso manualmente il dispositivo di interconnessione alla microrete (MID) per accedere alla modalità In rete. Se si è trattato di un errore, sei pregato di contattare l'assistenza."
    },
    "RAPID_SHUTDOWN_STATE": {
      "val": "Rapid Shutdown State"
    },
    "UNKNOWN": {
      "val": "Sconosciuto",
      "info": "Ti preghiamo di contattare l'assistenza clienti."
    },
    "ECA_RELAY_OPEN_AC_GRID_SYNCHED": {
      "val": "Sincronizzato e connesso alla rete"
    },
    "infoControlState": "Stati di controllo",
    "faults": "Errore controller di sistema",
    "MID_FUSED": "Il sistema non può passare alla modalità microrete perché il MID è bloccato in posizione aperta.",
    "EC1_FUSED": {
      "ES1": "Both IQ Battery L1 and L2 relays are stuck closed.",
      "ES2": {
        "NO_BATT-PV": "Both PV L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ8 PV L1 and L2 relays are stuck closed",
        "BATT-NO_PV": ""
      }
    },
    "EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery L1 and L2 relays are stuck closed"
      }
    },
    "EC1_EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Both IQ Battery and IQ8 PV, L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery and PV, L1 and L2 relays are stuck closed"
      }
    },
    "NFT_FUSED": "I relè NFT (Trasformatore di formazione del neutro) sono bloccati in posizione chiusa.",
    "NFT_OPEN": "Il sistema non può passare alla modalità microrete perché il Trasformatore di formazione del neutro (NFT) è bloccato in posizione aperta.",
    "MID_OPEN": "Il sistema non può passare alla modalità di connessione alla rete perché il MID è bloccato in posizione aperta.",
    "EC1_OPEN": {
      "ES1": "Your system cannot transition to the microgrid mode as one or both the IQ Battery L1 and L2 relays are stuck open.",
      "ES2": {
        "NO_BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the PV L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot use IQ8 PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot use PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode"
      }
    },
    "EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as one or both of the IQ Battery L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot reliably transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open. Only IQ8 PV will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open"
      }
    },
    "EC1_EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as IQ8 PV, L1 and L2 relays are stuck open",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as PV L1 and L2 relays are stuck open"
      }
    },
    "I2C_INIT": "Il sistema non è operativo. La scheda ATS (Automatic Transfer Switch) del controller di sistema è guasta.",
    "ADC_INIT": "Il sistema non è operativo. La scheda ATS (Automatic Transfer Switch) del controller di sistema è guasta.",
    "I2C_COMM": "Il sistema non è operativo. La scheda ATS (Automatic Transfer Switch) del controller di sistema è guasta.",
    "NFT_TEMP": "Il sistema non è operativo. Il Trasformatore di formatura neutra (NFT, Neutral Forming Transformer) del controller di sistema ha superato i limiti di temperatura.",
    "ATS_TEMP": "Il sistema non è operativo. La scheda ATS (Automatic Transfer Switch) del controller di sistema ha superato i limiti di temperatura.",
    "E3_TEMP": "Il sistema non è operativo. La scheda del controller del sistema ha superato i limiti di temperatura.",
    "CRC_MISMATCH": "Il sistema non è operativo. La scheda del controller di sistema non è stata inizializzata.",
    "V_IMBALANCE": "Il sistema non può passare alla modalità microrete. Uno squilibrio di tensione tra L1 e L2 ha provocato uno scatto.",
    "MANUAL_OVR": "Il sistema è in modalità di connessione alla rete a causa dell'esclusione manuale del controller di sistema.",
    "GEN_CONN_OPEN_NFT": 'Your system is connected to the Generator. The Neutral Forming Transformer (NFT) is being disconnected.',
    "MANUAL_BACKSTART": 'Your system is trying to blackstart in off grid mode.',
    "BACKSTART_FAILED": 'Your system could not blackstart in off grid mode. It will reattempt blackstart.',
    "GRID_TIED": 'Your system is in Grid Tied mode.',
    "MID": {
      "val": "MID",
      "info": "Il dispositivo di interconnessione alla microrete (MID) connette (se chiuso) o disconnette (se aperto) la tua casa dalla rete dell'utenza domestica."
    },
    "DER_L1": {
      "val": "DER L1",
      "info": "Il relè DER (Risorsa energetica distribuita) DER L1, se chiuso, connette gli Encharge e il PV rispettivamente sulle linee 1 o 2 di casa"
    },
    "DER_L2": {
      "val": "DER L2"
    },
    "DER_L3": {
      "val": "DER L3"
    },
    "DER_1": {
      "val": "DER 1"
    },
    "DER_N": {
      "val": "DER N"
    },
    "EC1_L1": {
      "val": "EC1 L1",
      "info": "I relè EC1 L1 e L2 quando sono chiusi collegano le batterie o IQ8 PV ai carichi domestici. Funzionano da linea a linea e non hanno un neutro."
    },
    "EC1_L2": {
      "val": "EC1 L2"
    },
    "ENCHARGE_L1L2": {
      "val": "IQ Battery L1, L2",
      "info": "I relè L1 e L2 di IQ Battery, se chiusi, connettono le batterie ai carichi domestici. Operano linea per linea e non dispongono del neutro."
    },
    "PV_L1L2": {
      "val": "PV L1, L2",
      "info": "Se chiusi, i relè FV L1 e L2 collegano i sistemi FV IQ8 ai carichi domestici. Funzionano line-to-line e non hanno un neutro."
    },
    "PV_L1_L2": {
      "val": "PV L1, L2",
      "info": "Se chiusi, i relè FV L1 e L2 collegano i sistemi FV IQ ai carichi domestici. Funzionano line-to-line e non hanno un neutro."
    },
    "DER_L1_L2": {
      "val": "DER L1, L2",
      "info": "DER L1 and L2 relays when closed connects your batteries or IQ PV to your home loads. They operate line to line and do not have a neutral."
    },
    "ENCHARGE_L1": {
      "val": "IQ Battery L1"
    },
    "ENCHARGE_L2": {
      "val": "IQ Battery L2"
    },
    "PV_L1": {
      "val": "PV L1"
    },
    "PV_L2": {
      "val": "PV L2"
    },
    "NFT_L1": {
      "val": "NFT L1",
      "info": "NFT è il Trasformatore di formazione del neutro. Assicura che il tuo sistema possa funzionare in modalità Fuori rete. Il relè NFT L1, se chiuso, alimenta il tuo NFT. Il relè NFT N connette il neutro dall'NFT al tuo carico domestico."
    },
    "NFT_N": {
      "val": "NFT N"
    },
    "GID_L1": {
      "val": "GID L1",
      "info": "I relè GID L1 e L2, se chiusi, connettono il generatore ai carichi domestici."
    },
    "GID_L2": {
      "val": "GID L2"
    },
    "NFT_L2": {
      "val": "NFT L2",
      "info": "NFT è il Trasformatore di formazione del neutro. Assicura che il tuo sistema possa funzionare in modalità Fuori rete. Il relè NFT L2, se chiuso, alimenta il tuo NFT. Il relè NFT N connette il neutro dall'NFT al tuo carico domestico."
    },
    "DER1_L1": {
      "val": "DER1 L1",
      "info": "I relè DER1 L1 e L2 quando sono chiusi collegano le batterie o IQ8 PV ai carichi domestici. Funzionano da linea a linea e non hanno un neutro."
    },
    "DER1_L2": {
      "val": "DER1 L2"
    },
    "DER2_L1": {
      "val": "DER2 L1",
      "info": "I relè DER2 L1 e L2, se chiusi, connettono IQ8 PV ai carichi domestici. Operano linea per linea e non dispongono del neutro."
    },
    "DER2_L2": {
      "val": "DER2 L2"
    },
    "dryContact": {
      "val": "NC1, NC2, NO1, NO2",
      "info": "Questi relè, quando chiusi, collegano i tuoi carichi alla fonte di alimentazione"
    },
    "DER_L1_L2_L3_N": {
      "val": "DER L1, L2, L3, N",
      "info": "I relè DER (risorsa energetica distribuita) DER L1, DER L2, DER L3 e DER N, se chiusi, connettono IQ Battery e IQ Microinverter rispettivamente sulle linee 1, 2 o 3 e neutra della casa."
    },
    "DER_L1_L2_N": {
      "val": "DER L1, L2, N",
      "info": "I relè DER (risorsa energetica distribuita) DER L1, DER L2 o DER N, se chiusi, connettono IQ Battery e IQ Microinverter sulle linee 1, 2 e neutra della casa."
    },
    "DER_1_N": {
      "val": "DER 1, N",
      "info": "I relè DER (risorsa energetica distribuita) DER L1 e DER N, se chiusi, connettono IQ Battery e IQ Microinverter rispettivamente sulle linee 1 e neutra della casa."
    },
    "open": "Aperto",
    "closed": "Chiuso"
  }, _defineProperty(_liveVitalStats, "powered", "Alimentato"), _defineProperty(_liveVitalStats, "notPowered", "Non alimentato"), _defineProperty(_liveVitalStats, "niu", "Non in uso"), _defineProperty(_liveVitalStats, "infoEc1L1L2", "EC1 L1, L2"), _defineProperty(_liveVitalStats, "infoNftL1N", "NFT L1, N"), _defineProperty(_liveVitalStats, "infoGidL1L2", "GID L1, L2"), _defineProperty(_liveVitalStats, "infoNftL2N", "NFT L2, N"), _defineProperty(_liveVitalStats, "infoDer1L1L2", "DER1 L1, L2"), _defineProperty(_liveVitalStats, "infoDer2L1L2", "DER2 L1, L2"), _defineProperty(_liveVitalStats, "infoEnchargeL1L2", "IQ Battery L1, L2"), _defineProperty(_liveVitalStats, "infoPvL1L2", "PV L1, L2"), _defineProperty(_liveVitalStats, "enpowerDesc", "La differenza tra la tensione e la frequenza della rete dell'utenza domestica e della microrete si nota dal calo di tensione nel dispositivo di interconnessione alla microrete (MID)."), _defineProperty(_liveVitalStats, "infoEnpwrDiagram", "Questo diagramma a blocchi del controller di sistema è solo a scopo illustrativo."), _defineProperty(_liveVitalStats, "infoEnpowerRelays", "Relè del controller di sistema"), _defineProperty(_liveVitalStats, "bmuWarning", "Avviso BMU"), _defineProperty(_liveVitalStats, "bmuL1Error", "BMU errore di livello 1"), _defineProperty(_liveVitalStats, "bmuL2Error", "BMU errore di livello 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_WARN_CODE", "Avviso massima tensione cella batteria"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_WARN_CODE", "Avviso minima tensione cella batteria"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_IMBAL_WARN_CODE", "Avviso di squilibrio nella tensione della cella della batteria"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_WARN_CODE", "Avviso di sovratensione interruttore FET batteria"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV1_CODE", "Tensione massima della cella della batteria errore livello 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV1_CODE", "Tensione minima della cella della batteria errore livello 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV1_CODE", "Temperatura massima della cella della batteria errore livello 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV1_CODE", "Temperatura minima della cella della batteria errore livello 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_DIS_OVER_CURRENT_ELV1_CODE", "Sovracorrente di scarica errore livello 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_LTC6811_NO_COMMS_ELV1_CODE", "Nessuna comunicazione BMU"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_CURRENT_ELV1_CODE", "Corrente transistor effetto campo errore livello 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FUSE_OPEN_ELV1_CODE", "Fusibile aperto errore livello 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_DRIVER_ELV1_CODE", "Attuatore transistor effetto campo errore livello 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_SENSE_LINE_OPEN_ELV1_CODE", "Rilevamento tensione linea aperta errore livello 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_ELV1_CODE", "Sovratemperatura transistor effetto campo errore livello 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_THERMAL_LINE_OPEN_ELV1_CODE", "Linea termica aperta errore livello 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_24V_ELV1_CODE", "Circuito precarica 24V errore livello 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_VBAT_ELV1_CODE", "Tensione cellula batteria precarica errore livello"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV2_CODE", "Tensione massima della cella della batteria errore livello 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV2_CODE", "Tensione minima della cella della batteria errore livello 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV2_CODE", "Temperatura massima della cella della batteria errore livello 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV2_CODE", "Temperatura minima della cella della batteria errore livello 2"), _defineProperty(_liveVitalStats, "gridMode", "Modalità Rete"), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED", {
    "val": "Rete legata",
    "info": "La batteria è in modalità di connessione alla rete. In questo stato temporaneo non formerà una microrete quando la rete non è disponibile.",
    "pcuInfo": "Il microinverter è in modalità di connessione alla rete. Non formerà una microrete se la rete è disponibile."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ON_GRID", {
    "val": "In rete",
    "info": "La batteria è in modalità di connessione alla rete ed è in grado di formare una microrete quando necessario.",
    "pcuInfo": "Il microinverter è in modalità di connessione alla rete ed è in grado di formare una microrete in caso di necessità."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_OFF_GRID", {
    "val": "Fuori rete",
    "info": "La batteria ha formato una microrete.",
    "pcuInfo": "Il microinverter ha formato una microrete."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ISLANDING", {
    "val": "Isola rilevata",
    "info": "La batteria ha rilevato che la rete è instabile/non disponibile. È in procinto di formare la microrete.",
    "pcuInfo": "Il microinverter ha rilevato che la rete è instabile / non disponibile. Sta formando la microrete."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED_BLACK_START", {
    "val": "Formazione di una microrete",
    "info": "La batteria si è appena riavviata. Ha rilevato che la rete pubblica non è disponibile ed è in procinto di formare la microrete. La riduzione del carico a casa aiuta la formazione di microrete.",
    "pcuInfo": "Il microinverter è stato riavviato. Ha rilevato che la rete dell'utenza domestica non è disponibile e sta formando una microrete. La riduzione del carico domestico aiuta la formazione della microrete."
  }), _defineProperty(_liveVitalStats, "gridModeUnknown", {
    "val": "Non valido",
    "info": "Modalità rete ricevuta non valida per la batteria.",
    "pcuInfo": "Modalità rete non valida ricevuta per il microinverter."
  }), _defineProperty(_liveVitalStats, "infoGridModes", "Modalità Rete"), _defineProperty(_liveVitalStats, "ledStatus", "Stato LED"), _defineProperty(_liveVitalStats, "phase", "Fase"), _defineProperty(_liveVitalStats, "infoEncharge", "IQ Battery"), _defineProperty(_liveVitalStats, "infoAcb", "ACB"), _defineProperty(_liveVitalStats, "infoEnchargeDesc1", "In ogni batteria sono presenti %{pcuLength} microinverter IQ8X-BAT."), _defineProperty(_liveVitalStats, "infoEnchargeDesc2", "Un valore di potenza (kW) del microinverter positivo indica che la batteria si sta scaricando mentre un valore di potenza (kW) negativo indica che la batteria si sta caricando."), _defineProperty(_liveVitalStats, "infoPcuMicro", "Microinverter IQ8X-BAT"), _defineProperty(_liveVitalStats, "infoEnsemble3_0", "IQ8D-BAT Microinverter"), _defineProperty(_liveVitalStats, "infoEnsemble3_0_EnchargeDesc1", "Ogni batteria include %{pcuLength} IQ8D-BAT microinverter."), _defineProperty(_liveVitalStats, "pcu", "Micro"), _defineProperty(_liveVitalStats, "enph_oper_state", "Stato"), _defineProperty(_liveVitalStats, "EN_OP_ST_Idle", {
    "val": "Inattivo"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Starting", {
    "val": "In avvio"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Discovery", {
    "val": "Rilevamento tramite Power Line Communcation (PLC) in corso"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Throttled", {
    "val": "Normale"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Mppt", {
    "val": "Normale (MPPT)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Bursting", {
    "val": "Normale (sovrapotenza)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Constant_Vin", {
    "val": "Funzionante in modalità di tensione CC costante"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Standby", {
    "val": "Normale (standby)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Protection_Fault", {
    "val": "Spegnimento (errore protezione)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Grid_Fault", {
    "val": "Spegnimento (errore rete)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Dcr", {
    "val": "Normale (verifica DCR)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Unknown_state", {
    "val": "Sconosciuto"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_DMIR_Init_Failed", {
    "val": "Errore firmware"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Host_Shutoff", {
    "val": "Disabilitato (spegnimento host)"
  }), _defineProperty(_liveVitalStats, "ac_power", "Alimentazione CA"), _defineProperty(_liveVitalStats, "signalStrength", "Potenza del segnale"), _defineProperty(_liveVitalStats, "commOk", "Comunicazione Ok"), _defineProperty(_liveVitalStats, "noComm", "Nessuna comunicazione"), _defineProperty(_liveVitalStats, "Normal", {
    "val": "Normale"
  }), _defineProperty(_liveVitalStats, "Unknown", {
    "val": "Sconosciuto"
  }), _defineProperty(_liveVitalStats, "pes", (_pes = {
    "voltage": "Voltage",
    "frequency": "Frequency",
    "current": "Current",
    "mode": "Mode",
    "status": "Status",
    "operatingMode": "Operating Mode",
    "systemControls": "System Controls",
    "builtInBattery": "Built-In Battery",
    "IQ8D_MicroInverters": "IQ8D-BAT Microinverters",
    "powerIn": "Power In",
    "powerOut": "Power Out",
    "idle": "Idle",
    "charging": "Charging",
    "normal": "Normal",
    "batteryFault": "Battery Fault",
    "PCUFault": "Pcu fault",
    "solarPvFault": "Solar PV fault",
    "powerOutFault": "Power out fault",
    "powerInFault": "Power in fault",
    "grid_relay": "Grid Relay",
    "pcu_relay": "PCU Relay",
    "ac_loads": "AC Loads",
    "dc_loads": "DC Loads",
    "powered": "Powered"
  }, _defineProperty(_pes, "idle", "Idle"), _defineProperty(_pes, "disabled", "Disabled"), _defineProperty(_pes, "batteryState", "Battery is "), _defineProperty(_pes, "144cellBattery", "144 Cell Battery"), _defineProperty(_pes, "powerIn", "Power In"), _defineProperty(_pes, "average", "Average"), _defineProperty(_pes, "min", "Min"), _defineProperty(_pes, "max", "Max"), _defineProperty(_pes, "cellVoltage", "Cell Voltage"), _defineProperty(_pes, "cellTemp", "Cell Temperature"), _defineProperty(_pes, "pcuMode", "PCU Mode"), _defineProperty(_pes, "micro", "Micro"), _defineProperty(_pes, "acPower", "Ac Power"), _defineProperty(_pes, "dcPower", "DC Power"), _defineProperty(_pes, "state", "State"), _defineProperty(_pes, "grid", "Grid"), _defineProperty(_pes, "solar", "Solar"), _defineProperty(_pes, "auxIn", "Aux In"), _defineProperty(_pes, "acOut", "AC Out"), _defineProperty(_pes, "usbOut", "USB Out"), _defineProperty(_pes, "auxOut", "Aux Out"), _defineProperty(_pes, "coolingFan", "Cooling Fan"), _defineProperty(_pes, "devicelight", "Device Light"), _defineProperty(_pes, "OC", "OC"), _defineProperty(_pes, "OT", "OT"), _defineProperty(_pes, "OV", "OV"), _defineProperty(_pes, "UT", "UT"), _defineProperty(_pes, "UV", "UV"), _defineProperty(_pes, "UC", "UC"), _defineProperty(_pes, "coldIdle", "Cold Idle"), _defineProperty(_pes, "hotIdle", "Hot Idle"), _defineProperty(_pes, "hotCharging", "Hot Charging"), _defineProperty(_pes, "hotDisCharging", "Hot Discharging"), _defineProperty(_pes, "cellImbalance", "Cell Imbalance"), _defineProperty(_pes, "unknown", "unknown"), _defineProperty(_pes, "powerMode", "Power Mode"), _defineProperty(_pes, "SYSTEM_OFF", "Off"), _defineProperty(_pes, "POWER_SAVE", "Save"), _defineProperty(_pes, "SYSTEM_ON", "On"), _defineProperty(_pes, "systemControlInfo", "The difference between the Utility Grid and the Microgrid voltage and frequency is observed due to voltage drop across the grid relay."), _pes)), _liveVitalStats),
  "ledStatus": {
    "title": "Stato LED",
    "code": {
      "-1": "Sconosciuto",
      "0": "Errore Assistenza richiesta",
      "1": "Errore BMU L1",
      "2": "Alta temperatura",
      "3": "Interruttore DC OFF",
      "4": "Nessuna comunicazione con gateway",
      "5": "Comunicazioni connesse ma non contestate",
      "6": "Comunicazioni connesse e contestate",
      "7": "Aggiornamento non riuscito",
      "8": "Aggiornamento BC in corso",
      "9": "Aggiornamento BMU in corso",
      "10": "Aggiornamento PCU in corso",
      "11": "Modalità stand-by",
      "12": "In carica",
      "13": "Scarica",
      "14": "La capacità della batteria è compresa tra: 75-100%",
      "15": "La capacità della batteria è compresa tra: 50-75%",
      "16": "La capacità della batteria è compresa tra: 25-50%",
      "17": "La capacità della batteria è compresa tra: 0-25%",
      "18": "Sistema SU"
    },
    "enpowerRow": {
      "code": {
        "-1": "Sconosciuto",
        "0": "Errore di System Controller (in rete)",
        "1": "Errore di System Controller (fuori rete)",
        "2": "System Controller è in modalità di spegnimento rapido/azionamento manuale",
        "3": "System Controller fuori rete; DER disconnessi",
        "4": "System Controller operativo, impossibile rilevare alcuna IQ Battery su CAN (in rete)",
        "5": "System Controller operativo, impossibile rilevare almeno una IQ Battery su CAN (in rete)",
        "6": "System Controller operativo, impossibile rilevare almeno una IQ Battery su CAN (fuori rete)",
        "7": "System Controller fuori rete; esecuzione ripristino SoC",
        "8": "System Controller si sta sincronizzando con la rete",
        "9": "Aggiornamento FW System Controller (in rete)",
        "10": "Aggiornamento FW System Controller (fuori rete)",
        "11": "System Controller attivo, in fase di avvio",
        "12": "System Controller attivo e in rete",
        "13": "System Controller attivo e fuori rete",
        "14": "System Controller disattivo"
      }
    },
    "info": {
      "safetyIssue": "Nessuno degli stati LED presenta un problema di sicurezza",
      "title": {
        "flashingRed": "Rosso lampeggiante",
        "flashingYellow": "Giallo lampeggiante",
        "softPulseYellow": "Pulsazione gialla lenta",
        "softPulseBlue": "Pulsazione blu lenta",
        "softPulseGreen": "Pulsazione verde lenta",
        "solidRed": "Rosso fisso",
        "solidYellow": "Giallo fisso",
        "solidBlueOrGreen": "Blu o verde fisso",
        "ledOff": "Spento"
      },
      "desc": {
        "flashingRed": "Aggiornamento non riuscito o la batteria è in stato di errore. Contattare l'installatore o l'assistenza Enphase.",
        "flashingYellow": "Aggiornamento in corso.",
        "softPulseYellow": "Modalità stand-by attivata.",
        "softPulseBlue": "Scarica in corso.",
        "softPulseGreen": "Carica in corso.",
        "solidRed": "Avvio.",
        "solidYellow": "Non funzionante a causa dell’alta temperatura. Per maggiori dettagli, consulta al sezione \"Risoluzione dei problemi di IQ Battery\" A.",
        "solidBlueOrGreen": "Inattivo. Transizioni di colore tra blu e verde al variare dello stato di carica. Lo stato di carica viene aggiornato sull'app Enphase. Per maggiori dettagli, consulta al sezione \"Risoluzione dei problemi di IQ Battery\" C.",
        "ledOff": "Non in funzione. Per maggiori dettagli, consulta al sezione \"Risoluzione dei problemi di IQ Battery\" B."
      }
    }
  },
  "updatePending": {
    "title": "Caricamento dati in corso",
    "content": "Il gateway sta caricando i dati del tuo sistema sul cloud Enphase. Ciò accade quando gateway è offline da un po’ di tempo. In genere occorre 1 ora per ogni giorno in cui il gateway è stato offline. Non preoccuparti, il messaggio sparirà una volta caricati tutti i dati.",
    "envoyDataTitle": "Caricamento dati",
    "envoyDataContent": "Il tuo sistema si è recentemente ricollegato a Internet e ci vorrà del tempo per scaricare i tuoi dati. Potrebbe essere necessaria fino a un'ora per ogni giorno in cui è stato offline."
  },
  "bkpConfig": {
    "title": "Configurazione di Backup",
    "0": "Non selezionato",
    "1": "Backup parziale della casa",
    "2": "Backup completo della casa"
  },
  "set": "Impostare",
  "change": "Modificare",
  "allTopics": "Tutti gli argomenti",
  "referFriends": {
    "title": "Segnala agli amici",
    "subTitle_1": "a dare ",
    "subTitle_2": " e ottieni ",
    "description_1": "Sia tu sia il tuo amico avrete diritto a ricevere una carta regalo da ",
    "description_2": " ciascuno dopo che il tuo amico ha acquistato e attivato un nuovo sistema solare o di accumulazione Enphase utilizzando il collegamento sottostante. ",
    "description_3": " ciascuno dopo che il tuo amico ha acquistato e attivato un nuovo sistema solare Enphase utilizzando il collegamento sottostante. ",
    "urlHeading": "Il tuo URL di riferimento",
    "shareButton": "Condividi il tuo link di segnalazione",
    "copyButton": "Copia il tuo link di segnalazione",
    "termsConditions": "Termini e condizioni",
    "applyTerms": "applica.",
    "toastMessage": "Link di riferimento copiato negli appunti",
    "shareMessage_1": "Ehi! Sapevi che la mia casa è a energia solare? Se stavi pensando di passare solare, è il momento giusto. Ho un link di riferimento esclusivo che puoi usare per ricevere ",
    "shareMessage_2": " quando attivi un nuovo sistema solare Enphase.",
    "shareMessageAU_1": "Hey! Getting Enphase solar for my home is one the best investments I've made so I'm sharing the sunshine. If you’re considering ways to lower your electricity bills and protect your pocket, I have a referral link that you can use to receive ",
    "shareMessageAU_2": " when you go solar with Enphase. Check it out:",
    "tncTitle": "Termini e condizioni del Programma di segnalazione Enphase:",
    "important_title": "Importante",
    "important_subtitle": "Tu e il tuo amico avrete diritto al voucher solo se:",
    "important_1": "C'è un intervallo di almeno 15 giorni tra il completamento della registrazione e l'installazione.",
    "important_2": "L'indirizzo email con il quale viene ricevuto o registrato il referral serve per attivare il sistema, una volta installato",
    "tnc": {
      "1": "Limite di 30 segnalazioni per cliente.",
      "2": "Le persone a cui hai mandato la segnalazione devono utilizzare il collegamento che condividi e fornire le proprie informazioni di contatto a Enphase tramite il sito Web Enphase designato entro il 31 dicembre 2022.",
      "3": "Se Enphase o i suoi installatori dispongono già dell'ID e-mail fornito dalla persona, il questa non sarà idonea a partecipare al presente programma di segnalazione.",
      "4": "Tu e la persona che hai presentato potrete ricevere i buoni regalo solo se la persona acquista, installa e completa l'attivazione del prodotto Enphase entro 2 anni dalla ricezione da parte di Enphase delle informazioni relative alla persona sul sito Enphase.",
      "5": "Dopo aver ricevuto la notifica da Enphase che tu e la persona a cui hai mandato la segnalazione siete idonei a ricevere il buono regalo, dovete richiedere tale buono entro 90 giorni dalla ricezione della notifica.",
      "6_One": "Se i buoni regalo da ",
      "6_Two": " non sono disponibili, Enphase può sostituirli con un altro premio di valore uguale o superiore.",
      "7": "L'importo del buono regalo selezionato riflette una stima del valore della segnalazione rispetto alle spese di marketing risparmiate per l’acquisizione di nuovi clienti.",
      "8": "Se tu o il la persona a cui hai mandato la segnalazione desiderate ritirarvi dal programma di segnalazione o non ricevere il buono regalo, contattate di Enphase",
      "9": "Enphase non sarà responsabile per invii incomprensibili, errati, incompleti o ritardati, né Enphase sarà responsabile per errori tipografici, problemi di caricamento o download delle informazioni di riferimento, o per qualsiasi altro malfunzionamento tecnico relativo a reti, Internet, apparecchiature elettroniche o siti web.",
      "10": "Enphase si riserva il diritto di modificare, sospendere o terminare questo programma di segnalazione senza preavviso.",
      "11": "Questo Programma di segnalazione è nullo ove proibito.",
      "12": "Affinché Enphase possa attribuire una persona segnalata, il link univoco deve essere utilizzato sia da te sia da tale persona.",
      "13": "È necessario un intervallo di almeno 15 giorni tra il completamento della registrazione e l'installazione.",
      "14": "L'indirizzo email con il quale viene ricevuto o registrato il referral deve essere utilizzato per attivare il sistema, una volta installato."
    }
  },
  "contactPVMaintainer": "Contatta il manutentore Solar",
  "contactStorageMaintainer": "Contatta il responsabile dell’accumulazione",
  "pvInstallerDetails": "Dettagli dell'installatore Solar",
  "storageInstallerDetails": "Dettagli dell’installatore dell’accumulazione",
  "customerSupport": "l'Assistenza clienti",
  "soFarToday": "Fino ad oggi,",
  "forSelectedPeriod": "Per il periodo selezionato,",
  "energyIndependence": {
    "title": "Indipendenza energetica",
    "subTitle": "Misura l'indipendenza dalla rete elettrica",
    "formulaText": "Calcolo dell'indipendenza energetica:",
    "formula": "[1-(Importata/Consumata)] * 100%",
    "formulaForGenerator": "[1 - {(Importata dalla rete + Importato dal generatore) / Consumata}] * 100%",
    "desc1": "L'indipendenza energetica è una misura dell'autosufficienza energetica. Questo significa che sei in grado di provvedere personalmente a tutto il tuo fabbisogno energetico.",
    "unknown": "non noto poiché il tuo sistema non ha riportato alcun dato di consumo.",
    "0": "tutto il tuo fabbisogno energetico è fornito da una fonte esterna come la rete elettrica. Questo significa che il tuo punteggio di indipendenza energetica per %{periodValue} %{eiValue}%.",
    "100": "nessuna parte del tuo fabbisogno energetico è fornita da una fonte esterna come la rete elettrica. Questo significa che il tuo punteggio di indipendenza energetica per %{periodValue} %{eiValue}%.",
    "value": "%{geValue}% del tuo fabbisogno energetico è fornito da una fonte esterna come la rete elettrica. Questo significa che il tuo punteggio di indipendenza energetica per %{periodValue} %{eiValue}%.",
    "forTodayPeriod": "oggi è",
    "forSelectedPeriod": "il periodo selezionato è",
    "addStorageTitle": "Aggiungi energia accumulata",
    "addStorage": "per aumentare la tua Indipendenza energetica.",
    "addStorageTitleWB": "Aggiunta di energia solare o accumulazione",
    "addStorageWB": "aumenta la tua Indipendenza energetica.",
    "clarify": "L'indipendenza energetica non include l'energia esportata e non deve essere confusa con il Net Metering (o Net Energy), che è la differenza tra l'energia importata ed esportata"
  },
  "backupHistory": {
    "backupEvents": "Eventi di backup totali"
  },
  "eventHistory": {
    "totalEvents": "Eventi totali",
    "events": "Articolo/Evento",
    "deviceImpacted": "Dispositivo interessato",
    "recommendedAction": "Azione consigliata",
    "noBackupHistoryFound": "Nessuna cronologia di backup trovata",
    "eventStatus": "Stato evento"
  },
  "siteActivationStage": {
    "title": " ha avviato l'attivazione del sistema Enphase, ",
    "learnToUse": "Scopri come puoi usare l'app Enphase per monitorare il tuo nuovo sistema Enphase."
  },
  "sfdcChatBot": {
    "exitConfirmation": "Sei sicuro di voler chiudere il chatta con noi?",
    "sfdcChatSubject": "Chatta dall'app Enphase",
    "offlineSupport": "Purtroppo i nostri agenti sono offline. Per favore lasciaci un messaggio."
  },
  "pushN": {
    "ok": "Ok, vai lì",
    "stay": "Rimani qui",
    "permMsg": "Hai ricevuto una notifica per il sito %{siteName}. Passare a questo sito per visualizzare la notifica."
  },
  "tariffEditor": {
    "autofillChooseModeFAQ": "Quale modalità devo scegliere?",
    "autofillRatePlanExistFAQ": "Perché il mio piano tariffario non è indicato?",
    "autofillRatePlanMatchFAQ": "Perché i miei dati non corrispondono alla mia bolletta?",
    "autofillTariffNote": "Se hai difficoltà a trovare il nome/codice della tariffa, contatta il tuo fornitore di energia elettrica per informazioni.",
    "whtBaslineElecRate": "Qual è il tuo tasso di pagamento per l'elettricità base? ",
    "doElecPayRateVaryWeekends": "Il tuo tasso di pagamento per l'elettricità varia nei weekend? ",
    "doElecPayRateVarySeasonaly": "Il tuo tasso di pagamento per l'elettricità varia a seconda della stagione? ",
    "elecPayGoesUpWithUsage": "Il tuo tasso di pagamento per l'elettricità cresce con l'aumentare dell'utilizzo? ",
    "pRatePeakOffPecakChanges": "Il tasso di pagamento per l'elettricità prevede delle differenze per le fasce orarie di punta e non di punta? ",
    "ratePerUnitOfSolar": "Qual è il tuo tasso di pagamento per ogni unità di energia solare generata? ",
    "payOutRate": "Tasso di pagamento ",
    "tarifeditorConstants1": "Struttura della tariffa elettrica ",
    "tarifeditorConstants2": "Converte i dati energetici in tassi di cambio equivalenti ",
    "tarifeditorConstants3": "Consente di visualizzare/modificare la struttura della tariffa elettrica della tua utenza domestica ",
    "tarifeditorConstants4": "Puoi controllare le informazioni sul costo di importazione dell'elettricità sulla tua bolletta nella sezione con i dettagli sui costi. ",
    "tarifeditorConstants5": "Aggiungi costo di importazione dell'elettricità ",
    "tarifeditorConstants6": "Consente di impostare la struttura della tariffa in base alla quale ti verrà addebitato il costo per l'importazione dell'elettricità dalla rete. ",
    "tarifeditorConstants7": "Nota ",
    "tarifeditorConstants8": "Le informazioni sulla tariffa dell'elettricità vengono utilizzate dal gateway per determinare il miglior programma di carica e scarica della batteria quando il profilo della batteria è impostato su \"Modalità risparmio\". La modifica di tali informazioni comporta la modifica del comportamento del sistema.",
    "tarifeditorConstants9": "La struttura della tariffa elettrica non è stata aggiunta ",
    "tarifeditorConstants10": "Aggiungi costo di importazione dell'elettricità ",
    "tarifeditorConstants11": "Seleziona una modalità per aggiungere i tuoi dettagli ",
    "tarifeditorConstants12": "Riempimento automatico ",
    "tarifeditorConstants13": "Importa la struttura della tua tariffa elettrica usando le informazioni sulla tua utenza domestica ",
    "tarifeditorConstants14": "Manuale ",
    "tarifeditorConstants15": "Consente di inserire manualmente i dettagli della struttura della tariffa elettrica della tua utenza ",
    "tarifeditorConstants16": "CAP ",
    "tarifeditorConstants17": "Nome dell'utenza domestica ",
    "tarifeditorConstants18": "Nome / Codice tariffa ",
    "tarifeditorConstants19": "Dettagli del costo di importazione dell'elettricità ",
    "tarifeditorConstants20": "Importo forfettario ",
    "tarifeditorConstants21": "A scaglioni ",
    "tarifeditorConstants22": "Tempo di utilizzo ",
    "tarifeditorConstants23": "Tariffa fissa ",
    "tarifeditorConstants24": "Dichiarazione di non responsabilità ",
    "tarifeditorConstants25": "Le tariffe elettriche segnalate sono addebiti aggregati che includono solo i componenti della tariffa che si basano sul consumo. Non sono inclusi addebiti fissi conguagli crediti incentivi e tasse regionali o specifiche. ",
    "tarifeditorConstants26": "Conferma e salva ",
    "tarifeditorConstants27": "Nome della tariffa elettrica ",
    "tarifeditorConstants28": "Tariffa elettrica base ",
    "tarifeditorConstants29": "Sei sicuro di voler ripristinare i dettagli? ",
    "tarifeditorConstants30": "La tua tariffa elettrica prevede addebiti per fasce orarie di punta e non di punta? ",
    "tarifeditorConstants31": "La tua tariffa elettrica cresce con l'aumentare dell'utilizzo? ",
    "tarifeditorConstants32": "La tariffa elettrica fissa non varia. ",
    "tarifeditorConstants33": "La tariffa elettrica cresce con l'aumentare dell'utilizzo. ",
    "tarifeditorConstants34": "La tua tariffa elettrica varia a seconda della stagione? ",
    "tarifeditorConstants35": "La tua tariffa elettrica varia nei weekend? ",
    "tarifeditorConstants36": "Qual è la tua tariffa elettrica base? ",
    "tarifeditorConstants37": "La tariffa elettrica fissa non varia. ",
    "tarifeditorConstants38": "La struttura della tariffa elettrica varia solo in base alla stagione. ",
    "tarifeditorConstants39": "La struttura della tariffa elettrica varia nei weekend. ",
    "tarifeditorConstants40": "La struttura della tariffa elettrica varia in base alla stagione e nei weekend. ",
    "tarifeditorConstants41": "La tariffa elettrica cresce con l'aumentare dell'utilizzo. ",
    "tarifeditorConstants42": "Tariffa elettrica base: ",
    "tarifeditorConstants43": "La struttura della tariffa elettrica varia solo in base alla stagione. ",
    "tarifeditorConstants44": "La tariffa elettrica include addebiti per fasce orarie di punta e non di punta. ",
    "tarifeditorConstants45": "La struttura della tariffa elettrica varia solo nei weekend. ",
    "tarifeditorConstants46": "Aggiungi tariffa di esportazione dell'elettricità ",
    "tarifeditorConstants47": "Consente di aggiungere la struttura della tariffa in base alla quale ti verrà pagata l'esportazione alla rete dell'elettricità generata dal tuo pannello solare. ",
    "tarifeditorConstants48": "Seleziona il tuo piano di esportazione dell'elettricità ",
    "tarifeditorConstants49": "Come selezionare il tuo piano di esportazione dell'elettricità ",
    "tarifeditorConstants50": "Puoi verificare questa informazione sulla bolletta nella sezione relativa ai crediti e conguagli. ",
    "tarifeditorConstants51": "NEM (Consumo energetico netto) ",
    "tarifeditorConstants52": "Verifica se in casa tua è presente una configurazione del contatore netta. <b style='font-weight: bold;'>La tua tariffa di importazione dell'elettricità verrà copiato come tasso di esportazione dell'elettricità.</b> ",
    "tarifeditorConstants53": "FIT netta (Tariffa conto energia netta) ",
    "tarifeditorConstants54": "Verifica questo valore se vieni pagato solo per l'energia solare che torna in rete dalla tua casa. ",
    "tarifeditorConstants55": "FIT lorda (Tariffa conto energia lorda) ",
    "tarifeditorConstants56": "Verifica questo valore se vieni pagato per ogni unità di elettricità generata dai tuoi pannelli solari. ",
    "tarifeditorConstants57": "Altro ",
    "tarifeditorConstants58": "Verificalo se sei iscritto a un altro piano. ",
    "tarifeditorConstants59": "Dettagli della tariffa di esportazione dell'elettricità ",
    "tarifeditorConstants60": "Struttura del tasso di pagamento elettrico ",
    "tarifeditorConstants61": "Piano di esportazione ",
    "tarifeditorConstants62": "Modifica tariffa di esportazione dell'elettricità ",
    "tarifeditorConstants63": "Il tuo piano FIT ti corrisponde un prezzo fisso per ogni unità di energia solare esportata? ",
    "tarifeditorConstants64": "Tariffa a tempo ",
    "tarifeditorConstants65": "Il tasso di pagamento per l'elettricità prevede addebiti per fasce orarie di punta e non di punta ",
    "tarifeditorConstants66": "Il tasso di pagamento per l'elettricità fisso non varia ",
    "tec67": "Tasso di ridistribuzione (payout rate) dell'energia elettrica base",
    "tec68": "Nome tariffa",
    "tec69": "Siamo spiacenti di informarti che la tua struttura tariffaria non è supportata dalla compilazione automatica. Stiamo lavorando per risolvere questo problema. Nel frattempo, puoi impostare la tua tariffa utilizzando la procedura manuale.",
    "tec70": "Impossibile recuperare il nome della società di utility in relazione al tuo codice di avviamento postale. Impostare la tariffa manualmente.",
    "tec71": "Spiacenti, impossibile recuperare i dettagli tariffari.",
    "tec72": "Selezionare il nome della Società di utility.",
    "tec73": "Cerca",
    "tec74": "Nome della tariffa/Codice",
    "tec75": "Seleziona Nome della tariffa/Codice",
    "tec76": "Imposta la tariffa manualmente",
    "tec77": "Riprova",
    "tec78": "Seleziona il tempo di ricarica",
    "tec79": "Carica batterie dalla rete",
    "from": "Da",
    "to": "A",
    "tec80": "Carica batteria dalla rete completata",
    "try_again": "Riprovare.",
    "tec81": "Valuta la tua esperienza",
    "tec82": "Questi dati sono risultati utili e accurati?",
    "tec83": "Probabilmente no",
    "tec84": "Quasi certamente",
    "tec85": "Per eventuali domande o chiarimenti, scrivici.",
    "tec86": "Non desideri caricare le tue batterie dalla rete?",
    "tec87": "Thank you for your valuable feedback",
    "talc": "Riprovare più tardi",
    "tec88": "Come è stata la tua esperienza con il gestore tariffario?",
    "tec89": "Nota",
    "tec90": "Copia da Tariffa di acquisto",
    "tec91": "Copia la tua tariffa dalla tariffa di acquisto impostata",
    "tec92": "Tariffa esportazione energia elettrica",
    "tec93": "Tariffa importazione energia elettrica",
    "tec94": "La tariffa dell'energia elettrica qui riportata include le componenti tariffarie sotto indicate.",
    "tec95": "Rispondi alle domande che seguono per impostare il tuo tipo di tariffa.",
    "tec96": "Periodo temporale non valido",
    "tec97": "%{time1} - %{time2} già selezionato",
    "peak": "Picco",
    "aPeak": "Aggiungi picco",
    "aSeason": "Aggiungi stagione",
    "season": "Stagione",
    "eSeason": "Modifica stagione",
    "tec98": "Voce non valida. Il valore deve essere maggiore di Fascia %{index}",
    "tec99": "Si è verificato un errore, riprovare più tardi",
    "tec100": "Il tasso di ridistribuzione dell'energia elettrica cresce all'aumentare dell'utilizzo.",
    "tec101": "Tariffa variabile col tempo",
    "tier": "Fascia",
    "offPeak": "Non di punta",
    "tec102": "Modifica Tariffa importazione energia elettrica",
    "tec103": "Configurazione manuale",
    "tec104": "Tariffa riempimento automatico",
    "tec105": "Selezionare una modalità",
    "tec106": "Seleziona una modalità per modificare i tuoi dettagli",
    "tec107": "Selezionare il nome della tariffa",
    "tec108": "Le informazioni sulla tariffa dell'energia elettrica vengono utilizzate dal gateway per determinare il programma di carica e scarica della batteria migliore possibile. La modifica di tali informazioni comporta la modifica del comportamento del sistema.",
    "tec109": "Le informazioni sulla tariffa dell'energia elettrica vengono utilizzate per calcolare i risparmi energetici nel corso del tempo e offrirti consigli personalizzati per aiutarti a risparmiare sui costi dell'energia.",
    "tec110": "Qual è il tuo tasso di pagamento per ogni unità di energia solare esportata?",
    "tec111": "Aggiunta tariffa importazione energia elettrica completata",
    "tec112": "Aggiornamento tariffa importazione energia elettrica completato",
    "tec113": "Reimpostazione tariffa importazione energia completata",
    "tec114": "Aggiunta tariffa esportazione energia elettrica completata",
    "tec115": "Aggiornamento tariffa esportazione energia elettrica completato",
    "tec116": "Reimpostazione tariffa esportazione energia completata",
    "rate": "Tariffa",
    "tec117": "Tasso di pagamento fisso",
    "tec118": "Altro (A scaglioni )",
    "tec119": "Altro (Tempo di utilizzo )",
    "tec120": "Altro (Importo forfettario )",
    "tec121": "Gross FIT",
    "tec122": "Net FIT (Tariffa variabile col tempo)",
    "tec123": "Net FIT (Importo forfettario )",
    "tec124": "NEM",
    "tec125": "La tariffa elettrica fissa non varia. La struttura della tariffa elettrica varia solo in base alla stagione.",
    "tec126": "La tariffa elettrica fissa non varia. La struttura della tariffa elettrica varia solo nei weekend.",
    "tec127": "La tariffa elettrica fissa non varia. La struttura della tariffa elettrica varia in base alla stagione e nei weekend.",
    "tec128": "Il tasso di pagamento per l'elettricità fisso non varia. La struttura della tariffa elettrica varia solo in base alla stagione.",
    "tec129": "Il tasso di pagamento per l'elettricità fisso non varia. La struttura della tariffa elettrica varia solo nei weekend.",
    "tec130": "Il tasso di pagamento per l'elettricità fisso non varia. La struttura della tariffa elettrica varia in base alla stagione e nei weekend.",
    "tec131": "La tariffa elettrica include addebiti per fasce orarie di punta e non di punta. La struttura della tariffa elettrica varia solo in base alla stagione.",
    "tec132": "La tariffa elettrica include addebiti per fasce orarie di punta e non di punta. La struttura della tariffa elettrica varia solo nei weekend.",
    "tec133": "La tariffa elettrica include addebiti per fasce orarie di punta e non di punta. La struttura della tariffa elettrica varia in base alla stagione e nei weekend.",
    "tec134": "Il tasso di pagamento per l'elettricità prevede addebiti per fasce orarie di punta e non di punta. La struttura della tariffa elettrica varia solo in base alla stagione.",
    "tec135": "Il tasso di pagamento per l'elettricità prevede addebiti per fasce orarie di punta e non di punta. La struttura della tariffa elettrica varia solo nei weekend.",
    "tec136": "Il tasso di pagamento per l'elettricità prevede addebiti per fasce orarie di punta e non di punta. La struttura della tariffa elettrica varia in base alla stagione e nei weekend.",
    "tec137": "La tariffa elettrica cresce con l'aumentare dell'utilizzo. La struttura della tariffa elettrica varia solo in base alla stagione.",
    "tec138": "Il tasso di ridistribuzione dell'energia elettrica cresce all'aumentare dell'utilizzo. La struttura della tariffa elettrica varia solo in base alla stagione.",
    "emptystring": "",
    "tec139": "ToU",
    "tec140": "Mostra cronologia percentuali",
    "tec141": "Tariffa di importazione dell'elettricità aggiunta correttamente",
    "tec142": "Valutare la propria esperienza con l'aggiunta della tariffa elettrica",
    "tec143": "nsoddisfatto",
    "tec144": "Soddisfatto",
    "tec145": "Ignora",
    "tedc0": "Addebito in base alla domanda",
    "tedc1": "Addebito per tutto il giorno (24 ore)",
    "tedc2": "La tariffa include il componente di addebito in base alla domanda aggiunto mensilmente alla bolletta dell'energia elettrica.",
    "tedc3": "La tariffa elettrica include il componente di potenza impegnata. Durante le ore di picco, il consumo massimo per ogni intervallo di %{time}-minuto durante il mese verrà caricato in base ai seguenti dettagli",
    "tedc4": "Consumo max. %{time} minuti",
    "tedc5": "Seleziona una struttura tariffaria elettrica",
    "tet1": "Parlami della variabilità della tariffa elettrica",
    "tet2": "In alcune aree, il costo dell'energia elettrica aumenta e diminuisce durante il giorno o in base a quanto se ne consuma. Usiamo la tua tariffa elettrica per pianificare il miglior programma di carica e scarica della batteria quando il suo profilo è impostato su Modalità risparmio.",
    "tet3": "Inizia",
    "tet4": "Tocca \"Aggiungi la tariffa per l\'importazione di energia elettrica\".",
    "tet5": "Inserisci le tue informazioni",
    "tet6": "Utilizza Compilazione automatica o Manuale per inserire i dettagli della tariffa. Potresti aver bisogno di una bolletta elettrica recente se inserisci la tariffa manualmente.",
    "tet7": "Compilazione automatica",
    "tet8": "Seleziona la tua utilità e il nome o il codice del piano dai menu a discesa. L'app cercherà automaticamente il tasso di importazione dell'energia elettrica.",
    "tet9": "Manuale",
    "tet10": "Inserisci i dettagli in ogni campo: potresti dover fare riferimento a una bolletta elettrica recente per raccogliere tutte le informazioni necessarie.",
    "tet11": "Aggiungi la tariffa per l'esportazione di energia elettrica",
    "tet12": "Se ottieni un accredito per l'invio di energia elettrica alla rete, aggiungi successivamente la tariffa di esportazione dell'energia elettrica. Tocca \"Aggiungi tariffa di esportazione dell\'energia elettrica\" per iniziare - avrai le stesse opzioni per inserire le tue informazioni tramite la compilazione automatica o manuale.",
    "tet13": "Come determiniamo e utilizziamo la tua tariffa elettrica",
    "undefined": "altro (a livelli)",
    "timeDiffError": "L'ora di inizio e l'ora di fine devono avere una differenza minima di 15 minuti",
    "periodOverlapError": "Questo periodo si sovrappone a uno degli altri periodi",
    "peakConflictError": "La tariffa di picco dovrebbe essere superiore alla tariffa normale",
    "isTimeValid": "L'ora di inizio deve essere precedente all'ora di fine"
  },
  "appliance": {
    "info": "Per mantenere la casa alimentata per periodi prolungati durante un’interruzione di rete, consigliamo di ridurre e gestire il proprio consumo energetico",
    "desc": "Apague las cargas domésticas no críticas para aumentar la duración de la batería.",
    "descSystem2_0AndEncharge": "Best practice da seguire in caso di interruzione della rete elettrica.",
    "largeAppliances": "Grandi elettrodomestici",
    "useSparingly": "Usa con parsimonia",
    "essentialAppliances": "Elettrodomestici essenziali",
    "useNormally": "Utilizzare normalmente",
    "airConditioner": "Condizionatore",
    "dishwasher": "Lavastoviglie",
    "poolPump": "Pompa per piscina",
    "washingMachine": "Lavatrice",
    "electricVehicle": "Veicolo elettrico",
    "electricDryer": "Asciugatrice elettrica",
    "lights": "Luci",
    "laptop": "Il computer portatile",
    "television": "Televisione",
    "refrigerator": "Frigorifero",
    "wifiRouter": "Router wifi",
    "microwave": "Forno a microonde"
  },
  "rootedAlert": {
    "exitBtn": "Esci",
    "proceedBtn": "Procedi",
    "agreeBtn": "Accetto",
    "warningLabel": "AVVERTENZA!",
    "warningTextInitial": "Il dispositivo sembra essere in rooting. Il rooting compromette la protezione di sicurezza predefinita e rende vulnerabili i dati archiviati sul dispositivo. Non è consigliabile eseguire l'app Enphase su un dispositivo in rooting.",
    "warningTextFinal": "Procedendo ulteriormente, comprendo e accetto che Enphase non sarà responsabile per alcun malfunzionamento o conseguenza dell'esecuzione dell'applicazione Enphase su questo dispositivo in rooting."
  },
  "sgipStatic": {
    "applyForIncentive": "Richiedi incentivo Sgip",
    "subheadingSgip": "I proprietari di sistemi in California che stanno pianificando o hanno acquistato una batteria Enphase per la propria casa possono richiedere SGIP",
    "applyNow": "Applica ora",
    "learnMore": "Maggiori informazioni",
    "serviceFee": "* Potrebbe essere applicata una tariffa per il servizio",
    "enphaseRepresentative": "* Potresti essere contattato da un rappresentante Enphase tramite telefono/e-mail",
    "documentsRequired": "Per richiedere l'incentivo SGIP, sono necessari i seguenti documenti:",
    "documentHeading1": "1. Ultime bollette (almeno una bolletta risalente agli ultimi 3 mesi)",
    "documentHeading2": "2. Documento contrattuale",
    "additionalInfo": "* Prima di poter ricevere l'incentivo finale, potrebbero essere richiesti altri documenti"
  },
  "activationProgress": {
    "systemActivationInProgress": "L'attivazione del tuo sistema è in corso",
    "completed": "Completato",
    "viewDetails": "Visualizza dettagli",
    "activationCompleted": "L'attivazione è completa al 100%",
    "activationInProgress": "Attivazione in corso",
    "devices": "Dispositivi",
    "status": "Status",
    "envoy": "Gateway",
    "encharge": "Batteria",
    "enpower": "Controller di sistema",
    "pvProduction": "Produzione PV",
    "cosumptionCT": "CT di consumo",
    "systemOperational": "Sistema operativo",
    "reporting": "Segnalazione",
    "notReporting": "Mancata segnalazione",
    "enabled": "Abilitato",
    "notEnabled": "Non abilitato",
    "producing": "Produzione",
    "verified": "Verificato",
    "notVerified": "Non verificato",
    "featuresNowEnable": "Le seguenti funzionalità non sono abilitate.",
    "featuresWillBeEnabled": "Le seguenti funzionalità verranno abilitate una volta completata l'attivazione del sistema:",
    "consumptionMonitoring": "Monitoraggio del consumo",
    "liveStatus": "Stato in tempo reale",
    "stormGuard": "Protezione temporale",
    "batteryProfileSetting": "Impostazioni dei profili della batteria",
    "gridControl": "Controllo rete"
  },
  "generator": {
    "exerciseModeOverlap1": "Il tempo di esercizio si sovrappone al Tempo di inattività",
    "exerciseModeOverlap2": "per",
    "exerciseModeOverlap3": "Vuoi continuare?",
    "dayInWeek": "Giorni alla settimana",
    "time": "Ora",
    "duration": "Durata",
    "frequency": "Frequenza",
    "save": "Salva",
    "edit": "MODIFICA",
    "cancelRequest": "Annulla richiesta",
    "activate": "Attiva",
    "okayText": "Ok, ho capito!",
    "batteryUnavailable": "<span>Il sistema non dispone di batteria. Controllare il generatore in base alla carica della batteria? <a href='https://estimator.enphaseenergy.com/login' target='_blank'>Aggiungi spazio di accumulo</a></span>",
    "suspendedStateText": "Il tuo generatore è attualmente disabilitato. Abilita il generatore utilizzando il pulsante di attivazione/disattivazione nella parte superiore dello schermo per attivarne il profilo.",
    "suspendedModalHeading": "Il generatore verrà disabilitato.",
    "suspendedModalHeading_1": "Il generatore sarà attivato in base al profilo selezionato.",
    "suspendedModalSubheading": "Per abilitare il generatore, usa il pulsante di attivazione/disattivazione nella parte superiore dello schermo.",
    "infoHeadng": "Generatore",
    "infoSubheading": "<div><div>Se questa opzione è  <span style='color: #F37320'>abilitata</span>, zal uw generator worden in- en uitgeschakeld op basis van het geselecteerde profiel en de beschikbaarheid van het net. Als uw systeem Op rooster is, wordt uw generator uitgeschakeld, ongeacht de gekozen profielen.</div><div style='margin-top: 10px;'> Puoi disabilitare il generatore quando non è in uso, ad esempio quando parti per una vacanza.<div></div>",
    "advancedSettings": "Impostazioni avanzate",
    "pendingRequest": "richiesta in sospeso",
    "disabled": "Disabilitato",
    "disable": "Disabilita",
    "enabled": "Abilitato",
    "waiting": "In attesa di informazioni",
    "active": "Attivo",
    "deviceDetails": "Seleziona un profilo smart per controllare il tuo %{manufacturer} %{modelNumber}.",
    "autoStart": "Avvio automatico",
    "autoStartSubheading": "Usa questa opzione se desideri far attivare il generatore appena il sistema passa alla modalità Fuori rete",
    "batteryOptimizationSubheading": "Usa questa opzione se desideri far attivare il generatore solo quando la carica della batteria è al di sotto di un determinato livello e il sistema è Fuori rete.",
    "batteryChargeThreshold": "Soglia di carica della batteria:",
    "lowerLimit": "Limite inferiore: ",
    "upperLimit": "Limite inferiore: ",
    "start": "Inizia: ",
    "stop": "Interrompi: ",
    "addQuietTime": "Aggiungi tempo di inattività",
    "quietTime": "Tempo di inattività",
    "quietTimeToggle": "Usa questa opzione se desideri far attivare il generatore in questo periodo di tempo. Quando la batteria raggiunge il limite critico, il generatore verrà attivato indipendentemente dal tempo di inattività.",
    "startTime": "Ora di inizio: ",
    "endTime": "Ora di fine: ",
    "criticalChargeSettings": "Impostazioni di ricarica della batteria:",
    "generatorLoadingToast": "La verifica dello stato del generatore sta impiegando più tempo del previsto. Ricontrolla più tardi.",
    "exerciseMode": "Impostazioni di esercizio",
    "exerciseModeSubheading": "Vengono usate per far azionare il generatore automaticamente a intervalli regolari per mantenerlo in buone condizioni operative.",
    "batteryOptimization": "Avvia in base al livello della batteria",
    "activateBatteryProfile": "Hai selezionato il profilo Avvio automatico. Per aggiungere il Tempo di inattività, attivare il profilo \"Avvia in base al livello della batteria",
    "manualMode": "Modalità manuale",
    "manualModeDescription": "Il tuo generatore sta attualmente funzionando in modalità manuale. Modifica la modalità del generatore in automatico o contatta il tuo installatore.",
    "generatorStartLimit": "Il limite di avvio non può essere inferiore al 10%",
    "generatorStartStopLimit": "Tra il limite di avvio e quello di arresto ci deve essere una differenza minima del 5%",
    "generatorLimitDescription": "Procedere in questo modo per evitare di attivare il generatore durante determinati periodi di tempo. Il generatore viene attivato quando il livello di carica della batteria scende sotto il limite critico.",
    "generatorQuietTime": "Tempo di riposo",
    "generatorNormalTime": "Tempo normale",
    "generatorEnableGenerator": "Abilita generatore",
    "generatorDisableGenerator": "Disabilita generatore",
    "automatic": "Automatico",
    "ecoFriendly": "Ecologico"
  },
  "prodIssue_faq_1": "Perché uno dei pannelli produce meno degli altri?",
  "prodIssue_faq_2": "È normale che la generazione di energia di pannelli posizionati sullo stesso tetto sia diversa. Queste variazioni possono essere causate da molti fattori, ad esempio la direzione dei pannelli, l'ombra da parte di camini o alberi e altre ostruzioni.",
  "accountNew": {
    "account": {
      "title": "Informazioni personali",
      "title_alternate": "Informazione personale",
      "save_changes": "Salva modifiche",
      "name_label": "Nome:",
      "phone_label": "Mobile:",
      "phone_placeholder": "Numero di telefono",
      "first_name_placeholder": "Nome",
      "last_name_placeholder": "Cognome",
      "email_placeholder": "Indirizzo e-mail",
      "email_label": "E-mail:",
      "change_password": "Modifica password",
      "current_password": "Password corrente:",
      "password_label": "Nuova password:",
      "password2_label": "Digitare di nuovo la nuova password:",
      "password_footnote": "La password deve contenere almeno 6 caratteri e un numero o un carattere speciale.",
      "cancel_change_password": "Non modificare password",
      "units_label": "Unità:",
      "units_metric": "Metriche (°C, km)",
      "units_us": "Imperiali (°F, mi)",
      "locale_label": "Lingua",
      "equivalent_label": "Equivalente energetico:",
      "equivalent_display": "Inizia con",
      "notification_label": "E-mail:",
      "preference_monthly_email": "Invia riepiloghi mensili sulle prestazioni di sistema",
      "preference_enphase_email": "Invia newsletter, promozioni e sondaggi su prodotti e servizi Enphase",
      "production_issues_email": "Avvisami sulla produzione del sistema o su problemi relativi all'assistenza",
      "save_successful": "Informazioni salvate correttamente.",
      "save_successful_email": "Informazioni salvate correttamente. Consultare di seguito le note a riguardo della modifica.",
      "save_failed": "Impossibile salvare la informazioni.",
      "system_info": "Informazioni di sistema per %{site_name}",
      "system_weather": "Meteo sistema",
      "show_system_weather": "Mostra funzionalità meteorologiche per questo sito",
      "save": "Salva"
    },
    "system_preferences": {
      "title": "Preferenze di sistema",
      "name_label": "Nome:",
      "public_label": "Pagina pubblica del sistema:",
      "public_text_html": "Crea una pagina pubblica del sistema",
      "public_preview_link": "Anteprima pagina pubblica",
      "public_help_link": "Ulteriori informazioni",
      "public_footnote": "Verranno abilitate le funzionalità di condivisione su social network e sarà consentito l'accesso dei visitatori al sistema.",
      "display_label": "Mostra nome sistema come:",
      "save_changes": "Salva preferenze di sistema",
      "save_location_changes": "Salva impostazioni privacy",
      "save_successful": "Preferenze di sistema salvate correttamente.",
      "save_failed": "Impossibile salvare preferenze di sistema."
    },
    "validations": {
      "required": "Campo obbligatorio.",
      "password_too_short": "La password deve essere lunga almeno 6 caratteri e contenere almeno 1 carattere numerico o speciale.",
      "password_too_long": "Immettere meno di 50 caratteri.",
      "password_similar_to_username": "La password non può corrispondere all'indirizzo e-mail inserito.",
      "password_too_weak": "La password deve essere lunga almeno 6 caratteri e contenere almeno 1 carattere numerico o speciale.",
      "password_weak": "La password deve essere lunga almeno 6 caratteri e contenere almeno 1 carattere numerico o speciale.",
      "password_good": "Sicurezza password: buona",
      "password_strong": "Sicurezza password: alta",
      "password_policy": "deve essere di almeno %{pwd_min_length}-%{pwd_max_length} caratteri e includere %{digit_in_pwd} cifre, %{uppercase_in_pwd} lettere maiuscole, %{lowercase_in_pwd} lettere minuscole, %{special_character_in_pwd} numero di caratteri speciali e solo (~!@#$%^&*)",
      "equalTo": "Il valore non corrisponde.",
      "invalid_phone_number": "Inserisci un numero di cellulare valido.",
      "empty_phone_number": "Inserisci il numero del cellulare.",
      "email_used": "L'ID e-mail è già registrato. Riprova con un altro ID e-mail o $cHere per reimpostare la tua password.",
      "emailInvalid": "Inserisci un indirizzo email valido"
    }
  },
  "accountDelete": {
    "deleteAccount": "Eliminare l'account",
    "deletePopUpText": "Il tuo account e le informazioni personali associate verrebbero cancellati. Verrai disconnesso dopo aver eliminato l'account. Vuoi procedere?",
    "deleteCnfText": "Il tuo account e le informazioni personali associate verrebbero cancellate, ad eccezione delle informazioni che siamo tenuti a mantenere in connessione con il tuo Sistema Energetico. Verrai disconnesso dopo aver eliminato l'account. Vuoi procedere?",
    "yes": "sì",
    "no": "No",
    "verificationCode": "Codice di verifica",
    "enterCodeText": "Inserisci il codice a 4 cifre che ti è stato inviato all'indirizzo email registrato e il numero di cellulare.",
    "didntReceive": "Non hai ricevuto il codice?",
    "resend": "Rinviare",
    "deleteCnfTextEnlm": "Il tuo account e le informazioni personali associate verrebbero cancellate, ad eccezione delle informazioni che siamo tenuti a mantenere in connessione con il tuo Sistema Energetico. Perderai anche l'accesso a Enlighten Manager. Verrai disconnesso dopo aver eliminato l'account. Vuoi procedere?",
    "deleteAdmin": "Il tuo account non può essere eliminato poiché sei un utente amministratore di Enphase",
    "verifyCode": "Verificare il codice",
    "logOutText": "Verrai disconnesso dopo aver verificato il codice.",
    "confirmText": "Il tuo account è disattivato. Conserveremo le informazioni personali relative al tuo sistema energetico per onorare la tua garanzia e supportare il tuo sistema.",
    "ok": "Ok capito",
    "activateCnfText": "Il tuo account Enphase non è attivo perché hai eliminato il tuo account. Vuoi riattivarlo?",
    "activateText": "L'ID e-mail è registrato con Enphase. Tuttavia, non è attivo in quanto è stato eliminato.",
    "click": "Clic ",
    "activateAgain": "qui per riattivarlo",
    "activateAccount": "Attiva account",
    "emailIDRegistered": "L'ID e-mail è registrato con Enphase. Tuttavia, non è attivo in quanto è stato eliminato. $cHere per riattivarlo.",
    "deleteAccountPopupText": "L'eliminazione del tuo account disattiverà il tuo account e rimuoverà tutte le informazioni personali associate al tuo account. Poiché sei associato a un sistema Enphase Energy, siamo tenuti a conservare le tue informazioni personali per supportare la garanzia del prodotto, gli aggiornamenti del sistema e il supporto.",
    "learnMore": "Per saperne di più",
    "accountdeletion": "Il tuo account è in fase di eliminazione. Questo processo può richiedere fino a 30 giorni e puoi creare un nuovo account dopo che il tuo account precedente è stato eliminato.",
    "incorrectEmailandPass": "L'e-mail e la password che hai inserito non corrispondono ai nostri record. Per favore riprova.",
    "accountdeletioninfo": "Il tuo account è in fase di eliminazione. Potrebbero essere necessari fino a 30 giorni.",
    "WOAccntdeletePopup": "L'eliminazione del tuo account disattiverà il tuo account e rimuoverà tutte le informazioni personali associate al tuo account.",
    "accountdelReq": "Richiesta di cancellazione dell'account",
    "verfcodedel": "Il tuo codice di verifica per eliminare l'account Enphase",
    "accountActvReq": "Richiesta di attivazione dell'account",
    "codedelAccount": "Codice di verifica per l'eliminazione dell'account Enphase",
    "codeDuration": "Questo codice sarà valido solo per 15 minuti.",
    "userDelReq": "L'utente ha richiesto l'opzione di eliminazione dell'account nell'app Enphase. Si prega di trovare i dettagli dell'utente di seguito",
    "requestReceived": "Abbiamo ricevuto la tua richiesta di attivazione del tuo account Enphase. Per fare ciò, fai clic sul link sottostante entro 7 giorni dalla ricezione di questa e-mail.",
    "activate": "Attivare",
    "accActivate": "Attiva il tuo account",
    "optdelaccount": "Il tuo codice di verifica per eliminare l'account Enphase è %{otp}. Questo codice è valido per 15 minuti.",
    "emailCheckInstruction": "Controlla la tua email per le istruzioni per attivare l'account."
  },
  "phase": {
    "all": "Vista trifase",
    "phaseL": "Fase L",
    "msgOffGrid": "I dati sul consumo energetico in base alla fase non sono disponibili quando il sistema è fuori rete."
  },
  "vls": {
    "vlsHeading": "Livello di spegnimento della batteria",
    "shutdownLevelLine1": "In caso di interruzione dell'alimentazione, la batteria verrà spenta in",
    "shutdownLevelLine1-2": "carica per risparmiare energia. Verrà riavviata, usando l'energia conservata, quando verrà ripristinata l'alimentazione della rete ripristinerà o i pannelli solari inizieranno a produrre energia.",
    "shutdownLevelLine2": "Scegli un valore più elevato in caso di condizioni meteorologiche avverse che influiscono sulla produzione dell'energia solare.",
    "vlsWarning": "Il livello di spegnimento della batteria non può essere maggiore della riserva della batteria (%{soc}%)",
    "stormVlsWarning": "L'allerta temporale è attiva sul sistema. Una volta terminata l'allerta temporale, la riserva della batteria verrà aggiornata al %{soc}% in quanto non può essere inferiore al livello di spegnimento",
    "batteryReserveWarning": "La riserva della batteria non può essere impostata su un valore inferiore al livello di spegnimento della batteria (%{horizontal}%). Per ridurre la riserva della batteria, riduci il livello di spegnimento della batteria da #Impostazioni avanzate#.",
    "editRequest": "Hai una richiesta attiva. Attendi la conferma o annulla la richiesta per procedere con la selezione."
  },
  "defaultLocale": {
    "popContent1": "Scegli la lingua dell'app",
    "popContentBody1": "Vuoi continuare con ",
    "popContentBody2": " come lingua dell'app?",
    "button1": "Ok, continua",
    "button2": "Scegli un'altra lingua",
    "button3": "No, cambia in ",
    "en": "inglese",
    "de": "Tedesco",
    "es": "spagnolo",
    "fr": "francese",
    "it": "Italiano",
    "nl": "Olandese",
    "pl": "Polacco",
    "pt": "portoghese",
    "en-AU": "English (AU)"
  },
  "woSolarWStorage": {
    "noArraysTitle": "Nessun array!",
    "noArraysDesc": "Non è installato alcun pannello solare",
    "noAccessConsumptionData": "Non si dispone dell'accesso ai dati di consumo per questo sito."
  },
  "drEventsActive": "Evento RD: Attivo",
  "pleaseGoTo": "Accedere a ",
  "enlightenManager": "Enlighten Manager",
  "updateNP": " per aggiornare le preferenze di notifica.",
  "loadControl": {
    "enabled": "Abilitato",
    "disabled": "Disabilitato",
    "smartEnabled": "Controllo smart avanzato",
    "smartDisabled": "Controllo smart disabilitata",
    "offGridBehaviour": "Comportamento Fuori rete",
    "modeDetails": "Dettagli della modalità di controllo smart",
    "newModeDetails": "Dettagli della modalità di controllo del carico",
    "basicMode": "Modalità base",
    "cannotUse": "Non è possibile usare una %{loadName}",
    "genOnUSe": "%{loadName} può essere usata quando la batteria è acceso",
    "genMode": "Modalità generatore",
    "batteryMode": "Modalità batteria",
    "batteryModePercent": "%{loadName} può essere usata quanto la carica della batteria è di almeno il %{lowerSoc}%.​",
    "batteryModeSoc": "Se la carica della batteria scende al di sotto del %{lowerSoc}%, %{loadName} non può essere usata finché la carica della batteria non raggiunge il %{upperSoc}%",
    "loadControlHeading": "Controlla l'alimentazione dei carichi quando il sistema è Fuori rete",
    "loadControlSubHeading": "Tutti i carichi verranno alimentati In rete",
    "powered": "Alimentato",
    "notPowered": "Non alimentato",
    "unknown": "Sconosciuto",
    "permissionOfIntstaller": "Non si dispone dell'autorizzazione a modificare le impostazioni di questo apparecchio. Per saperne di più, contattare l'installatore o l'assistenza clienti Enphase.",
    "willbePowered": "In questo stato, la %{loadName} sarà sempre alimentata.",
    "poweredOnOffGrid": "La %{loadName} verrà alimentata in base al comportamento Fuori rete selezionato.",
    "continueModal": " Continuare?",
    "infoDetails": "Quando il controllo smart è disabilitato oppure il sistema è In rete, i carichi saranno sempre alimentati.",
    "newInfoDetails": "Controlla la potenza sui tuoi carichi in base alla risorsa energetica o l'ora del giorno. Puoi usare anche la modalità manuale se desideri controllare la potenza sui tuoi carichi contemporaneamente.",
    "enableSmartComtrol": "Per usare questa funzionalità, assicurarsi che gli interruttori di alimentazione di questi apparecchi siano accesi.",
    "enableToggle": "Attiva Controllo smart?",
    "disableToggle": "Disabilita Controllo smart?",
    "apply": "Applica",
    "modalPara1": "<div>Quando il controllo smart è <span style='color: #F37320'>abilitato</span>, è possibile scegliere uno dei tre metodi per il comportamento Fuori rete.</div>",
    "disabledModalText": "La funzione di controllo smart è disabilitata per questo carico. Abilita la funzione di controllo smart utilizzando il pulsante di attivazione/disattivazione per aggiornare il comportamento fuori rete",
    "batteryChargeLowerLimit": "Il limite inferiore di carica della batteria non può essere minore del 10%.",
    "batteryChargeHigherLimit": "Il limite inferiore della carica della batteria non può essere superiore al 90%",
    "loadControlLoadingToast": "La conferma dello stato %{loadName} richiede più tempo del previsto. Controlla più tardi.",
    "loadControlTakingLonger": "La conferma dello stato dei caricamento richiede più tempo del previsto. Controlla più tardi.",
    "batteryChargeLowerHigherLimit": "Deve esserci una differenza minima del 5% tra il limite inferiore e il limite superiore di caricamento della batteria",
    "mode": "modalità",
    "lcMainHeading": "Controlla la potenza sui tuoi carichi",
    "basic": "base",
    "scheduled": "pianificato",
    "advanced": "avanzato",
    "manual": "manuale",
    "notSelected": "Non selezionato",
    "poweredWhen": "Alimentato quando la carica della batteria è superiore a",
    "poweredGenOn": "Alimentato quando il generatore è acceso",
    "poweredBetweenTime": "Alimentato tra le %{startTime} e le %{endTime}",
    "onceDisconnected": "Una volta effettuata la disconnessione dalla fonte di alimentazione, il carico non verrà più alimentato, a meno che la batteria non raggiunge il 100%.",
    "alwaysPowered": "Sempre alimentato",
    "neverPowered": "Mai alimentato",
    "minDiff": "L'ora di inizio e l'ora di fine devono avere una differenza minima di 15 minuti.",
    "startLessThanEnd": "L'ora di inizio deve essere precedente all'ora di fine",
    "notValidTime": "L'ora di inizio e l'ora di fine devono rientrare tra le %{startTime} e le %{endTime}.",
    "completed": "Modalità %{loadName} aggiornato correttamente.",
    "notCompleted": "Non è stato possibile completare la richiesta. Riprovare più tardi",
    "completedAll": "Loads updated successfully.",
    "emptyLoadControls": "Nessun controllo del carico trovato",
    "allowedWarning": "Se modifichi questa finestra temporale, assicurati che la tua produzione solare sia sufficiente per supportare il tuo consumo per tutto il periodo in questione.",
    "advancedMode": {
      "subtitle": "Controlla il carico usando:",
      "notPowered": "Alimentato quando la carica è oltre il ",
      "batterySocDesc1": "Non alimentato quando la carica scende al di sotto del ",
      "batterySocDesc2": "Alimentato solo quando la batteria si ricarica fino al ",
      "batterySocDesc3": " (anche se il generatore è acceso)",
      "notAvailable": "Non disponibile",
      "onGridGenPowered": "Alimentato",
      "offGridGenPowered": "Alimentato quando il generatore è acceso"
    }
  },
  "app_info": _defineProperty({
    "update_available": "Aggiornamento dell'app disponibile",
    "already_updatec": "La tua app è aggiornata alla",
    "update_now": "Aggiorna ora",
    "latest_update": "Ultimo aggiornamento",
    "update_history": "Cronologia aggiornamenti",
    "show_more": "Mostra dettagli"
  }, "show_more", "Mostra di meno"),
  "s1": "Aiutami a selezionare un profilo",
  "s2": "Ulteriori informazioni sui profili della batteria",
  "s3": "Suggerisci un profilo adatto a me",
  "s4": "La carica della batteria è maggiore della riserva",
  "s5": "Indipendenza energetica durante le ore di punta:",
  "s6": "Durante le ore non di punta i tuoi pannelli solari caricheranno la batteria prima di alimentare la tua casa. L'energia fotovoltaica in eccesso verrà restituita alla rete per ridurre la bolletta elettrica.",
  "s7": "Se la tua casa ha bisogno di più energia di quella prodotta dai tuoi pannelli solari, l'energia elettrica verrà utilizzata dalla rete.",
  "s8": "Comportamento del sistema durante le ore di punta",
  "s9": "Riduci le tue bollette elettriche",
  "s10": "In alcune aree, il costo dell'energia elettrica cambia durante il giorno, diventando più costoso durante le ore di punta quando l'energia elettrica è molto richiesta.",
  "s11": "Per evitare di acquistare energia elettrica a un costo maggiore, la tua casa utilizzerà la batteria. Se la tua casa ha bisogno di più energia di quella che la batteria può fornire, l'energia fotovoltaica viene utilizzata dopo e la rete verrà utilizzata per ultima. L'energia fotovoltaica in eccesso verrebbe esportata nella rete.",
  "s12": "Di notte, quando i tuoi pannelli solari non producono nulla, la tua casa utilizza l'energia della batteria fino al raggiungimento del livello di carica di riserva.",
  "s13": "L'energia elettrica viene importata dalla rete quando l'energia fotovoltaica non è disponibile e la casa ha bisogno di più energia di quella che la batteria può fornire.",
  "s14": "Alimenta la tua casa con energia pulita",
  "s15": "La tua casa darà priorità all'utilizzo di energia pulita. Durante il giorno, l'energia fotovoltaica alimenta la casa e poi la batteria. Ogni eccesso viene esportato in rete. Durante la notte, la batteria alimenta la casa.",
  "s16": "L'energia elettrica viene importata dalla rete quando la tua casa ha bisogno di più energia di quella che l'energia fotovoltaica e la batteria possono fornire insieme.",
  "s17": "La batteria è completamente carica",
  "s18": "Comportamento del sistema durante le ore non di punta",
  "s19": "I tuoi pannelli alimenteranno prima la tua batteria e poi la tua casa. Ogni energia supplementare verrà inviata alla rete.",
  "s20": "Di notte o ogni volta che hai bisogno di più energia di quella prodotta dai tuoi pannelli, la tua casa utilizzerà l'energia elettrica dalla rete. La batteria non viene mai utilizzata, tranne durante un'interruzione di corrente.",
  "s21": "Tocca un profilo per passare alla sua scheda.",
  "s22": "Scorri verso sinistra o verso destra per saperne di più.",
  "s23": "Le batterie si scaricano anche dopo le ore di punta.",
  "s24": "L'energia elettrica viene importata dalla rete quando l'energia fotovoltaica non è disponibile e la casa ha bisogno di più energia di quella che la batteria può fornire.",
  "s25": "Comportamento del sistema durante le ore non di punta",
  "s26": "Mantieni l'alimentazione anche in caso di interruzioni",
  "guestUser": "Guest",
  "systemOwner": {
    "savings": {
      "infoPopUpContent": "Questo è il risparmio economico stimato del tuo impianto in base alla produzione di energia solare. Viene calcolato in base alle informazioni sulla tariffa dell'energia elettrica immesse.",
      "noTeriffMsg": "Aggiungi la tariffa elettrica per conoscere i tuoi risparmi",
      "noBillingCyclefMsg": "Add billing cycle to know your savings",
      "getStarted": "Per iniziare",
      "billingCycle": {
        "more": "maggiore rispetto allo scorso ciclo di fatturazione",
        "less": "minore rispetto allo scorso ciclo di fatturazione",
        "same": "Quasi uguale rispetto allo scorso ciclo di fatturazione"
      },
      "calendarMonth": {
        "more": "in più rispetto al mese precedente",
        "less": "meno di questa settimana precedente",
        "same": "Circa lo stesso periodo del mese precedente"
      },
      "day": {
        "more": "più del giorno precedente a quest'ora",
        "less": "meno di questa ora del giorno precedente",
        "same": "Più o meno come a quest'ora del giorno precedente",
        "significantMore": "Significativamente superiore al giorno precedente"
      },
      "week": {
        "more": "in più rispetto a questo periodo della settimana precedente",
        "less": "meno di questa settimana precedente",
        "same": "Circa lo stesso periodo della settimana precedente"
      },
      "year": {
        "more": "in più rispetto a questo periodo dell'anno precedente",
        "less": "meno rispetto a questo periodo dell'anno precedente",
        "same": "Circa lo stesso periodo dell'anno precedente"
      },
      "editElectricity": "MODIFICA TARIFFA DELL'ENERGIA ELETTRICA",
      "viewSavingsBased": "Visualizza i risparmi in base a",
      "calendarMonthTitle": "Mese solare",
      "calendarMonthDesc": "Periodo di tempo dal 1° del mese all'ultimo giorno del mese",
      "noExportRate": "Aggiungi %{exportCTA} per visualizzare i tuoi risparmi totali",
      "exportRate": "Tasso di esportazione"
    }
  },
  "offline": (_offline = {
    "unableToConnectLocally": "Impossibile connettersi localmente",
    "limitedAppFunctionality": "Funzionalità app limitate",
    "needHelpGatewayWifi": "Assistenza con la configurazione della connettività Wi-Fi del Gateway",
    "howToConnectGatewayNetwork": "Come connettersi alla rete del Gateway",
    "connectGatewayToWifi": "Connessione alla rete Wi-Fi del Gateway",
    "connectLocally": "CONNETTI LOCALMENTE",
    "checkNetworkConnection": "Controlla la connessione di rete.",
    "noInternetModalSubText1": "Controlla la connessione di rete. Nel frattempo, puoi visualizzare lo stato corrente del sistema.",
    "noInternetModalSubText2": "Controlla la connessione di rete. Nel frattempo, se nei nelle vicinanze del tuo sistema, puoi connetterti localmente con il Gateway per visualizzare lo stato corrente.",
    "refereshing": "Aggiornamento",
    "pullToReferesh": "Tira in basso per aggiornare",
    "connectionStatus": "Il telefono è ora connesso localmente alla rete del Gateway.",
    "connectivityErrorMsg1": "Assicurati che il tuo telefono e il Gateway si trovino sulla stessa rete",
    "connectivityErrorMsg2": 'Il Gateway è stato connesso di recente alla rete %{wifiName}"',
    "connectivityErrorMsg3": "In alternativa, connetti il tuo telefono alla rete Wi-Fi del Gateway abilitando la modalità AP sul Gateway",
    "connecting": "Il tuo telefono sta cercando di connettersi localmente con il Gateway per visualizzare lo Stato in tempo reale.",
    "viewLiveStatus": "Visualizza stato in tempo reale",
    "pleaseTryAgainInSomeTime": "Riprova tra un po'.",
    "connectedLocally": "Connetti localmente",
    "ssidNotMatchedError": "Non hai collegato il cellulare alla rete del gateway corretto. Connetti il tuo cellulare alla rete di questo gateway: %{envoySSID}",
    "envoySSIDListDialog": {
      "title": "Reti gateway per questo sito",
      "message": "Connetti il tuo cellulare alla rete di uno dei gateway di questo sito. Di seguito sono indicate le reti dei gateway per questo sito:",
      "buttonText": "Ok, ho capito!"
    },
    "multiEnvoySiteSSIDNotMatchedMsg": "Il cellulare non è stato connesso alla rete del gateway corretto. Connettere il cellulare solo alla rete di uno dei gateway di questo sito.",
    "configureButtonMultiEnvoyMsg": "Non hai collegato il cellulare alla rete del gateway corretto. Connetti il tuo cellulare alla rete di uno dei gateway di questo sito. Di seguito sono indicate le reti dei gateway per questo sito:",
    "listOfGatewayNetworks": "Elenco delle reti dei gateway per questo sito",
    "configureWifiMultiEnvoyMsg": "Per configurare il Wi-Fi per il gateway (n. di serie: XXXX) connetti il cellulare alla modalità AP di questo gateway. Sei attualmente connesso alla modalità AP del gateway (n. di serie:XX_%{sNumber}).",
    "deviceOfflineModal": {
      "title": "Come connettersi alla rete Wi-Fi del gateway",
      "okGotIt": "Ok, ho capito",
      "subText": "Please make sure your phone and the gateway are on the same Wi-Fi network to connect locally",
      "gatewayNetwork": "",
      "subText1": "Connettere la rete del gateway localmente se si desidera modificare le impostazioni di sistema.",
      "subText2": 'Assicurarsi che il telefono e il gateway siano sulla stessa rete %{recentlyConnectedWifiMsg}.',
      "wifiSSIDMsg": "(di recente il gateway \xE8 stato connesso alla rete \"%{lastConnection}\")",
      "subText3": "In alternativa, connettere il cellulare alla rete Wi-Fi del gateway abilitando la modalità AP sul gateway",
      "connectToAPGateway": "Connect your phone to gateway's Wi-Fi by enabling AP mode on your gateway."
    },
    "systemStatus": {
      "recentWifiTitle": "Connessioni Wi-Fi recenti dei gateway",
      "gatewayPrefix": "Numero di serie del gateway",
      "gatewayBtn": "Reti gateway Wi-Fi per questo sito",
      "alternetively": "In alternativa, connettere il telefono alla rete Wi-Fi del gateway abilitando la modalità AP sul gateway."
    },
    "isTouPopupMsg": "La modalità Risparmio energetico non può essere attivata perché funziona solo se si ha un Consumo energetico netto (NEM) e se la tariffa dell'elettricità varia con il Tempo di utilizzo (ToU). È possibile impostare o aggiornare la tariffa elettrica solo se il proprio telefono è connesso a Internet.",
    "configWifiToGateway": "CONFIGURARE IL WI-FI PER IL GATEWAY",
    "phoneNtConnectedToGateway": "Il telefono non è collegato al gateway",
    "chooseWifiNetwork": "Scegliere una rete Wi-Fi da utilizzare con il gateway.",
    "learnWifiConfigToGatway": "Imparare a configurare il Wi-Fi per il gateway",
    "step": "Passo",
    "connectPhoneToGateway": "Collegare il telefono al gateway",
    "connectToGatewayNetwork": "Connettersi alla rete del gateway per configurare il Wi-Fi del gateway.",
    "gatewayNtReachable": "Il gateway non è raggiungibile",
    "pleaseEnsure": "Assicurarsi che:",
    "gatewayAPModeOn": "La modalità AP del gateway è attivata",
    "phoneInCloseProximity": "Il telefono è in prossimità del gateway",
    "mobileDataOff": "I dati mobili (dati del cellulare) sono disattivati",
    "searchingGateway": "Ricerca della rete gateway...",
    "devicePluggedIn": "Assicurarsi che il dispositivo sia vicino, collegato e che la modalità AP sia attiva.",
    "connectingTo": "Collegamento a",
    "reflectedInApp": "L'applicazione potrebbe impiegare un paio di minuti per essere visualizzata.",
    "connectionFailed": "Impossibile connettersi alla rete del gateway",
    "connectedToGateway": "Il telefono è collegato al gateway"
  }, _defineProperty(_offline, "connectGatewayToWifi", "Collegare il gateway al Wi-Fi"), _defineProperty(_offline, "chooseNetworkToConnectGateway", "Scegliere una rete Wi-Fi a cui collegare il gateway."), _defineProperty(_offline, "scanNetwork", "Scansione rete Wi-Fi"), _defineProperty(_offline, "enterPassword", "Inserire la password per %"), _defineProperty(_offline, "join", "Unirsi"), _defineProperty(_offline, "gatewayConnected", "Il gateway è collegato a %{selectedWifi} con successo"), _defineProperty(_offline, "disconnectPhoneFromGateway", "A questo punto è possibile scollegare il telefono dalla rete gateway e collegarlo al Wi-Fi/attivare i dati mobili."), _defineProperty(_offline, "failedToConnect", "Connessione fallita a"), _defineProperty(_offline, "gatewayConnectedToPoerSource", "Assicurarsi che il gateway sia collegato a una fonte di alimentazione e che ci si trovi nelle vicinanze del gateway."), _defineProperty(_offline, "routerIsOn", "Assicurarsi che il router Wi-Fi sia acceso e che ci si trovi nelle immediate vicinanze del router Wi-Fi."), _defineProperty(_offline, "unableToDisplayNetworks", "Impossibile visualizzare le reti Wi-Fi"), _defineProperty(_offline, "errorDisplayingNetworks", "Si è verificato un errore nella visualizzazione delle reti Wi-FI a causa di alcuni problemi tecnici. Si prega di riprovare."), _defineProperty(_offline, "errorInConnectingToWifi", "Si è verificato un errore durante la connessione alla rete WiFi. Provare più tardi o connettersi a un'altra rete."), _defineProperty(_offline, "unableToConnect", "Impossibile connettersi"), _defineProperty(_offline, "pairGateway", "Accoppiare il gateway con il telefono tramite bluetooth."), _offline),
  "tutorial": {
    "back": "Indietro",
    "apMode": "Come attivare la modalità AP",
    "step1": "Fase 1 di 3",
    "step2": "Fase 2 di 3",
    "step3": "Fase 3 di 3",
    "powerOnGateway": "Accensione del gateway",
    "title2": "Premere il pulsante della modalità AP",
    "brieflyPressGateway": "Briefly press and release (do not hold) the gateway menu button next the phone icon",
    "getStarted": "Iniziare",
    "next": "prossino passo",
    "prev": "Passo precedente",
    "via": "Via",
    "chooseWifi": "After connecting your phone to the gateway, choose the Wi-Fi you want to connect your gateway to",
    "connectGateway": "Connect to gateway's network to configue Wi-Fi  for your gateway",
    "selectGateway": "Select your gateway type",
    "thatsIt": "Ecco fatto!",
    "step1of2": "Fase 1 di 2",
    "step2of2": "Fase 2 di 2",
    "learnHow": "Learn how",
    "tryConnectingGateway": "Proviamo a collegare il gateway al telefono. Assicuratevi di essere nelle immediate vicinanze del gateway e che i dati del cellulare siano disattivati."
  }
};
module.exports = mobile;